{
  "configs": {
    "screenConfigs": [
      {
        "config": {
          "key": "debt-sale-product-debt-sold-error",
          "name": "Debt Sold Error",
          "category": "error",
          "subcategory": "debt_sale"
        }
      },
      {
        "config": {
          "key": "Deep Link Error",
          "name": "Deep Link Error",
          "category": "error",
          "subcategory": "route_not_found"
        }
      },
      {
        "config": {
          "key": "accountsHomeScreen",
          "name": "My Accounts Home",
          "source_name": "",
          "category": "varo_home",
          "subcategory": ""
        }
      },
      {
        "config": {
          "key": "believe-apply",
          "name": "Varo Believe Offer",
          "source_name": "varo_believe_offer",
          "category": "varo_believe",
          "subcategory": "believe_application"
        }
      },
      {
        "config": {
          "key": "believeQualifyDetails",
          "name": "Varo Believe Qualification Details",
          "category": "varo_believe",
          "subcategory": "believe_application"
        }
      },
      {
        "config": {
          "key": "cardApplication",
          "name": "Legal Agreements",
          "category": "varo_believe",
          "subcategory": "believe_application"
        }
      },
      {
        "config": {
          "key": "/believe/apply/approved",
          "name": "Varo Believe Application Approved",
          "category": "varo_believe",
          "subcategory": "believe_application"
        }
      },
      {
        "config": {
          "key": "approvedBelieveApplication",
          "name": "Varo Believe Application Approved",
          "category": "varo_believe",
          "subcategory": "believe_day_0_application"
        }
      },
      {
        "config": {
          "key": "addWallet",
          "name": "Varo Believe Digital Card",
          "category": "card",
          "subcategory": "believe_application"
        }
      },
      {
        "config": {
          "key": "/believe/apply/moneyIn",
          "name": "Varo Believe Funding",
          "category": "transfer_money",
          "subcategory": "believe_application"
        }
      },
      {
        "config": {
          "key": "/move-money/transfer/transfer-money",
          "name": "Transfer Money Amount",
          "category": "transfer_money"
        }
      },
      {
        "config": {
          "key": "believeDeclined",
          "name": "Varo Believe Application Declined",
          "category": "varo_believe",
          "subcategory": "believe_application"
        }
      },
      {
        "config": {
          "key": "believeReview",
          "name": "Varo Believe Application In Review",
          "category": "varo_believe",
          "subcategory": "believe_application"
        }
      },
      {
        "config": {
          "key": "/accounts/manageAccount",
          "name": "Manage Account",
          "source_name": "manage_account",
          "category": "account",
          "subcategory": "manage"
        }
      },
      {
        "config": {
          "key": "/myvaro",
          "name": "My Varo",
          "category": ""
        }
      },
      {
        "config": {
          "key": "/myvaro/manage-accounts",
          "name": "Manage Account",
          "category": "account_management"
        }
      },
      {
        "config": {
          "key": "/myvaro/settings",
          "name": "Notification Settings",
          "category": "account_management"
        }
      },
      {
        "config": {
          "key": "/myvaro/manage-accounts/account-numbers",
          "name": "Account Numbers",
          "category": "account_management"
        }
      },
      {
        "config": {
          "key": "external-accounts",
          "name": "External Accounts Management",
          "category": ""
        }
      },
      {
        "config": {
          "key": "linked-cards-and-accounts",
          "name": "Linked Cards and Accounts",
          "category": "link_external_debit_card"
        }
      },
      {
        "config": {
          "key": "address-screen",
          "name": "Personal Info - Address",
          "category": "profile_settings"
        }
      },
      {
        "config": {
          "key": "/rewards",
          "name": "Partner Offers Home",
          "category": "rewards"
        }
      },
      {
        "config": {
          "key": "/rewards/categories",
          "name": "Offer Type",
          "category": "rewards"
        }
      },
      {
        "config": {
          "key": "/rewards/cashback/cashbackEarned",
          "name": "Cashback Management",
          "category": "rewards"
        }
      },
      {
        "config": {
          "key": "/rewards/cashback/transactions/[transactionId]",
          "name": "Cashback Transaction Detail",
          "category": "rewards"
        }
      },
      {
        "config": {
          "key": "rewardsError",
          "category": "rewards",
          "name": "Rewards Flow Error Encountered"
        }
      },
      {
        "config": {
          "key": "myActivatedOffersError",
          "category": "rewards",
          "name": "My Activated Offers Flow Error Encountered"
        }
      },
      {
        "config": {
          "key": "signupFlowError",
          "name": "Application Flow Error Encountered",
          "category": "application",
          "subcategory": "checking"
        }
      },
      {
        "config": {
          "key": "referralInvite",
          "name": "Referral Invite",
          "category": "referral"
        }
      },
      {
        "config": {
          "key": "referralLimitMet",
          "name": "Referral Limit Met",
          "category": "referral"
        }
      },
      {
        "config": {
          "key": "/check-deposit",
          "name": "Check Deposit",
          "source_name": "check_deposit",
          "category": "savings",
          "subcategory": "automatic"
        }
      },
      {
        "config": {
          "key": "/believe/how-it-works",
          "name": "Charge Card Intro",
          "source_name": "charge_card_intro",
          "category": "varo_believe",
          "subcategory": "believe_intro"
        }
      },
      {
        "config": {
          "key": "/believe/make-payment",
          "name": "Payment Methods",
          "category": "varo_believe",
          "subcategory": "believe_disbursement"
        }
      },
      {
        "config": {
          "key": "/believe/make-payment/payCheck",
          "name": "Pay By Check",
          "source_name": "pay_by_check",
          "category": "varo_believe",
          "subcategory": "believe_disbursement"
        }
      },
      {
        "config": {
          "key": "/believe/make-payment/payCheck",
          "name": "Pay By Check",
          "source_name": "pay_by_check",
          "category": "varo_believe",
          "subcategory": "believe_disbursement"
        }
      },
      {
        "config": {
          "key": "paymentErrorScreen",
          "name": "Payment Setup Failed",
          "source_name": "payment_setup_failed",
          "category": "varo_believe",
          "subcategory": "believe_disbursement"
        }
      },
      {
        "config": {
          "key": "paymentSuccessScreen",
          "name": "Payment Setup Completed",
          "category": "varo_believe",
          "subcategory": "believe_disbursement"
        }
      },
      {
        "config": {
          "key": "/believe/how-it-works/how-works",
          "name": "How Charge Card Works",
          "source_name": "how_charge_card_works",
          "category": "varo_believe",
          "subcategory": "believe_intro"
        }
      },
      {
        "config": {
          "key": "/believe/how-it-works/how-build-credit",
          "name": "Build Credit",
          "source_name": "how_to_build_credit",
          "category": "varo_believe",
          "subcategory": "believe_intro"
        }
      },
      {
        "config": {
          "key": "/believe/how-it-works/card-benefits",
          "name": "Card Benefits",
          "source_name": "card_benefits",
          "category": "varo_believe",
          "subcategory": "believe_intro"
        }
      },
      {
        "config": {
          "key": "/believe/how-it-works/spending-limit",
          "name": "Spending Limit",
          "source_name": "spending_limit",
          "category": "varo_believe",
          "subcategory": "believe_intro"
        }
      },
      {
        "config": {
          "key": "/believe/how-it-works/supportTopics",
          "name": "Support Topics",
          "source_name": "support_topics",
          "category": "varo_believe",
          "subcategory": "believe_intro"
        }
      },
      {
        "config": {
          "key": "/open-savings",
          "name": "New Savings Account Application",
          "source_name": "savings_account_application",
          "category": "application",
          "subcategory": "savings"
        }
      },
      {
        "config": {
          "key": "/open-savings/open-savings-success",
          "name": "Savings Account Application Approved",
          "source_name": "savings_account_application",
          "category": "application",
          "subcategory": "savings"
        }
      },
      {
        "config": {
          "key": "/open-savings/fund-savings-account",
          "name": "Savings Account Funding",
          "source_name": "savings_account_funding",
          "category": "savings",
          "subcategory": ""
        }
      },
      {
        "config": {
          "key": "/accounts/current-apy",
          "name": "Current APY Qualification Details",
          "source_name": "",
          "category": "savings",
          "subcategory": ""
        }
      },
      {
        "config": {
          "key": "/move-money/check-deposit",
          "name": "Mobile Check Deposit",
          "source_name": "mobile_check_deposit",
          "category": "mobile_check_deposit",
          "subcategory": ""
        }
      },
      {
        "config": {
          "key": "/move-money/check-deposit/amount",
          "name": "Check Deposit Input Amount",
          "source_name": "check_deposit_input_amount",
          "category": "mobile_check_deposit",
          "subcategory": ""
        }
      },
      {
        "config": {
          "key": "/move-money/check-deposit/capture-front",
          "name": "Check Deposit Education Front",
          "source_name": "check_deposit_education_front",
          "category": "mobile_check_deposit",
          "subcategory": ""
        }
      },
      {
        "config": {
          "key": "/move-money/check-deposit/capture-back",
          "name": "Check Deposit Education Back",
          "source_name": "check_deposit_education_back",
          "category": "mobile_check_deposit",
          "subcategory": ""
        }
      },
      {
        "config": {
          "key": "/move-money/check-deposit/review",
          "name": "Check Deposit Confirm",
          "source_name": "check_deposit_confirm",
          "category": "mobile_check_deposit",
          "subcategory": ""
        }
      },
      {
        "config": {
          "key": "checkDepositFlowFailed",
          "name": "Check Deposit Flow Failed",
          "source_name": "check_deposit_flow_failed",
          "category": "mobile_check_deposit",
          "subcategory": ""
        }
      },
      {
        "config": {
          "key": "checkDepositInReview",
          "name": "Check Deposit In Review",
          "source_name": "check_deposit_in_review",
          "category": "mobile_check_deposit",
          "subcategory": ""
        }
      },
      {
        "config": {
          "key": "checkDepositError",
          "name": "Check Deposit Error",
          "source_name": "check_deposit_error",
          "category": "mobile_check_deposit",
          "subcategory": ""
        }
      },
      {
        "config": {
          "key": "checkDepositDeclined",
          "name": "Check Deposit Declined",
          "source_name": "mobile_check_declined",
          "category": "mobile_check_deposit",
          "subcategory": ""
        }
      },
      {
        "config": {
          "key": "/move-money/check-deposit-history",
          "name": "Mobile Deposit History",
          "source_name": "mobile_deposit_history",
          "category": "mobile_check_deposit",
          "subcategory": ""
        }
      },
      {
        "config": {
          "key": "/move-money/check-deposit-history/[id]",
          "name": "Check Deposit Details",
          "source_name": "check_deposit_details",
          "category": "mobile_check_deposit",
          "subcategory": ""
        }
      },
      {
        "config": {
          "key": "v2aNotAvailable",
          "name": "V2A Not Available",
          "category": "v2a"
        }
      },
      {
        "config": {
          "key": "V2ATransferHistory",
          "name": "V2A History",
          "category": "v2a"
        }
      },
      {
        "config": {
          "key": "V2ATransferHistoryDetails",
          "name": "V2A History Details",
          "category": "v2a"
        }
      },
      {
        "config": {
          "key": "rdcReviewCapturedImage",
          "name": "RDC Review Captured Image",
          "category": "mobile_check_deposit",
          "subcategory": ""
        }
      },
      {
        "config": {
          "key": "/help",
          "name": "Login Help",
          "source_name": "",
          "category": "login"
        }
      },
      {
        "config": {
          "key": "reset-password-sms-error",
          "name": "Verification Error Encountered",
          "subcategory": "forgot_password",
          "category": "login",
          "source_name": ""
        }
      },
      {
        "config": {
          "key": "reset-password-email-error",
          "name": "Account Finding Error Encountered",
          "subcategory": "forgot_password",
          "category": "login",
          "source_name": ""
        }
      },
      {
        "config": {
          "key": "/reset-password/email-review",
          "name": "Forgot Password Find Account",
          "subcategory": "forget_password",
          "category": "login",
          "source_name": ""
        }
      },
      {
        "config": {
          "key": "/reset-password/checkemail",
          "name": "Email OTP",
          "subcategory": "forget_password",
          "category": "login",
          "source_name": ""
        }
      },
      {
        "config": {
          "key": "/reset-password/confirm-identity",
          "name": "Step Up Challenge Methods",
          "category": "login",
          "subcategory": "forgot_password",
          "source_name": ""
        }
      },
      {
        "config": {
          "key": "CHECKING",
          "name": "Account Page",
          "category": "checking"
        }
      },
      {
        "config": {
          "key": "SAVINGS",
          "name": "Account Page",
          "category": "savings"
        }
      },
      {
        "config": {
          "key": "CHARGE_CARD",
          "name": "Account Page",
          "category": "varo_believe"
        }
      },
      {
        "config": {
          "key": "ADVANCE",
          "name": "Account Page",
          "category": "ADVANCE"
        }
      },
      {
        "config": {
          "key": "EXTERNAL",
          "name": "Account Page",
          "category": "external"
        }
      },
      {
        "config": {
          "key": "Card Management Create Pin",
          "name": "Card Management Create Pin",
          "category": "card",
          "card_type": ""
        }
      },
      {
        "config": {
          "key": "Card Activated",
          "name": "Card Activated",
          "category": "card",
          "source_name": "",
          "subcategory": "card_activation"
        }
      },
      {
        "config": {
          "key": "PIN Set Completed",
          "name": "PIN Set Completed",
          "category": "card",
          "source_name": "",
          "subcategory": "card_activation"
        }
      },
      {
        "config": {
          "key": "Card Not On File",
          "name": "Card Not On File",
          "category": "card",
          "source_name": "",
          "subcategory": "card_activation"
        }
      },
      {
        "config": {
          "key": "/borrowing-power",
          "name": "Borrowing Power",
          "category": ""
        }
      },
      {
        "config": {
          "key": "supportChatScreen",
          "name": "Support Chat",
          "category": "servicing",
          "source_name": "",
          "subcategory": "chat"
        }
      },
      {
        "config": {
          "key": "/myvaro/help",
          "name": "Help and Support",
          "category": "servicing",
          "source_name": "",
          "subcategory": ""
        }
      },
      {
        "config": {
          "key": "/myvaro/help/call-us",
          "name": "Call Us",
          "category": "servicing",
          "source_name": "",
          "subcategory": ""
        }
      },
      {
        "config": {
          "key": "Card Management",
          "name": "Card Management",
          "category": "card",
          "source_name": "",
          "subcategory": ""
        }
      },
      {
        "config": {
          "key": "welcome",
          "name": "Welcome",
          "subcategory": "onboarding_wizard",
          "category": "onboarding"
        }
      },
      {
        "config": {
          "key": "/varo-line-of-credit/repayment-success/vlocPaidOff",
          "name": "VLOC Paid Off",
          "category": "vloc",
          "subcategory": "vloc_repayment"
        }
      },
      {
        "config": {
          "key": "vlocOffer",
          "name": "VLOC Offer",
          "subcategory": "vloc_application",
          "category": "vloc"
        }
      },
      {
        "config": {
          "key": "vlocEducational",
          "name": "VLOC Educational",
          "category": "vloc"
        }
      },
      {
        "config": {
          "key": "/varo-line-of-credit/manage-account",
          "name": "Manage Account",
          "category": "vloc"
        }
      },
      {
        "config": {
          "key": "/varo-line-of-credit/eligibility",
          "name": "VLOC Qualification Details",
          "category": "vloc",
          "subcategory": "vloc_application"
        }
      },
      {
        "config": {
          "key": "/varo-line-of-credit/not-eligible",
          "name": "VLOC Qualification Details",
          "category": "vloc",
          "subcategory": "vloc_application"
        }
      },
      {
        "config": {
          "key": "vlocCreditCheck",
          "name": "Credit Check",
          "category": "vloc",
          "subcategory": "vloc_application"
        }
      },
      {
        "config": {
          "key": "/varo-line-of-credit/confirm-payment",
          "name": "VLOC Repayment Submission",
          "category": "vloc",
          "subcategory": "vloc_repayment"
        }
      },
      {
        "config": {
          "key": "/varo-line-of-credit/not-qualified/withBelieve",
          "name": "VLOC Not Qualified With Believe",
          "category": "vloc",
          "subcategory": "vloc_application"
        }
      },
      {
        "config": {
          "key": "/varo-line-of-credit/not-qualified/withoutBelieve",
          "name": "VLOC Not Qualified Without Believe",
          "category": "vloc",
          "subcategory": "vloc_application"
        }
      },
      {
        "config": {
          "key": "/varo-line-of-credit/active-details-screen/errorScreenLoad",
          "name": "VLOC Repayment Flow Error Encountered",
          "category": "vloc",
          "subcategory": "vloc_repayment"
        }
      },
      {
        "config": {
          "key": "/varo-line-of-credit/LineOfCreditErrorScreenComponent-applyEmploymentScreen",
          "name": "VLOC Application Flow Error Encountered",
          "category": "vloc",
          "subcategory": "vloc_application"
        }
      },
      {
        "config": {
          "key": "/varo-line-of-credit/LineOfCreditErrorScreenComponent-autoPayScreen",
          "name": "VLOC Application Flow Error Encountered",
          "category": "vloc",
          "subcategory": "vloc_repayment"
        }
      },
      {
        "config": {
          "key": "/varo-line-of-credit/LineOfCreditErrorScreenComponent-confirmPaymentScreen",
          "name": "VLOC Application Flow Error Encountered",
          "category": "vloc",
          "subcategory": "vloc_repayment"
        }
      },
      {
        "config": {
          "key": "/varo-line-of-credit/LineOfCreditErrorScreenComponent-eligibilityScreen",
          "name": "VLOC Application Flow Error Encountered",
          "category": "vloc",
          "subcategory": "vloc_application"
        }
      },
      {
        "config": {
          "key": "/varo-line-of-credit/LineOfCreditErrorScreenComponent-notEligibleScreen",
          "name": "VLOC Application Flow Error Encountered",
          "category": "vloc",
          "subcategory": "vloc_application"
        }
      },
      {
        "config": {
          "key": "/varo-line-of-credit/LineOfCreditErrorScreenComponent-vlocHistoryDetails",
          "name": "Manage Account VLOC Flow Error Encountered",
          "category": "vloc",
          "subcategory": ""
        }
      },
      {
        "config": {
          "key": "/varo-line-of-credit/LineOfCreditErrorScreenComponent-vlocTransactionHistory",
          "name": "Manage Account VLOC Flow Error Encountered",
          "category": "vloc",
          "subcategory": ""
        }
      },
      {
        "config": {
          "key": "/varo-line-of-credit/LineOfCreditErrorScreenComponent-lineOfCreditEntryPoint",
          "name": "VLOC Application Flow Error Encountered",
          "category": "vloc",
          "subcategory": "vloc_application"
        }
      },
      {
        "config": {
          "key": "/varo-line-of-credit/LineOfCreditErrorScreenComponent-manageAccountScreen",
          "name": "Manage Account VLOC Flow Error Encountered",
          "category": "vloc",
          "subcategory": "vloc_application",
          "source_name": "manage_account_vloc_error_encountered"
        }
      },
      {
        "config": {
          "key": "/varo-line-of-credit/LineOfCreditErrorScreenComponent-VLOCpaymentDetailsScreen",
          "name": "VLOC Application Flow Error Encountered",
          "category": "vloc",
          "subcategory": "vloc_repayment"
        }
      },
      {
        "config": {
          "key": "/varo-line-of-credit/LineOfCreditErrorScreenComponent-userInfoScreen",
          "name": "VLOC Application Flow Error Encountered",
          "category": "vloc",
          "subcategory": "vloc_application"
        }
      },
      {
        "config": {
          "key": "/varo-line-of-credit/LineOfCreditErrorScreenComponent-reviewScreen",
          "name": "VLOC Application Flow Error Encountered",
          "category": "vloc",
          "subcategory": "taking_out_vloc"
        }
      },
      {
        "config": {
          "key": "/varo-line-of-credit/reviewScreen/errorScreen-<source>",
          "name": "VLOC Application Flow Error Encountered",
          "category": "vloc",
          "subcategory": "taking_out_vloc"
        }
      },
      {
        "config": {
          "key": "/varo-line-of-credit/repayment-success/vlocRepaymentSuccessful",
          "name": "VLOC Repayment Successful",
          "category": "vloc",
          "subcategory": "vloc_repayment"
        }
      },
      {
        "config": {
          "key": "moneyInTheBankScreen",
          "name": "VLOC Executed",
          "category": "vloc",
          "subcategory": ""
        }
      },
      {
        "config": {
          "key": "/varo-line-of-credit/review-custom",
          "name": "VLOC Disbursement Confirmation",
          "category": "vloc"
        }
      },
      {
        "config": {
          "key": "/varo-line-of-credit/history",
          "name": "VLOC Transaction History",
          "category": "vloc"
        }
      },
      {
        "config": {
          "key": "/varo-line-of-credit/take-out",
          "name": "VLOC Tier Selection",
          "category": "vloc",
          "subcategory": "taking_out_vloc"
        }
      },
      {
        "config": {
          "key": "/varo-line-of-credit/creditFrozen",
          "name": "Credit Report Frozen",
          "category": "vloc",
          "subcategory": "vloc_application"
        }
      },
      {
        "config": {
          "key": "/varo-line-of-credit/history-details",
          "name": "VLOC History Details",
          "category": "vloc"
        }
      },
      {
        "config": {
          "key": "/varo-line-of-credit/hardPullDecline",
          "name": "VLOC Application Declined",
          "category": "vloc",
          "subcategory": "vloc_application"
        }
      },
      {
        "config": {
          "key": "/varo-line-of-credit/apply-employment",
          "name": "VLOC Employment Income Form",
          "category": "vloc",
          "subcategory": "vloc_application"
        }
      },
      {
        "config": {
          "key": "/varo-line-of-credit/transaction-details-custom",
          "name": "VLOC Transaction Details",
          "category": "vloc"
        }
      },
      {
        "config": {
          "key": "/varo-line-of-credit/vloc-is-on-its-way",
          "name": "VLOC Not Executed",
          "category": "vloc"
        }
      },
      {
        "config": {
          "key": "/varo-line-of-credit/user-info",
          "name": "VLOC User Info Form",
          "category": "vloc",
          "subcategory": "vloc_application"
        }
      },
      {
        "config": {
          "key": "/varo-line-of-credit/prequal-approved",
          "name": "VLOC Tier Selection",
          "category": "vloc",
          "subcategory": "vloc_application"
        }
      },
      {
        "config": {
          "key": "/varo-line-of-credit/hard-pull-approved",
          "name": "VLOC Application Approved",
          "category": "vloc",
          "subcategory": "vloc_application"
        }
      },
      {
        "config": {
          "key": "/varo-line-of-credit/lost-eligibility",
          "name": "VLOC Lost Eligibility",
          "category": "vloc",
          "subcategory": "vloc_application"
        }
      },
      {
        "config": {
          "key": "/varo-line-of-credit/active-details",
          "name": "VLOC Home Page",
          "category": "vloc"
        }
      },
      {
        "config": {
          "key": "/varo-line-of-credit/payment-details",
          "name": "VLOC Repayment Amount",
          "category": "vloc",
          "subcategory": "vloc_repayment"
        }
      },
      {
        "config": {
          "key": "/varo-line-of-credit/vloc-payment-schedule-custom",
          "name": "VLOC Payment Schedule",
          "category": "vloc"
        }
      },
      {
        "config": {
          "key": "editAddress",
          "name": "Edit Home Address",
          "category": "vloc",
          "subcategory": "vloc_application"
        }
      },
      {
        "config": {
          "key": "/varo-line-of-credit/autopay-custom",
          "name": "VLOC Auto Pay",
          "category": "vloc"
        }
      },
      {
        "config": {
          "key": "/login",
          "name": "Login",
          "category": "login",
          "source_name": ""
        }
      },
      {
        "config": {
          "key": "believePaymentError",
          "category": "varo_believe",
          "subcategory": "believe_disbursement",
          "name": "Payment Setup Failed"
        }
      },
      {
        "config": {
          "key": "transactionDetails",
          "name": "My Accounts Transaction Details",
          "category": "",
          "source_name": "Transaction_details"
        }
      },
      {
        "config": {
          "key": "manageAccountsPage",
          "name": "Manage Account",
          "category": ""
        }
      },
      {
        "config": {
          "key": "advancePageKey",
          "name": "Account Page",
          "category": "varo_advance"
        }
      },
      {
        "config": {
          "key": "/accounts/savings-tracker",
          "name": "Savings High APY Tracker",
          "category": "savings",
          "subcategory": "savings_high_apy",
          "source_name": "account_page"
        }
      },
      {
        "config": {
          "key": "/signup",
          "name": "Signup Home",
          "category": "application",
          "subcategory": "checking",
          "source_name": ""
        }
      },
      {
        "config": {
          "key": "/signup/verify-email",
          "name": "Email Verification",
          "category": "login",
          "source_name": ""
        }
      },
      {
        "config": {
          "key": "/signup/verify-email-code",
          "name": "Email Code Verification",
          "category": "login",
          "source_name": ""
        }
      },
      {
        "config": {
          "key": "/signup/verify-device",
          "name": "Device Verification",
          "category": "login",
          "source_name": ""
        }
      },
      {
        "config": {
          "key": "signup-verify-sms",
          "name": "Phone Number Verification",
          "category": "application",
          "subcategory": "checking",
          "source_name": ""
        }
      },
      {
        "config": {
          "key": "login-verify-sms",
          "name": "Phone Number Verification",
          "category": "login",
          "source_name": ""
        }
      },
      {
        "config": {
          "key": "/login/verify-email-code",
          "name": "Email Verification",
          "category": "login",
          "source_name": ""
        }
      },
      {
        "config": {
          "key": "/login/verify-identity",
          "name": "Identity Verification",
          "category": "login",
          "subcategory": "magic_link"
        }
      },
      {
        "config": {
          "key": "V2aEducationScreen",
          "name": "Allow Access System Dialog",
          "category": "v2a",
          "subcategory": "transfer_money_v2a_sender"
        }
      },
      {
        "config": {
          "key": "V2aSearchRecipient",
          "name": "V2A Search Recipient",
          "category": "v2a",
          "subcategory": "transfer_money_v2a_sender"
        }
      },
      {
        "config": {
          "key": "V2aMultipleContactsForm",
          "name": "Multiple Contacts Form",
          "category": "v2a",
          "subcategory": "transfer_money_v2a_sender"
        }
      },
      {
        "config": {
          "key": "V2aContactSearchError",
          "name": "V2A Contact Search Error Encountered",
          "category": "v2a",
          "subcategory": "transfer_money_v2a_sender"
        }
      },
      {
        "config": {
          "key": "/signup/personal-information",
          "name": "Personal Info - Name",
          "category": "application",
          "subcategory": "checking",
          "source_name": ""
        }
      },
      {
        "config": {
          "key": "/signup/address-collection",
          "name": "Personal Info - Address",
          "category": "application",
          "subcategory": "checking",
          "source_name": ""
        }
      },
      {
        "config": {
          "key": "/signup/dob",
          "name": "Personal Info - DOB",
          "category": "application",
          "subcategory": "checking",
          "source_name": ""
        }
      },
      {
        "config": {
          "key": "/signup/employment",
          "name": "Personal Info - Employment",
          "category": "application",
          "subcategory": "checking",
          "source_name": ""
        }
      },
      {
        "config": {
          "key": "/signup/citizenship",
          "name": "Personal Info - Citizenship",
          "category": "application",
          "subcategory": "checking",
          "source_name": ""
        }
      },
      {
        "config": {
          "key": "/signup/verify-ssn",
          "name": "SSN Verification",
          "category": "application",
          "subcategory": "checking",
          "source_name": ""
        }
      },
      {
        "config": {
          "key": "/signup/legal",
          "name": "Legal Agreements",
          "subcategory": "checking",
          "category": "application",
          "source_name": ""
        }
      },
      {
        "config": {
          "key": "/signup/edd-questions",
          "name": "Banking Survey",
          "source_name": "",
          "category": "application",
          "subcategory": "checking"
        }
      },
      {
        "config": {
          "key": "socureFlowScreen",
          "name": "Application In Review",
          "subcategory": "checking",
          "category": "application",
          "source_name": ""
        }
      },
      {
        "config": {
          "key": "applicationAutoApproved",
          "name": "Application Auto Approved",
          "subcategory": "checking",
          "category": "application",
          "source_name": ""
        }
      },
      {
        "config": {
          "key": "mobileAppDownLoad",
          "name": "Mobile App Download",
          "category": "onboarding",
          "subcategory": "onboarding_wizard",
          "source_name": ""
        }
      },
      {
        "config": {
          "key": "applicationDeclined",
          "name": "Application Declined",
          "subcategory": "checking",
          "category": "application",
          "source_name": ""
        }
      },
      {
        "config": {
          "key": "applicationInReview",
          "name": "Application In Review",
          "subcategory": "checking",
          "category": "application",
          "source_name": ""
        }
      },
      {
        "config": {
          "key": "/signup/socure/application-in-review",
          "name": "Application In Review",
          "subcategory": "checking",
          "category": "application",
          "source_name": ""
        }
      },
      {
        "config": {
          "key": "/signup/socure/idv-methods",
          "name": "IDV Methods",
          "category": ""
        }
      },
      {
        "config": {
          "key": "/reset-password/enter-otp",
          "name": "SMS OTP",
          "category": "login",
          "subcategory": "forgot_password",
          "source_name": ""
        }
      },
      {
        "config": {
          "key": "/reset-password/set-password",
          "name": "Create New Password",
          "category": "login",
          "subcategory": "forgot_password",
          "source_name": ""
        }
      },
      {
        "config": {
          "key": "/reset-password/success",
          "name": "Reset Password Completed",
          "category": "login",
          "subcategory": "forgot_password",
          "source_name": ""
        }
      },
      {
        "config": {
          "key": "/reset-password/find-account",
          "name": "Forgot Password Find Account",
          "category": "login",
          "subcategory": "forgot_password",
          "source_name": ""
        }
      },
      {
        "config": {
          "key": "/myvaro/statements-and-forms/account-statements/[id]/[year]",
          "name": "Statements and Documents",
          "category": ""
        }
      },
      {
        "config": {
          "key": "/suspicious-transaction",
          "name": "Suspicious Transaction Review",
          "category": ""
        }
      },
      {
        "config": {
          "key": "moveMoneyScreen",
          "name": "Move Money",
          "category": "transfer_money",
          "source_name": "home_page"
        }
      },
      {
        "config": {
          "key": "move-money/v2a/transfer",
          "name": "V2A Enter Amount",
          "category": "v2a",
          "subcategory": "transfer_money_v2a_sender"
        }
      },
      {
        "config": {
          "key": "card_replaced",
          "name": "Your new card is on the way",
          "category": "card",
          "subcategory": "card_replacement"
        }
      },
      {
        "config": {
          "key": "moveMoneyOptions",
          "name": "Move Money Options",
          "category": "transfer_money",
          "source_name": "move_money_page"
        }
      },
      {
        "config": {
          "key": "transaction_recognized",
          "name": "Try Your Transaction Again",
          "category": ""
        }
      },
      {
        "config": {
          "key": "card_replacement_error",
          "name": "Card Replacement Flow Error Encountered",
          "category": "card",
          "subcategory": "card_replacement"
        }
      },
      {
        "config": {
          "key": "/myvaro/personal-details",
          "name": "Profile Settings",
          "category": "profile_settings"
        }
      },
      {
        "config": {
          "key": "/myvaro/personal-details/change-email",
          "name": "Change Email Input New Email",
          "category": "profile_settings"
        }
      },
      {
        "config": {
          "key": "/myvaro/personal-details/change-password",
          "name": "Change Password Verify Current Password",
          "category": "profile_settings"
        }
      },
      {
        "config": {
          "key": "/myvaro/personal-details/change-address/address-verification",
          "name": "Home Address Confirmation",
          "category": "profile_settings"
        }
      },
      {
        "config": {
          "key": "/myvaro/personal-details/change-address",
          "name": "Change Home Address",
          "category": "profile_settings"
        }
      },
      {
        "config": {
          "key": "/myvaro/personal-details/change-mailing-address",
          "name": "Change Mailing Address",
          "category": "profile_settings"
        }
      },
      {
        "config": {
          "key": "/myvaro/personal-details/change-email/confirm-email",
          "name": "Change Email Verify Link",
          "category": "profile_settings"
        }
      },
      {
        "config": {
          "key": "/myvaro/personal-details/change-password/confirm-password",
          "name": "Change Password Create New Password",
          "category": "profile_settings"
        }
      },
      {
        "config": {
          "key": "/myvaro/personal-details/change-email/enter-code",
          "name": "SMS OTP",
          "category": "profile_settings"
        }
      },
      {
        "config": {
          "key": "/myvaro/personal-details/change-password/enter-code",
          "name": "Phone Number Verification",
          "category": "profile_settings"
        }
      },
      {
        "config": {
          "key": "/myvaro/external-accounts/[id]",
          "name": "External Accounts Management Details",
          "category": ""
        }
      },
      {
        "config": {
          "key": "external-debit-card-details",
          "name": "Linked Card",
          "category": "link_external_debit_card"
        }
      },
      {
        "config": {
          "key": "external-card-update-expiry-date",
          "name": "Card Expiration Date",
          "category": "link_external_debit_card"
        }
      },
      {
        "config": {
          "key": "accountNotLinked",
          "name": "Account Not Linked",
          "source_name": "",
          "category": "",
          "subcategory": ""
        }
      },
      {
        "config": {
          "key": "/credit/about-credit-score",
          "name": "Credit Score Details",
          "category": ""
        }
      },
      {
        "config": {
          "key": "creditScoreError",
          "name": "Credit Score Monitoring Consent Error Encountered",
          "source_name": "Credit Score Monitoring Consent Error Encountered",
          "category": ""
        }
      },
      {
        "config": {
          "key": "/move-money/direct-deposit",
          "name": "Direct Deposit Info",
          "category": "direct_deposit"
        }
      },
      {
        "config": {
          "key": "/move-money/direct-deposit/direct-deposit-form",
          "name": "Direct Deposit View PDF",
          "category": "direct_deposit"
        }
      },
      {
        "config": {
          "key": "ddManagementError",
          "name": "Direct Deposit Management Error Encountered",
          "category": "direct_deposit"
        }
      },
      {
        "config": {
          "key": "ddManagementFallbackError",
          "name": "Direct Deposit Error Management",
          "category": "direct_deposit"
        }
      },
      {
        "config": {
          "key": "/believe/move-your-pay",
          "name": "Move Your Pay",
          "category": "varo_believe",
          "subcategory": "move_your_pay"
        }
      },
      {
        "config": {
          "key": "/move-money/find-atm",
          "name": "Find ATM",
          "category": ""
        }
      },
      {
        "config": {
          "key": "transferSuccess",
          "name": "Transfer Money Successful",
          "category": "transfer_money",
          "source_name": "transfer_money_success"
        }
      },
      {
        "config": {
          "key": "/move-money/zelle",
          "name": "Zelle Initiated",
          "category": "zelle",
          "source_name": "move_money_page"
        }
      },
      {
        "config": {
          "key": "zelleIneligible",
          "name": "Zelle Failed",
          "category": "zelle"
        }
      },
      {
        "config": {
          "key": "zelleScamInfo",
          "name": "Screen Viewed",
          "category": "zelle",
          "subcategory": "scam_warning"
        }
      },
      {
        "config": {
          "key": "zelleMulingWarning",
          "name": "Screen Viewed",
          "category": "zelle",
          "subcategory": "mule_warning"
        }
      },
      {
        "config": {
          "key": "zelleErrorEncountered",
          "name": "Zelle Error Encountered",
          "category": "zelle"
        }
      },
      {
        "config": {
          "key": "zelleError",
          "name": "Zelle Error Encountered",
          "category": "zelle"
        }
      },
      {
        "config": {
          "key": "zelleSdkLaunchError",
          "name": "Zelle Error Encountered",
          "category": "zelle"
        }
      },
      {
        "config": {
          "key": "/move-money/zelleError",
          "name": "Zelle Error Encountered",
          "category": "zelle"
        }
      },
      {
        "config": {
          "key": "/move-money/deposit-cash",
          "name": "Deposit Cash Info",
          "category": "",
          "subcategory": ""
        }
      },
      {
        "config": {
          "key": "/move-money/transfer/confirm-transfer",
          "name": "Transfer Money Confirm",
          "category": "transfer_money"
        }
      },
      {
        "config": {
          "key": "/move-money/debit-card-funding",
          "name": "Debit Card Funding",
          "category": "dcf"
        }
      },
      {
        "config": {
          "key": "believeDisclosure",
          "name": "Varo Believe Disclosures",
          "category": "varo_believe",
          "subcategory": "believe_application"
        }
      },
      {
        "config": {
          "key": "dcfUnavailable",
          "name": "Debit Card Funding Unavailable",
          "category": "dcf"
        }
      },
      {
        "config": {
          "key": "dcfErrorEncountered",
          "name": "Debit Card Funding Error Encountered",
          "category": "dcf"
        }
      },
      {
        "config": {
          "key": "newAddressForm",
          "name": "New Address Form Viewed",
          "category": "dcf",
          "source_name": "debit_card_funding"
        }
      },
      {
        "config": {
          "key": "/move-money/debit-card-funding/debit-card-funding-success",
          "name": "Debit Card Funding Completed",
          "category": "dcf"
        }
      },
      {
        "config": {
          "key": "/move-money/transfer/transfer-history",
          "name": "Transfer Money History",
          "category": "transfer_money",
          "subcategory": ""
        }
      },
      {
        "config": {
          "key": "/move-money/transfer/transfer-details",
          "name": "Transfer Money History Details",
          "category": "transfer_money",
          "subcategory": ""
        }
      },
      {
        "config": {
          "key": "/move-money/transfer/transfer-money",
          "name": "Transfer Money Amount",
          "category": "transfer_money"
        }
      },
      {
        "config": {
          "key": "/move-money/transfer/confirm-transfer",
          "name": "Transfer Money Confirm",
          "category": "transfer_money"
        }
      },
      {
        "config": {
          "key": "/move-money/transfer/transfer-success",
          "name": "Transfer Money Success",
          "category": "transfer_money"
        }
      },
      {
        "config": {
          "key": "/move-money/transfer/transfer-error",
          "name": "Transfer Money Flow Error Encountered",
          "category": "transfer_money"
        }
      },
      {
        "config": {
          "key": "instantTransferSuccess",
          "name": "Transfer Money Success",
          "category": "transfer_money"
        }
      },
      {
        "config": {
          "key": "instantTransferAmount",
          "name": "Transfer Money Amount",
          "category": "transfer_money"
        }
      },
      {
        "config": {
          "key": "instantTransferConfirm",
          "name": "Transfer Money Confirm",
          "category": "transfer_money"
        }
      },
      {
        "config": {
          "key": "instantTransferConfirmLeaveDialog",
          "name": "Screen Viewed",
          "source_name": "transfer_money_confirm",
          "category": "transfer_money"
        }
      },
      {
        "config": {
          "key": "instantTransferProcessing",
          "name": "Transfer Money Processing",
          "source_name": "transfer_money_processing",
          "category": "transfer_money"
        }
      },
      {
        "config": {
          "key": "instantTransferFlowError",
          "name": "Transfer Money Flow Error Encountered",
          "category": "transfer_money"
        }
      },
      {
        "config": {
          "key": "paymentHistory",
          "name": "Payment History",
          "category": "varo_believe",
          "subcategory": "believe_disbursement"
        }
      },
      {
        "config": {
          "key": "transferSuccessScreen",
          "name": "V2A Submission Successful",
          "category": "v2a",
          "subcategory": "transfer_money_v2a_sender"
        }
      },
      {
        "config": {
          "key": "promoScreen",
          "name": "V2A Heads Up",
          "category": "v2a",
          "subcategory": "transfer_money_v2a_sender"
        }
      },
      {
        "config": {
          "key": "transferUnsuccessfulScreen",
          "name": "V2A Submission Unsuccessful",
          "category": "v2a",
          "subcategory": "transfer_money_v2a_sender"
        }
      },
      {
        "config": {
          "key": "v2aReceiverLandingPage",
          "name": "V2A Receiver Landing Page",
          "category": "v2a",
          "subcategory": "transfer_money_v2a_receiver"
        }
      },
      {
        "config": {
          "key": "/payments-detail/v2aReceiverPaymentDetails",
          "name": "V2A Receiver Form",
          "category": "v2a",
          "subcategory": "transfer_money_v2a_receiver"
        }
      },
      {
        "config": {
          "key": "v2aReceiverFlowError",
          "name": "V2A Receiver Flow Error Encountered",
          "category": "v2a",
          "subcategory": "transfer_money_v2a_receiver"
        }
      },
      {
        "config": {
          "key": "/payments-confirmation/v2aReceiverPaymentSuccess",
          "name": "V2A Transfer Successful",
          "category": "v2a",
          "subcategory": "transfer_money_v2a_receiver"
        }
      },
      {
        "config": {
          "key": "/payments-detail/v2aReceiverEmailOtpPage",
          "name": "Email Verification",
          "category": "v2a",
          "subcategory": "transfer_money_v2a_receiver"
        }
      },
      {
        "config": {
          "key": "/payments-detail/v2aReceiverPhoneOtpPage",
          "name": "Phone Number Verification",
          "category": "v2a",
          "subcategory": "transfer_money_v2a_receiver"
        }
      },
      {
        "config": {
          "key": "Credit Score Access",
          "name": "Credit Score Access",
          "category": ""
        }
      },
      {
        "config": {
          "key": "Automatic Savings Manage",
          "name": "Automatic Savings Manage",
          "category": "savings"
        }
      },
      {
        "config": {
          "key": "Automatic Savings SYP Input",
          "name": "Automatic Savings SYP Input",
          "category": "savings"
        }
      },
      {
        "config": {
          "key": "Last Four Digits",
          "name": "Activate Card Last Four Digits",
          "category": "card",
          "subcategory": "card_activation"
        }
      },
      {
        "config": {
          "key": "Expiry Date",
          "name": "Activate Card Expiry Date",
          "category": "card",
          "subcategory": "card_activation"
        }
      },
      {
        "config": {
          "key": "SuspiciousCardTransactionBanner",
          "name": "Alert Banner Shown",
          "source_name": "account_page",
          "category": "account_page"
        }
      },
      {
        "config": {
          "key": "WalletProvisioningSuccessScreen",
          "name": "Wallet Provisioning Successful",
          "source_name": "wallet_provisioning_successful",
          "category": ""
        }
      },
      {
        "config": {
          "key": "Tax Filing Intro",
          "name": "Tax Filing Intro",
          "category": "tax_filing"
        }
      },
      {
        "config": {
          "key": "Tax Filing Session Started",
          "name": "Tax Filing Session Started",
          "category": "tax_filing",
          "source_name": "tax_filing_intro_page"
        }
      },
      {
        "config": {
          "key": "P2P Funding Onboarding",
          "name": "P2P Funding",
          "category": "onboarding",
          "subcategory": "onboarding_wizard"
        }
      },
      {
        "config": {
          "key": "P2P Funding Home",
          "name": "P2P Funding",
          "category": "transfer_money",
          "source_name": "onboarding_cards"
        }
      },
      {
        "config": {
          "key": "pinSetFailed",
          "name": "PIN Set Failed",
          "category": "card",
          "source_name": "pin_set_failed",
          "card_type": ""
        }
      },
      {
        "config": {
          "key": "verificationFailed",
          "name": "Verification Failed",
          "source_name": "sms_otp_page",
          "category": "profile_settings"
        }
      },
      {
        "config": {
          "key": "confirm-your-address",
          "name": "Home Address Confirmation",
          "category": "profile_settings",
          "subcategory": "mastercard"
        }
      },
      {
        "config": {
          "key": "editFromConfirmAddress",
          "name": "Edit Home Address",
          "category": "profile_settings",
          "subcategory": "mastercard"
        }
      },
      {
        "config": {
          "key": "confirm-address-error",
          "name": "Confirm Address Error Encountered",
          "category": "profile_settings",
          "subcategory": "mastercard"
        }
      },
      {
        "config": {
          "key": "add-debit-card",
          "name": "Add Debit Card",
          "category": "link_external_debit_card",
          "subcategory": "va_day_0"
        }
      },
      {
        "config": {
          "key": "debit-card-added-success",
          "name": "Debit Card Successfully Added",
          "category": "link_external_debit_card",
          "subcategory": "va_day_0"
        }
      },
      {
        "config": {
          "key": "add-debit-card-error",
          "name": "Add Debit Card Error Encountered",
          "category": "link_external_debit_card",
          "subcategory": "va_day_0"
        }
      },
      {
        "config": {
          "key": "update-card-expiration-date-error",
          "name": "Update Card Expiration Date Error Encountered",
          "source_name": "linked_card_expiration_date",
          "category": "link_external_debit_card"
        }
      },
      {
        "config": {
          "key": "mobile-app-download",
          "name": "Mobile App Download",
          "category": "v2a",
          "subcategory": "transfer_money_v2a_sender"
        }
      },
      {
        "config": {
          "key": "cashback-nearby",
          "name": "Cashback Nearby",
          "category": "rewards"
        }
      },
      {
        "config": {
          "key": "closed-account-reactivation",
          "name": "Closed Account Reactivation",
          "category": "application",
          "subcategory": "checking"
        }
      },
      {
        "config": {
          "key": "verify-sms-reactivation",
          "name": "Phone Number Verification",
          "category": "application",
          "subcategory": "checking"
        }
      },
      {
        "config": {
          "key": "contact-support-reactivation",
          "name": "Phone Number Verification",
          "category": "servicing"
        }
      },
      {
        "config": {
          "key": "verify-ssn-reactivation",
          "name": "SSN Verification",
          "category": "application",
          "subcategory": "checking"
        }
      },
      {
        "config": {
          "key": "review-info-reactivation",
          "name": "Review Information",
          "category": "application",
          "subcategory": "checking"
        }
      },
      {
        "config": {
          "key": "verify-ssn-error-reactivation",
          "name": "Info Not Verified",
          "category": "application",
          "subcategory": "checking"
        }
      },
      {
        "config": {
          "key": "reactivation-error",
          "name": "Reactivation Error Encountered",
          "category": "application",
          "subcategory": "checking"
        }
      },
      {
        "config": {
          "key": "legal-agreements-reactivation",
          "name": "Legal Agreements",
          "category": "application",
          "subcategory": "checking"
        }
      },
      {
        "config": {
          "key": "/myvaro/personal-details/change-phone",
          "name": "Change Phone Number",
          "category": "profile_settings"
        }
      },
      {
        "config": {
          "key": "phone-change-otp",
          "name": "SMS OTP",
          "category": "profile_settings"
        }
      },
      {
        "config": {
          "key": "/myvaro/personal-details/change-phone/decline",
          "name": "Phone Number Change Declined",
          "source_name": "profile_settings",
          "category": "profile_settings"
        }
      },
      {
        "config": {
          "key": "/confirm-your-address",
          "name": "Home Address Confirmation",
          "category": "profile_settings",
          "subcategory": "card_expiration"
        }
      },
      {
        "config": {
          "key": "edit-home-address",
          "name": "Edit Home Address",
          "category": "profile_settings",
          "subcategory": "card_expiration"
        }
      },
      {
        "config": {
          "key": "home-address-updated-success",
          "name": "Address Updated",
          "category": "profile_settings",
          "subcategory": "card_expiration"
        }
      },
      {
        "config": {
          "key": "/onboarding/funding",
          "name": "Funding Method",
          "category": "onboarding",
          "subcategory": "intent_based_onboarding"
        }
      },
      {
        "config": {
          "key": "/onboarding/funding/screenViewed",
          "name": "Screen Viewed",
          "category": "onboarding",
          "subcategory": "onboarding_wizard",
          "source_name": "funding_screen_v2"
        }
      },
      {
        "config": {
          "key": "/onboarding/get-paid-early",
          "category": "onboarding",
          "name": "Set Up Direct Deposit",
          "subcategory": "intent_based_onboarding"
        }
      },
      {
        "config": {
          "key": "/onboarding",
          "name": "Primary Goal Onboarding Survey",
          "category": "onboarding",
          "subcategory": "intent_based_onboarding"
        }
      },
      {
        "config": {
          "key": "/onboarding/wallet-provisioning",
          "name": "Wallet Provisioning",
          "category": "onboarding",
          "subcategory": "intent_based_onboarding"
        }
      },
      {
        "config": {
          "key": "tabapay-transfer-screen",
          "name": "Transfer Money Amount",
          "category": "dcf",
          "flow_name": "dcf"
        }
      },
      {
        "config": {
          "key": "tabapay-transfer-success",
          "name": "Debit Card Funding Completed",
          "category": "dcf",
          "flow_name": "dcf"
        }
      },
      {
        "config": {
          "key": "verify-card-screen",
          "name": "Verify Card",
          "category": "link_external_debit_card"
        }
      },
      {
        "config": {
          "key": "/welcome",
          "name": "Welcome Screen",
          "category": "welcome_page"
        }
      },
      {
        "config": {
          "key": "cashbackRewardsErrorEncountered",
          "name": "Cashback Rewards Error Encountered",
          "subcategory": "self_funded",
          "category": "rewards"
        }
      },
      {
        "config": {
          "key": "/bill-switch/intro/cardFrozenBottomSheet",
          "name": "Card Frozen Bottom Sheet Presented",
          "category": "bill_switch",
          "source_name": "home_control"
        }
      },
      {
        "config": {
          "key": "/bill-switch/believe/cardFrozenBottomSheet",
          "name": "Card Frozen Bottom Sheet Presented",
          "category": "bill_switch",
          "source_name": "home_believe"
        }
      },
      {
        "config": {
          "key": "/bill-switch/phone-bill/cardFrozenBottomSheet",
          "name": "Card Frozen Bottom Sheet Presented",
          "category": "bill_switch",
          "source_name": "home_sweepstakes"
        }
      },
      {
        "config": {
          "key": "/varo-advance/approved",
          "name": "VA Qualified",
          "source_name": "",
          "category": "varo_advance",
          "subcategory": "va_application"
        }
      },
      {
        "config": {
          "key": "/varo-advance/autopayment",
          "name": "VA Auto Payment",
          "category": "varo_advance",
          "subcategory": "va_disbursement"
        }
      },
      {
        "config": {
          "key": "/accounts/advance-details/what-is-va",
          "name": "VA Educational",
          "category": "varo_advance"
        }
      },
      {
        "config": {
          "key": "/varo-advance/qualification",
          "name": "VA Qualification Details",
          "source_name": "",
          "category": "varo_advance",
          "subcategory": "va_application"
        }
      },
      {
        "config": {
          "key": "/accounts/varo-advance/partially-qualified",
          "name": "VA Re-eligibility Temp No Access",
          "source_name": "",
          "category": "varo_advance",
          "subcategory": ""
        }
      },
      {
        "config": {
          "key": "/varo-advance/account-pending",
          "name": "VA Account Linking Pending Timeout",
          "source_name": "",
          "category": "varo_advance",
          "subcategory": "va_day_0"
        }
      },
      {
        "config": {
          "key": "/varo-advance/throttled",
          "name": "VA Account Throttled",
          "source_name": "",
          "category": "varo_advance",
          "subcategory": "va_day_0"
        }
      },
      {
        "config": {
          "key": "/varo-advance/new",
          "name": "VA Amount Selection",
          "source_name": "select_amount",
          "category": "varo_advance",
          "subcategory": "va_application"
        }
      },
      {
        "config": {
          "key": "/accounts/varo-advance/confirm-payment/success",
          "name": "",
          "category": "varo_advance",
          "subcategory": "va_repayment"
        }
      },
      {
        "config": {
          "key": "/varo-advance/va-review",
          "name": "VA Review",
          "category": "varo_advance"
        }
      },
      {
        "config": {
          "key": "/varo-advance/processing",
          "name": "VA Processing",
          "source_name": "",
          "category": "varo_advance",
          "subcategory": "va_application"
        }
      },
      {
        "config": {
          "key": "/varo-advance/employment-info",
          "name": "VA Employment Info",
          "source_name": "",
          "category": "varo_advance",
          "subcategory": "va_application"
        }
      },
      {
        "config": {
          "key": "/varo-advance/qualified",
          "name": "VA Qualified",
          "source_name": "",
          "category": "varo_advance",
          "subcategory": "va_application"
        }
      },
      {
        "config": {
          "key": "/varo-advance/approved",
          "name": "VA Qualified",
          "source_name": "",
          "category": "varo_advance",
          "subcategory": "va_application"
        }
      },
      {
        "config": {
          "key": "/varo-advance/success",
          "name": "VA Executed",
          "source_name": "",
          "category": "varo_advance",
          "subcategory": "va_application"
        }
      },
      {
        "config": {
          "key": "/accounts/varo-advance/manual-repayments",
          "name": "VA Repayment Amount",
          "category": "varo_advance",
          "subcategory": "va_repayment"
        }
      },
      {
        "config": {
          "key": "/accounts/varo-advance/confirm-payment",
          "name": "VA Repayment Confirmation",
          "source_name": "",
          "category": "varo_advance",
          "subcategory": "va_repayment"
        }
      },
      {
        "config": {
          "key": "varo-advance/error-custom",
          "name": "Advance Flow Error Encountered",
          "source_name": "",
          "category": "varo_advance"
        }
      },
      {
        "config": {
          "key": "/varo-advance/lcm-direct-deposit",
          "name": "Set Up Direct Deposit",
          "category": "direct_deposit",
          "subcategory": "varo_advance"
        }
      },
      {
        "config": {
          "key": "/varo-advance/link-account/va_eligibility",
          "name": "VA Qualification Details",
          "category": "va_advance",
          "subcategory": "va_day_0"
        }
      },
      {
        "config": {
          "key": "/varo-advance/link-account",
          "name": "Account Linking Legal Agreement",
          "source_name": "va_agreement",
          "category": "varo_advance",
          "subcategory": "va_day_0"
        }
      },
      {
        "config": {
          "key": "/varo-advance/link-account/phase1",
          "name": "VA Account Linking Pending Phase 1",
          "category": "varo_advance",
          "subcategory": "va_day_0"
        }
      },
      {
        "config": {
          "key": "/varo-advance/link-account/phase2",
          "name": "VA Account Linking Pending Phase 2",
          "category": "varo_advance",
          "subcategory": "va_day_0"
        }
      },
      {
        "config": {
          "key": "/varo-advance/link-account/phase3",
          "name": "VA Account Linking Pending Phase 3",
          "category": "varo_advance",
          "subcategory": "va_day_0"
        }
      },
      {
        "config": {
          "key": "/varo-advance/link-account/pending",
          "name": "VA Account Linking Pending Timeout",
          "category": "varo_advance",
          "subcategory": "va_day_0"
        }
      },
      {
        "config": {
          "key": "/varo-advance/link-account/error",
          "name": "Account Linking Error Encountered",
          "category": "account_linking",
          "subcategory": "va_day_0"
        }
      },
      {
        "config": {
          "key": "/varo-advance/link-account/cra-upgrade",
          "name": "CRA Account Selection",
          "category": "varo_advance",
          "subcategory": ""
        }
      },
      {
        "config": {
          "key": "/varo-advance/link-debit-card",
          "name": "Link Debit Card",
          "category": "link_external_debit_card",
          "subcategory": "va_day_0"
        }
      },
      {
        "config": {
          "key": "/varo-advance/expired-card",
          "name": "VA Review",
          "category": "varo_advance"
        }
      },
      {
        "config": {
          "key": "/accounts/advance-details",
          "name": "Manage Account",
          "category": "varo_advance"
        }
      },
      {
        "config": {
          "key": "/varo-advance/link-account/intro",
          "name": "VA Educational Screen",
          "category": "varo_advance",
          "subcategory": "va_day_0"
        }
      },
      {
        "config": {
          "key": "/accounts/advance-details/advance-history",
          "name": "VA History Details",
          "category": "varo_advance"
        }
      },
      {
        "config": {
          "key": "/accounts/advance-details/history",
          "name": "VA Transaction History",
          "category": "varo_advance"
        }
      },
      {
        "config": {
          "key": "accounts/varo-advance/confirm-payment/errorScreen",
          "name": "VA Repayment Flow Error Encountered",
          "category": "varo_advance",
          "subcategory": "va_repayment"
        }
      },
      {
        "config": {
          "key": "/varo-advance/autopayment-authorization",
          "name": "VA Autopay Authorization",
          "category": "varo_advance",
          "subcategory": "va_disbursement"
        }
      },
      {
        "config": {
          "key": "login/verify-identity-error",
          "name": "Identity Verification Error",
          "category": "login",
          "subcategory": "magic_link"
        }
      },
      {
        "config": {
          "key": "/get-varo-app/appDownloadQrCode",
          "name": "App Download Qr Code",
          "category": "home_page",
          "subcategory": "app_download"
        }
      },
      {
        "config": {
          "key": "/spend-benefits/onBoardingCashbackInformation",
          "name": "Onboarding Cashback Information",
          "category": "onboarding",
          "subcategory": "onboarding_checklist"
        }
      },
      {
        "config": {
          "key": "/onboardingChecklistCompleteNotification",
          "name": "Onboarding Checklist Complete Notification",
          "category": "onboarding",
          "subcategory": "onboarding_checklist"
        }
      },
      {
        "config": {
          "key": "/onboardingChecklistDisclosuresNotification",
          "name": "Onboarding Checklist Disclosures Notification",
          "category": "onboarding",
          "subcategory": "onboarding_checklist"
        }
      },
      {
        "config": {
          "key": "/onboarding/deposit-cash/depositCashLocationFlow",
          "name": "Deposit Cash Location Flow",
          "category": "onboarding",
          "subcategory": "onboarding_wizard"
        }
      },
      {
        "config": {
          "key": "/move-money/deposit-cash/barcode/loading-error",
          "name": "Barcode Page Loading Error",
          "category": "deposit_cash",
          "subcategory": "cash_deposit_barcode"
        }
      },
      {
        "config": {
          "key": "/move-money/deposit-cash/barcode/location-required-error",
          "name": "Location Required for Cash Deposits Error",
          "category": "deposit_cash",
          "subcategory": "cash_deposit_barcode",
          "flow_name": "move_money",
          "error_code": "",
          "user_error_message": "locations_off_for_barcode",
          "error_category": "cash_deposit_errors"
        }
      },
      {
        "config": {
          "key": "/move-money/deposit-cash/barcode/app-required-error",
          "name": "App Required for Cash Deposits Error",
          "category": "deposit_cash",
          "subcategory": "cash_deposit_barcode",
          "flow_name": "move_money"
        }
      },
      {
        "config": {
          "key": "/move-money/deposit-cash/map",
          "name": "Deposit Locations",
          "category": "deposit_cash",
          "subcategory": "barcode",
          "flow_name": "move_money"
        }
      },
      {
        "config": {
          "key": "/move-money/deposit-cash/barcode/refreshed",
          "name": "Cash Deposit Barcode Manual Refresh",
          "category": "deposit_cash",
          "subcategory": "barcode",
          "flow_name": "move_money"
        }
      },
      {
        "config": {
          "key": "/move-money/deposit-cash/barcode/expired",
          "name": "Cash Deposit Barcode Expired",
          "category": "deposit_cash",
          "subcategory": "cash_deposit_barcode",
          "barcode_status": "Expired",
          "flow_name": "move_money"
        }
      },
      {
        "config": {
          "key": "/move-money/deposit-cash/barcode/unable-to-refresh",
          "name": "Barcode Unable To Refresh",
          "category": "deposit_cash",
          "subcategory": "cash_deposit_barcode",
          "flow_name": "move_money"
        }
      },
      {
        "config": {
          "key": "/myvaro/personal-details/change-address/home-address-confirmation",
          "name": "Home Address Confirmation",
          "category": "profile_settings",
          "source_name": "home_address_confirmation"
        }
      },
      {
        "config": {
          "key": "/rewards/upside-offer/activation-error",
          "name": "Offer Activation Failed",
          "category": "rewards",
          "source_name": "cashback_details_page"
        }
      },
      {
        "config": {
          "key": "/myvaro/personal-details/change-mailing-address/mailing-address-confirmation",
          "name": "Mailing Address Confirmation",
          "category": "profile_settings",
          "source_name": "mailing_address_confirmation"
        }
      },
      {
        "config": {
          "key": "/rewards/upside-offer/deactivation-error",
          "name": "Offer Deactivation Failed",
          "category": "rewards",
          "source_name": "cashback_details_page"
        }
      },
      {
        "config": {
          "key": "/rewards/my-offers",
          "name": "My Offers",
          "category": "rewards"
        }
      },
      {
        "config": {
          "key": "onboarding/apple-pay/apple-pay-success",
          "name": "Apple Pay Funding Completed",
          "category": "apple_pay"
        }
      },
      {
        "config": {
          "key": "/move-money/apple-pay/loaded",
          "name": "Apple Pay Funding Clicked",
          "category": "apple_pay"
        }
      },
      {
        "config": {
          "key": "/move-money/apple-pay/unavailable",
          "name": "Apple Pay Is Unavailable",
          "category": "apple_pay"
        }
      },
      {
        "config": {
          "key": "/move-money/apple-pay/limits-info",
          "name": "Apple Pay Limits Info",
          "category": "apple_pay"
        }
      },
      {
        "config": {
          "key": "/move-money/apple-pay/debit-card-error",
          "name": "Add Debit Card Error Encountered",
          "category": "link_external_debit_card",
          "subcategory": "add_card",
          "money_flow_direction": "pull",
          "flow_name": "apple_pay"
        }
      },
      {
        "config": {
          "key": "applePayFunding",
          "name": "Apple Pay Funding",
          "category": "apple_pay"
        }
      },
      {
        "config": {
          "key": "encourageDdAfterVaSuccessViewed",
          "name": "DD Encouragement",
          "category": "varo_advance",
          "subcategory": "va_day_0",
          "source_name": "va_successful"
        }
      },
      {
        "config": {
          "key": "moveYourPayDirectDepositSheetViewed",
          "name": "DD Encouragement",
          "category": "varo_believe",
          "subcategory": "move_your_pay",
          "source_name": "move_your_pay_setup"
        }
      },
      {
        "config": {
          "key": "/rewards/categories/[category]/categoryDetailPage",
          "name": "Partner Offer Details",
          "category": "rewards"
        }
      },
      {
        "config": {
          "key": "dd-borrow-more",
          "name": "DD Borrow More",
          "category": "varo_advance",
          "subcategory": "va_day_0"
        }
      },
      {
        "config": {
          "key": "dd-borrow-more-phase-2",
          "name": "DD Borrow More Phase 2",
          "category": "varo_advance",
          "subcategory": "va_day_0"
        }
      },
      {
        "config": {
          "key": "/onboarding/paycheck-option/payCheckOption",
          "name": "Paycheck Option",
          "category": "onboarding",
          "subcategory": "onboarding_wizard"
        }
      },
      {
        "config": {
          "key": "/believe-funding/p2p/credential-challenge/[cardId]/confirm-identity",
          "name": "P2P Credential Challenge Identity",
          "category": "card",
          "subcategory": "card_credential"
        }
      },
      {
        "config": {
          "key": "/believe-funding/p2p/credential-challenge/[cardId]/declined",
          "name": "P2P Credential Challenge Declined",
          "category": "card",
          "subcategory": "card_credential"
        }
      },
      {
        "config": {
          "key": "/believe-funding/p2p/credential-challenge/[cardId]/verify-otp",
          "name": "P2P Credential Challenge OTP",
          "category": "card",
          "subcategory": "card_credential"
        }
      },
      {
        "config": {
          "key": "/move-money/p2p/credential-challenge/[cardId]/confirm-identity",
          "name": "P2P Credential Challenge Identity",
          "category": "card",
          "subcategory": "card_credential"
        }
      },
      {
        "config": {
          "key": "/move-money/p2p/credential-challenge/[cardId]/declined",
          "name": "P2P Credential Challenge Declined",
          "category": "card",
          "subcategory": "card_credential"
        }
      },
      {
        "config": {
          "key": "/move-money/p2p/credential-challenge/[cardId]/verify-otp",
          "name": "P2P Credential Challenge OTP",
          "category": "card",
          "subcategory": "card_credential"
        }
      },
      {
        "config": {
          "key": "/onboarding/p2p/credential-challenge/[cardId]/confirm-identity",
          "name": "P2P Credential Challenge Identity",
          "category": "card",
          "subcategory": "card_credential"
        }
      },
      {
        "config": {
          "key": "/onboarding/p2p/credential-challenge/[cardId]/declined",
          "name": "P2P Credential Challenge Declined",
          "category": "card",
          "subcategory": "card_credential"
        }
      },
      {
        "config": {
          "key": "/onboarding/p2p/credential-challenge/[cardId]/verify-otp",
          "name": "P2P Credential Challenge OTP",
          "category": "card",
          "subcategory": "card_credential"
        }
      },
      {
        "config": {
          "key": "/myvaro/card/credential-challenge/[cardId]/confirm-identity",
          "name": "Card Credential Challenge Identity",
          "category": "card",
          "subcategory": "card_credential"
        }
      },
      {
        "config": {
          "key": "/myvaro/card/credential-challenge/[cardId]/declined",
          "name": "Card Credential Challenge Declined",
          "category": "card",
          "subcategory": "card_credential"
        }
      },
      {
        "config": {
          "key": "/myvaro/card/credential-challenge/[cardId]/verify-otp",
          "name": "Card Credential Challenge OTP",
          "category": "card",
          "subcategory": "card_credential"
        }
      },
      {
        "config": {
          "key": "/pay-over-time/manage-loans",
          "name": "Pay Over Time Home Page",
          "category": "pay_over_time"
        }
      },
      {
        "config": {
          "key": "/pay-over-time/account-settings",
          "name": "Pay Over Time Account Settings",
          "category": "pay_over_time"
        }
      },
      {
        "config": {
          "key": "/pay-over-time/apply-now",
          "name": "Pay Over Time Intro",
          "category": "pay_over_time"
        }
      },
      {
        "config": {
          "key": "/pay-over-time/landing-page",
          "name": "Pay Over Time Landing Page",
          "category": "pay_over_time"
        }
      },
      {
        "config": {
          "key": "/pay-over-time/payment-plan",
          "name": "Pay Over Time Payment Plan Review",
          "category": "pay_over_time"
        }
      },
      {
        "config": {
          "key": "/pay-over-time/payment-plan/paymentPlanWhatIsAutopayBottomSheetViewed",
          "name": "Pay Over Time What Is Autopay Bottom Sheet Viewed",
          "category": "pay_over_time",
          "source_name": "pay_over_time_payment_plan_review"
        }
      },
      {
        "config": {
          "key": "/accounts/transaction-details/payOverTimeApplyNowBottomSheetViewed",
          "name": "Pay Over Time Apply Now Bottom Sheet Viewed",
          "category": "pay_over_time",
          "source_name": "pay_over_time_bottom_sheet"
        }
      },
      {
        "config": {
          "key": "/pay-over-time/application-success",
          "name": "Pay Over Time Application Approved",
          "category": "pay_over_time"
        }
      },
      {
        "config": {
          "key": "/pay-over-time/application-decline",
          "name": "Pay Over Time Application Declined",
          "category": "pay_over_time"
        }
      },
      {
        "config": {
          "key": "payOverTimeApplicationFlowErrorEncountered",
          "name": "Pay Over Time Application Flow Error Encountered",
          "category": "pay_over_time"
        }
      },
      {
        "config": {
          "key": "payOverTimeManualPaymentErrorEncountered",
          "name": "Pay Over Time Manual Payment Error Encountered",
          "category": "pay_over_time"
        }
      },
      {
        "config": {
          "key": "/pay-over-time/payment-schedule",
          "name": "Pay Over Time Payment Schedule",
          "category": "pay_over_time"
        }
      },
      {
        "config": {
          "key": "/pay-over-time/loan-details",
          "name": "Pay Over Time Loan Details",
          "category": "pay_over_time"
        }
      },
      {
        "config": {
          "key": "/pay-over-time/manual-payment/payment-received",
          "name": "Pay Over Time Payment Received",
          "category": "pay_over_time"
        }
      },
      {
        "config": {
          "key": "/pay-over-time/manual-payment/loan-paid-off",
          "name": "Pay Over Time Loan Paid Off",
          "category": "pay_over_time"
        }
      },
      {
        "config": {
          "key": "dd-instant-switch-intro",
          "name": "Screen Viewed",
          "category": "direct_deposit",
          "subcategory": "instant_switch",
          "source_name": "direct_deposit_menu"
        }
      },
      {
        "config": {
          "key": "/move-money/direct-deposit/instant-switch-intro",
          "name": "Direct Deposit Instant Switch Intro",
          "category": "direct_deposit",
          "subcategory": "instant_switch",
          "source_name": "direct_deposit_menu"
        }
      },
      {
        "config": {
          "key": "onboarding-google-pay",
          "name": "Google Pay Funding",
          "category": "card",
          "subcategory": "wallet_provisioning"
        }
      },
      {
        "config": {
          "key": "progress-tracker-funding-google-pay",
          "name": "Google Pay Funding",
          "category": "card",
          "subcategory": "wallet_provisioning"
        }
      },
      {
        "config": {
          "key": "move-money-google-pay",
          "name": "Google Pay Funding",
          "category": "card",
          "subcategory": "wallet_provisioning"
        }
      },
      {
        "config": {
          "key": "/plaid/marketing-consent",
          "name": "Plaid Marketing Consent",
          "source_name": "plaid_marketing_consent",
          "category": "external_account",
          "subcategory": "plaid_consent"
        }
      }
    ],
    "pressableConfigs": [
      {
        "config": {
          "key": "/encourageDdAfterVaSuccessDirectDepositClicked",
          "name": "Direct Deposit Flow Initiated",
          "category": "direct_deposit",
          "subcategory": "va_day_0",
          "source_name": "va_successful"
        }
      },
      {
        "config": {
          "key": "/encourageDdAfterVaSuccessDismissed",
          "name": "Direct Deposit Flow Skipped",
          "category": "direct_deposit",
          "subcategory": "va_day_0",
          "source_name": "va_successful"
        }
      },
      {
        "config": {
          "key": "/myvaro/personal-details/change-phone/enter-code/verificationCodeSubmitted",
          "name": "Code Submitted",
          "category": "profile_settings",
          "source_name": "sms_otp_page"
        }
      },
      {
        "config": {
          "key": "/myvaro/personal-details/change-phone/enter-code/verification-code-requested",
          "name": "Verification Code Requested",
          "category": "profile_settings",
          "source_name": "sms_otp_page"
        }
      },
      {
        "config": {
          "key": "/myvaro/personal-details/change-phone/phone-number-change-submitted",
          "name": "Phone Number Change Submitted",
          "category": "profile_settings",
          "source_name": "sms_otp_page"
        }
      },
      {
        "config": {
          "key": "/myvaro/personal-details/change-phone-clicked",
          "name": "Edit Phone Number Clicked",
          "category": "profile_settings",
          "source_name": "personal_details_page"
        }
      },
      {
        "config": {
          "key": "/myvaro/statements-and-forms/account-statements/[id]/year-pressed",
          "name": "Account Statement Clicked",
          "category": "",
          "source_name": "statements_page"
        }
      },
      {
        "config": {
          "key": "/otp/error/linkExpired",
          "name": "Forgot Password Link Expired",
          "category": "login",
          "subcategory": "forgot_password"
        }
      },
      {
        "config": {
          "key": "/otp/error/resetPassword",
          "name": "Forgot Password Clicked",
          "source_name": "link_expired_page",
          "category": "login",
          "subcategory": "forgot_password"
        }
      },
      {
        "config": {
          "key": "/otp/error/verificationFailed",
          "name": "Verification Failed",
          "source_name": "link_expired_page",
          "category": "login",
          "subcategory": "forgot_password"
        }
      },
      {
        "config": {
          "key": "/myvaro/statements-and-forms/account-statements/[id]/[year]/month-pressed",
          "name": "Account Statement Clicked",
          "category": "",
          "source_name": "statements_page"
        }
      },
      {
        "config": {
          "key": "/myvaro/statements-and-forms/account-statements/[id]/[year]/[month]/day-pressed",
          "name": "Account Statement Clicked",
          "category": "",
          "source_name": "statements_page"
        }
      },
      {
        "config": {
          "key": "/signup/legal",
          "name": "Legal Agreements",
          "subcategory": "checking",
          "category": "application",
          "source_name": ""
        }
      },
      {
        "config": {
          "key": "/signup/application-decision",
          "name": "",
          "subcategory": "checking",
          "category": "application",
          "source_name": ""
        }
      },
      {
        "config": {
          "key": "/signup/application-decision/socureFlowInitiated",
          "name": "Identity Verification Flow Initiated",
          "source_name": "application_decision",
          "subcategory": "checking",
          "category": "application"
        }
      },
      {
        "config": {
          "key": "/signup/application-decision/idv-completed",
          "name": "IDV Completed",
          "source_name": "application_sent",
          "subcategory": "checking",
          "category": "application"
        }
      },
      {
        "config": {
          "key": "/signup/application-decision/logoutClicked",
          "name": "Log Out Clicked",
          "source_name": "application_sent",
          "subcategory": "checking",
          "category": "application"
        }
      },
      {
        "config": {
          "key": "/signup/application-decision/phoneClickedSocure",
          "name": "Phone Field Clicked",
          "source_name": "idv_methods",
          "category": "application",
          "subcategory": "checking"
        }
      },
      {
        "config": {
          "key": "/signup/application-decision/verificationCodeRequestedSocure",
          "name": "Verification Code Requested",
          "source_name": "idv_methods",
          "category": "application",
          "subcategory": "checking"
        }
      },
      {
        "config": {
          "key": "/reset-password/enter-otp",
          "name": "SMS OTP",
          "category": "login",
          "subcategory": "forgot_password",
          "source_name": ""
        }
      },
      {
        "config": {
          "key": "/reset-password/set-password",
          "name": "Create New Password",
          "category": "login",
          "subcategory": "forgot_password",
          "source_name": ""
        }
      },
      {
        "config": {
          "key": "/reset-password/success",
          "name": "Reset Password Completed",
          "category": "login",
          "subcategory": "forgot_password",
          "source_name": ""
        }
      },
      {
        "config": {
          "key": "/myvaro/statements-and-forms/account-statements/[id]/[year]",
          "name": "Statements and Documents",
          "category": ""
        }
      },
      {
        "config": {
          "key": "/myvaro/statements-and-forms/account-statements/[id]/year-pressed",
          "name": "Account Statement Clicked",
          "category": "",
          "source_name": "statements_page"
        }
      },
      {
        "config": {
          "key": "/myvaro/statements-and-forms/account-statements/[id]/[year]/month-pressed",
          "name": "Account Statement Clicked",
          "category": "",
          "source_name": "statements_page"
        }
      },
      {
        "config": {
          "key": "/myvaro/statements-and-forms/account-statements/[id]/[year]/[month]/day-pressed",
          "name": "Account Statement Clicked",
          "category": "",
          "source_name": "statements_page"
        }
      },
      {
        "config": {
          "key": "/varo-line-of-credit/payment-details/errorButtonPress",
          "name": "VLOC Application Flow Error Encountered",
          "category": "vloc",
          "subcategory": "vloc_repayment"
        }
      },
      {
        "config": {
          "key": "/varo-line-of-credit/review/errorButtonPress",
          "name": "VLOC Application Flow Error Encountered",
          "category": "vloc",
          "subcategory": "vloc_application"
        }
      },
      {
        "config": {
          "key": "/varo-line-of-credit/user-info/errorButtonPress",
          "name": "VLOC Application Flow Error Encountered",
          "category": "vloc",
          "subcategory": "vloc_application"
        }
      },
      {
        "config": {
          "key": "/varo-line-of-credit/review/autopay",
          "name": "VLOC Auto Pay",
          "source_name": "vloc_disbursement_confirmation",
          "category": "vloc",
          "subcategory": "taking_out_vloc"
        }
      },
      {
        "config": {
          "key": "/varo-line-of-credit/review/faq",
          "name": "FAQs Clicked",
          "source_name": "vloc_disbursement_confirmation",
          "category": "vloc",
          "subcategory": "taking_out_vloc",
          "faq_name": "autopay"
        }
      },
      {
        "config": {
          "key": "/varo-line-of-credit/review/submitReviewDetails",
          "name": "Get VLOC Clicked",
          "source_name": "vloc_disbursement_confirmation",
          "category": "vloc",
          "subcategory": "taking_out_vloc"
        }
      },
      {
        "config": {
          "key": "/varo-line-of-credit/history/history-item",
          "name": "VLOC Transaction Viewed",
          "category": "vloc",
          "source_name": "vloc_transaction_history"
        }
      },
      {
        "config": {
          "key": "/varo-line-of-credit/line-of-credit-entry-point/takeout_manageAccountClicked",
          "name": "Manage Account Clicked",
          "category": "vloc",
          "source_name": "vloc_tier_selection_page",
          "subcategory": "take_out_vloc"
        }
      },
      {
        "config": {
          "key": "/varo-line-of-credit/line-of-credit-entry-point/active_details_manageAccountClicked",
          "name": "Manage Account Clicked",
          "category": "vloc",
          "source_name": "vloc_home_page",
          "subcategory": "vloc_repayment"
        }
      },
      {
        "config": {
          "key": "/varo-line-of-credit/manage-account/auto-pay",
          "name": "Auto Pay Clicked",
          "category": "vloc",
          "source_name": "manage_account_page"
        }
      },
      {
        "config": {
          "key": "/varo-line-of-credit/manage-account/history",
          "name": "Account History Accessed",
          "category": "vloc",
          "source_name": "manage_account_page"
        }
      },
      {
        "config": {
          "key": "/varo-line-of-credit/manage-account/statements-documents",
          "name": "Statements and Documents Clicked",
          "category": "vloc",
          "source_name": "manage_account_page"
        }
      },
      {
        "config": {
          "key": "/varo-line-of-credit/manage-account/faq",
          "name": "FAQs Clicked",
          "category": "vloc",
          "source_name": "manage_account_page"
        }
      },
      {
        "config": {
          "key": "/varo-line-of-credit/manage-account/faq-intro",
          "name": "FAQs Clicked",
          "category": "vloc",
          "source_name": "manage_account_page"
        }
      },
      {
        "config": {
          "key": "/varo-line-of-credit/manage-account/faq-tnc",
          "name": "FAQs Clicked",
          "category": "vloc",
          "source_name": "manage_account_page"
        }
      },
      {
        "config": {
          "key": "/varo-line-of-credit/apply-employment/faqsClicked",
          "name": "FAQs Clicked",
          "category": "vloc",
          "subcategory": "vloc_application",
          "source_name": "vloc_employment_income_form",
          "faq_name": "income"
        }
      },
      {
        "config": {
          "key": "/varo-line-of-credit/apply-employment/termsAndConditionsClicked",
          "name": "VLOC Consent To Credit Pull Checkbox Clicked",
          "category": "vloc",
          "subcategory": "vloc_application",
          "source_name": "vloc_employment_income_form"
        }
      },
      {
        "config": {
          "key": "/varo-line-of-credit/apply-employment/viewPdfClicked",
          "name": "Terms And Conditions Accessed",
          "category": "vloc",
          "subcategory": "vloc_application",
          "source_name": "vloc_employment_income_form"
        }
      },
      {
        "config": {
          "key": "/varo-line-of-credit/apply-employment/vaRegistrationStepCompleted",
          "name": "VLOC Application Step Completed",
          "category": "vloc",
          "subcategory": "vloc_application",
          "source_name": "vloc_employment_income_form",
          "step_name": "employment_income"
        }
      },
      {
        "config": {
          "key": "/varo-line-of-credit/apply-employment/employmentStatusDropDownClicked",
          "name": "Employment Status Drop Down Clicked",
          "category": "vloc",
          "subcategory": "vloc_application",
          "source_name": "vloc_employment_income_form"
        }
      },
      {
        "config": {
          "key": "/varo-line-of-credit/apply-employment/employmentStatusSelected",
          "name": "Employment Status Selected",
          "category": "vloc",
          "subcategory": "vloc_application",
          "source_name": "vloc_employment_income_form"
        }
      },
      {
        "config": {
          "key": "/varo-line-of-credit/apply-employment/monthlyIncomeTextFieldEntered",
          "name": "Monthly Income Entered",
          "category": "vloc",
          "subcategory": "vloc_application",
          "source_name": "vloc_employment_income_form"
        }
      },
      {
        "config": {
          "key": "/varo-line-of-credit/apply-employment/vaRegistrationStepSkipped",
          "name": "VLOC Application Flow Exited",
          "category": "vloc",
          "subcategory": "vloc_application"
        }
      },
      {
        "config": {
          "key": "/varo-line-of-credit/line-of-credit-entry-point/prequal_vloc_tier_selected",
          "name": "VLOC Tier Selected",
          "category": "vloc",
          "subcategory": "vloc_application"
        }
      },
      {
        "config": {
          "key": "/varo-line-of-credit/line-of-credit-entry-point/takeout_vloc_tier_selected",
          "name": "VLOC Tier Selected",
          "category": "vloc",
          "subcategory": "taking_out_vloc",
          "source_name": "vloc_tier_selection_page"
        }
      },
      {
        "config": {
          "key": "/varo-line-of-credit/line-of-credit-entry-point/borrow_more",
          "name": "Grow Borrowing Power Clicked",
          "category": "vloc",
          "subcategory": "taking_out_vloc",
          "source_name": "vloc_tier_selection_page"
        }
      },
      {
        "config": {
          "key": "/varo-line-of-credit/hard-pull-approved/borrowNow",
          "name": "VLOC Initiated",
          "category": "vloc",
          "subcategory": "vloc_application",
          "source_name": "vloc_application_approved"
        }
      },
      {
        "config": {
          "key": "/varo-line-of-credit/hard-pull-approved/borrowLater",
          "name": "VLOC Offer Skipped",
          "category": "vloc",
          "subcategory": "vloc_application",
          "source_name": "vloc_application_approved"
        }
      },
      {
        "config": {
          "key": "/varo-line-of-credit/line-of-credit-entry-point/creditFrozenAndGoToHomeClicked",
          "name": "Go To Home Clicked",
          "category": "vloc",
          "source_name": "vloc_credit_report_frozen",
          "subcategory": "vloc_application"
        }
      },
      {
        "config": {
          "key": "/varo-line-of-credit/money-in-the-bank/goToHomeClicked",
          "name": "Go To Home Clicked",
          "category": "vloc",
          "source_name": "vloc_executed",
          "subcategory": "taking_out_vloc"
        }
      },
      {
        "config": {
          "key": "/varo-line-of-credit/line-of-credit-entry-point/hardPullDeclineAndGoToHomeClicked",
          "name": "Go To Home Clicked",
          "category": "vloc",
          "source_name": "vloc_application_declined",
          "subcategory": "vloc_application"
        }
      },
      {
        "config": {
          "key": "/varo-line-of-credit/line-of-credit-entry-point/vloc_is_on_its_way_goToHomeClicked",
          "name": "Go To Home Clicked",
          "category": "vloc",
          "source_name": "vloc_not_executed"
        }
      },
      {
        "config": {
          "key": "/varo-line-of-credit/line-of-credit-entry-point/vloc_not_qualified_goToHomeClicked",
          "name": "Go To Home Clicked",
          "category": "vloc",
          "source_name": "vloc_not_qualified_page",
          "subcategory": "vloc_application"
        }
      },
      {
        "config": {
          "key": "/varo-line-of-credit/line-of-credit-entry-point/believeFlowInitiated",
          "name": "Believe Application Flow Initiated",
          "category": "varo_believe",
          "source_name": "vloc_not_qualified_page",
          "subcategory": "believe_application"
        }
      },
      {
        "config": {
          "key": "/varo-line-of-credit/user-info/confirmClicked",
          "name": "VLOC Application Step Completed",
          "category": "vloc",
          "source_name": "vloc_user_info_form",
          "subcategory": "vloc_application"
        }
      },
      {
        "config": {
          "key": "/varo-line-of-credit/user-info/cancelClicked",
          "name": "VLOC Application Flow Exited",
          "category": "vloc",
          "source_name": "vloc_user_info_form",
          "subcategory": "vloc_application"
        }
      },
      {
        "config": {
          "key": "/varo-line-of-credit/user-info/editAddressClicked",
          "name": "Edit Address Clicked",
          "category": "vloc",
          "source_name": "vloc_user_info_form",
          "subcategory": "vloc_application"
        }
      },
      {
        "config": {
          "key": "/varo-line-of-credit/line-of-credit-entry-point/vlocNotEligibleClicked",
          "name": "VLOC Offer Clicked",
          "subcategory": "vloc_application",
          "source_name": "vloc_offer_page",
          "category": "vloc"
        }
      },
      {
        "config": {
          "key": "/varo-line-of-credit/line-of-credit-entry-point/vlocEligibleClicked",
          "name": "VLOC Application Flow Initiated",
          "subcategory": "vloc_application",
          "source_name": "vloc_offer_page",
          "category": "vloc"
        }
      },
      {
        "config": {
          "key": "/varo-line-of-credit/line-of-credit-entry-point/lost_eligibility_manageAccountClicked",
          "name": "Manage Account Clicked",
          "subcategory": "vloc_application",
          "source_name": "vloc_lost_eligibility",
          "category": "vloc"
        }
      },
      {
        "config": {
          "key": "/varo-line-of-credit/history-details/paymentScheduleClicked",
          "name": "VLOC Payment Schedule Clicked",
          "category": "vloc",
          "source_name": "vloc_history_details"
        }
      },
      {
        "config": {
          "key": "/varo-line-of-credit/line-of-credit-entry-point/makePaymentClicked",
          "name": "Make Payment Clicked",
          "category": "vloc",
          "source_name": "vloc_home_page",
          "subcategory": "vloc_repayment"
        }
      },
      {
        "config": {
          "key": "/varo-line-of-credit/line-of-credit-entry-point/autoPayClicked",
          "name": "Auto Pay Clicked",
          "category": "vloc",
          "source_name": "vloc_home_page"
        }
      },
      {
        "config": {
          "key": "/varo-line-of-credit/line-of-credit-entry-point/transactionViewed",
          "name": "VLOC Transaction Viewed",
          "category": "vloc",
          "source_name": "vloc_home_page"
        }
      },
      {
        "config": {
          "key": "/varo-line-of-credit/line-of-credit-entry-point/paymentScheduleClicked",
          "name": "VLOC Payment Schedule Clicked",
          "category": "vloc",
          "source_name": "vloc_home_page"
        }
      },
      {
        "config": {
          "key": "/varo-line-of-credit/autopay/autoPayTurnedOn",
          "name": "VLOC Auto Pay Turned On",
          "category": "vloc",
          "source_name": "vloc_autopay",
          "account_type": "vloc"
        }
      },
      {
        "config": {
          "key": "/varo-line-of-credit/autopay/autoPayTurnedOff",
          "name": "VLOC Auto Pay Turned Off",
          "category": "vloc",
          "source_name": "vloc_autopay",
          "account_type": "vloc"
        }
      },
      {
        "config": {
          "key": "/varo-line-of-credit/payment-details/repayAccountSelected",
          "name": "VLOC Repayment Account Selected",
          "category": "vloc",
          "subcategory": "vloc_repayment",
          "source_name": "vloc_repayment_amount"
        }
      },
      {
        "config": {
          "key": "/varo-line-of-credit/payment-details/nextButtonClicked",
          "name": "VLOC Select Amount Step Completed",
          "category": "vloc",
          "subcategory": "vloc_repayment",
          "source_name": "vloc_repayment_amount"
        }
      },
      {
        "config": {
          "key": "/myVaroTabClicked",
          "name": "My Varo Tab Clicked",
          "source_name": "home_page",
          "category": "",
          "subcategory": ""
        }
      },
      {
        "config": {
          "key": "/myvaro/invite-friends",
          "name": "Invite Friends Clicked",
          "source_name": "my_varo",
          "category": "referral",
          "subcategory": ""
        }
      },
      {
        "config": {
          "key": "/myvaro/personal-details",
          "name": "Personal Details Clicked",
          "source_name": "my_varo",
          "category": "account_management",
          "subcategory": ""
        }
      },
      {
        "config": {
          "key": "/myvaro/notifications-settings",
          "name": "Settings Clicked",
          "source_name": "my_varo",
          "category": "settings",
          "subcategory": "notifications"
        }
      },
      {
        "config": {
          "key": "/myvaro/statements-and-documents",
          "name": "Statements and Documents Clicked",
          "source_name": "my_varo",
          "category": "account_management",
          "subcategory": ""
        }
      },
      {
        "config": {
          "key": "/myvaro/settings/marketingEmailNotificationsEnabled",
          "name": "Marketing Email Notifications Enabled",
          "source_name": "notification_settings",
          "category": "account_management"
        }
      },
      {
        "config": {
          "key": "/myvaro/settings/marketingEmailNotificationsDisabled",
          "name": "Marketing Email Notifications Disabled",
          "source_name": "notification_settings",
          "category": "account_management"
        }
      },
      {
        "config": {
          "key": "/myvaro/settings/marketingPushNotificationsEnabled",
          "name": "Marketing Push Notifications Enabled",
          "source_name": "notification_settings",
          "category": "account_management"
        }
      },
      {
        "config": {
          "key": "/myvaro/settings/marketingPushNotificationsDisabled",
          "name": "Marketing Push Notifications Disabled",
          "source_name": "notification_settings",
          "category": "account_management"
        }
      },
      {
        "config": {
          "key": "/myvaro/settings/transactionalPushNotificationsEnabled",
          "name": "Transactional Push Notification Enabled",
          "source_name": "notification_settings",
          "category": "account_management"
        }
      },
      {
        "config": {
          "key": "/myvaro/settings/transactionalPushNotificationsDisabled",
          "name": "Transactional Push Notification Disabled",
          "source_name": "notification_settings",
          "category": "account_management"
        }
      },
      {
        "config": {
          "key": "/believe/apply/believeCardClicked",
          "name": "Varo Believe Clicked",
          "source_name": "my_varo",
          "category": "varo_believe",
          "subcategory": "believe_intro"
        }
      },
      {
        "config": {
          "key": "/myvaro/help-and-support",
          "name": "Help and Support Clicked",
          "source_name": "my_varo",
          "category": "servicing",
          "subcategory": ""
        }
      },
      {
        "config": {
          "key": "/myvaro/legal-agreements",
          "name": "Legal Agreement Clicked",
          "source_name": "my_varo",
          "category": "account_management",
          "subcategory": ""
        }
      },
      {
        "config": {
          "key": "/myvaro/disputes",
          "name": "Disputes Clicked",
          "source_name": "my_varo",
          "category": "servicing",
          "subcategory": "dispute"
        }
      },
      {
        "config": {
          "key": "/myvaro/manage-accounts",
          "name": "Manage Account Clicked",
          "source_name": "my_varo",
          "category": "account_management",
          "subcategory": ""
        }
      },
      {
        "config": {
          "key": "/myvaro/manage-accounts/account-numbers/directDepositFlowInitiated",
          "name": "Direct Deposit Flow Initiated",
          "source_name": "account_numbers",
          "category": "direct_deposit"
        }
      },
      {
        "config": {
          "key": "/myvaro/manage-accounts/card-services",
          "name": "Card Services Clicked",
          "source_name": "manage_account",
          "category": "card",
          "subcategory": ""
        }
      },
      {
        "config": {
          "key": "/myvaro/referrals/shareLinkClicked",
          "name": "Referral Link Share Clicked",
          "category": "referral",
          "source_name": "referral_invite_page"
        }
      },
      {
        "config": {
          "key": "/myvaro/referrals/referralTermsClicked",
          "name": "Referral Terms Clicked",
          "category": "referral",
          "source_name": "referral_invite_page"
        }
      },
      {
        "config": {
          "key": "/myvaro/referrals/linkCopyClicked",
          "name": "Referral Link Copy Clicked",
          "category": "referral",
          "source_name": "referral_invite_page"
        }
      },
      {
        "config": {
          "key": "/referrals/shareLinkClicked",
          "name": "Referral Link Share Clicked",
          "category": "referral",
          "source_name": "referral_invite_page"
        }
      },
      {
        "config": {
          "key": "/referrals/referralTermsClicked",
          "name": "Referral Terms Clicked",
          "category": "referral",
          "source_name": "referral_invite_page"
        }
      },
      {
        "config": {
          "key": "/referrals/linkCopyClicked",
          "name": "Referral Link Copy Clicked",
          "category": "referral",
          "source_name": "referral_invite_page"
        }
      },
      {
        "config": {
          "key": "/move-money/direct-deposit",
          "name": "Direct Deposit Flow Initiated",
          "source_name": "account_number",
          "category": "move_money",
          "subcategory": "direct_deposit"
        }
      },
      {
        "config": {
          "key": "/myvaro/manage-accounts/external-accounts",
          "name": "External Accounts Clicked",
          "source_name": "manage_account",
          "category": "",
          "subcategory": ""
        }
      },
      {
        "config": {
          "key": "/myvaro/myVaroLogOutClicked",
          "name": "Log Out Clicked",
          "source_name": "my_varo",
          "category": "",
          "subcategory": ""
        }
      },
      {
        "config": {
          "key": "//deposit-check",
          "name": "Deposit Check",
          "source_name": "deposit_check",
          "category": "deposit",
          "subcategory": "check"
        }
      },
      {
        "config": {
          "key": "/believe/apply/howApply",
          "name": "Varo Believe Offer Clicked",
          "category": "varo_believe",
          "subcategory": "believe_application",
          "source_name": "believe_offer_page"
        }
      },
      {
        "config": {
          "key": "/believe/apply/qualify/addMoney",
          "name": "Transfer Money Clicked",
          "category": "transfer_money",
          "source_name": "believe_qualification_details"
        }
      },
      {
        "config": {
          "key": "/believe/apply/applyNow",
          "name": "Believe Application Flow Initiated",
          "category": "varo_believe",
          "subcategory": "believe_application",
          "source_name": "believe_offer_page"
        }
      },
      {
        "config": {
          "key": "/believe/apply/cardApplication/believeProgramAgreements",
          "name": "Varo Believe Program Agreement Checkbox Clicked",
          "category": "varo_believe",
          "subcategory": "believe_application",
          "source_name": "legal_agreements"
        }
      },
      {
        "config": {
          "key": "/believe/apply/cardApplication/rightsToObtainInformation",
          "name": "Varo Believe Credit Profile Agreement Checkbox Clicked",
          "category": "varo_believe",
          "subcategory": "believe_application",
          "source_name": "legal_agreements"
        }
      },
      {
        "config": {
          "key": "/believe/apply/cardApplication/grantInterest",
          "name": "Varo Believe Security Interest Agreement Checkbox Clicked",
          "category": "varo_believe",
          "subcategory": "believe_application",
          "source_name": "legal_agreements"
        }
      },
      {
        "config": {
          "key": "/believe/apply/cardApplication/safePay",
          "name": "Varo Believe SafePay Turn On Agreement Checkbox Clicked",
          "category": "varo_believe",
          "subcategory": "believe_application",
          "source_name": "legal_agreements"
        }
      },
      {
        "config": {
          "key": "/believe/apply/cardApplication/allCheckBox",
          "name": "Varo Believe All Agreements Checkbox Clicked",
          "category": "varo_believe",
          "subcategory": "believe_application",
          "source_name": "legal_agreements"
        }
      },
      {
        "config": {
          "key": "/believe/apply/cardApplication/submitApplication",
          "name": "Varo Believe Application Submitted",
          "category": "varo_believe",
          "subcategory": "believe_application",
          "source_name": "legal_agreements"
        }
      },
      {
        "config": {
          "key": "/believe/apply/addWallet/skipNow",
          "name": "Wallet Provisioning Skipped",
          "category": "card",
          "subcategory": "wallet_provisioning",
          "source_name": "believe_digital_card"
        }
      },
      {
        "config": {
          "key": "/believe/apply/moneyIn/skipNow",
          "name": "Transfer Money Skipped",
          "category": "transfer_money",
          "source_name": "believe_funding_page"
        }
      },
      {
        "config": {
          "key": "/believe/apply/moneyIn/moveMoney",
          "name": "Transfer Money Clicked",
          "category": "transfer_money",
          "source_name": "believe_funding_page"
        }
      },
      {
        "config": {
          "key": "/believe/apply/review/done",
          "name": "Go To Home Clicked",
          "category": "varo_believe",
          "subcategory": "believe_application",
          "source_name": "application_declined_page"
        }
      },
      {
        "config": {
          "key": "/believe/apply/cardApplicationError/done",
          "name": "Go To Home Clicked",
          "category": "varo_believe",
          "subcategory": "believe_application",
          "source_name": "application_in_review_page",
          "cta": "Done"
        }
      },
      {
        "config": {
          "key": "/believe/how-it-works/how-worksPressed",
          "name": "FAQs Clicked",
          "source_name": "charge_card_intro",
          "category": "varo_believe",
          "subcategory": "believe_intro"
        }
      },
      {
        "config": {
          "key": "/believe/how-it-works/how-works-pressed",
          "name": "FAQs Clicked",
          "source_name": "believe_intro",
          "category": "varo_believe",
          "subcategory": "believe_intro"
        }
      },
      {
        "config": {
          "key": "/believe/how-it-works/how-build-creditPressed",
          "name": "FAQs Clicked",
          "source_name": "believe_intro",
          "category": "varo_believe",
          "subcategory": "believe_intro"
        }
      },
      {
        "config": {
          "key": "/believe/how-it-works/card-benefitsPressed",
          "name": "FAQs Clicked",
          "source_name": "believe_intro",
          "category": "varo_believe",
          "subcategory": "believe_intro"
        }
      },
      {
        "config": {
          "key": "/believe/how-it-works/spending-limitPressed",
          "name": "FAQs Clicked",
          "source_name": "believe_intro",
          "category": "varo_believe",
          "subcategory": "believe_intro"
        }
      },
      {
        "config": {
          "key": "/believe/how-it-works/supportTopicsPressed",
          "name": "FAQs Clicked",
          "source_name": "believe_intro",
          "category": "varo_believe",
          "subcategory": "believe_intro"
        }
      },
      {
        "config": {
          "key": "/believe/how-it-works/how-build-credit/safePayOn",
          "name": "Charge Card SafePay Turned On",
          "source_name": "build_credit",
          "category": "varo_believe",
          "subcategory": "believe_intro"
        }
      },
      {
        "config": {
          "key": "/believe/how-it-works/how-works/linkText",
          "category": "varo_believe",
          "subcategory": "believe_intro",
          "source_name": "how_charge_card_works",
          "name": "FAQs Clicked"
        }
      },
      {
        "config": {
          "key": "/believe/how-it-works/how-works/safePayOn",
          "category": "varo_believe",
          "subcategory": "believe_intro",
          "name": "Charge Card SafePay Turned On",
          "source_name": "how_charge_card_works"
        }
      },
      {
        "config": {
          "key": "/believe/make-payment/bank_account",
          "name": "Payment Method Selected",
          "category": "varo_believe",
          "subcategory": "believe_disbursement",
          "source_name": "payment_methods_page"
        }
      },
      {
        "config": {
          "key": "/believe/make-payment/check",
          "name": "Payment Method Selected",
          "category": "varo_believe",
          "subcategory": "believe_disbursement",
          "source_name": "payment_methods_page"
        }
      },
      {
        "config": {
          "key": "/believe/make-payment/paymentCancel",
          "category": "varo_believe",
          "subcategory": "believe_disbursement",
          "name": "Payment Cancelled",
          "source_name": "payment_methods_page"
        }
      },
      {
        "config": {
          "key": "/accounts/manage-account/makePayment",
          "category": "varo_believe",
          "subcategory": "believe_disbursement",
          "name": "Manage Account Page",
          "source_name": "manage_account_page"
        }
      },
      {
        "config": {
          "key": "/believe/make-payment/schedulePayment/paymentError",
          "category": "varo_believe",
          "subcategory": "believe_disbursement",
          "name": "Manage Account Page",
          "source_name": "manage_account_page"
        }
      },
      {
        "config": {
          "key": "/believe/make-payment/schedulePayment/paymentSuccess",
          "category": "varo_believe",
          "subcategory": "believe_disbursement",
          "name": "Manage Account Page",
          "source_name": "manage_account_page"
        }
      },
      {
        "config": {
          "key": "/believe/make-payment/schedulePayment/retry",
          "category": "varo_believe",
          "subcategory": "believe_disbursement",
          "name": "Make Payment Clicked",
          "source_name": "payment_setup_failed"
        }
      },
      {
        "config": {
          "key": "/believe/make-payment/schedulePayment/selectDate",
          "category": "varo_believe",
          "subcategory": "believe_disbursement",
          "name": "Payment Date Selected",
          "source_name": "payment_methods_page"
        }
      },
      {
        "config": {
          "key": "/believe/make-payment/schedulePayment/believePaymentSuccess",
          "category": "varo_believe",
          "subcategory": "believe_disbursement",
          "name": "Payment Setup Completed"
        }
      },
      {
        "config": {
          "key": "/believe/make-payment/schedulePayment/payCardClick",
          "category": "varo_believe",
          "subcategory": "believe_disbursement",
          "name": "Payment Setup Submitted",
          "source_name": "payment_methods_page"
        }
      },
      {
        "config": {
          "key": "/believe/make-payment/schedulePayment/cancelClick",
          "category": "varo_believe",
          "subcategory": "believe_disbursement",
          "name": "Payment Cancelled",
          "source_name": "payment_setup_fail"
        }
      },
      {
        "config": {
          "key": "/accounts/[id]/moveYourPay",
          "category": "varo_believe",
          "subcategory": "move_your_pay",
          "name": "Move Your Pay Clicked",
          "source_name": "account_page"
        }
      },
      {
        "config": {
          "key": "/accounts/[id]/payCardClick",
          "category": "varo_believe",
          "account_type": "charge_card",
          "subcategory": "believe_disbursement",
          "name": "Make Payment Clicked",
          "source_name": "account_page"
        }
      },
      {
        "config": {
          "key": "/accounts/[id]/chargeCardViewCard",
          "category": "card",
          "card_type": "charge_card",
          "name": "View Card Clicked",
          "source_name": "debit_card_not_active"
        }
      },
      {
        "config": {
          "key": "/accounts/[id]/chargeCardViewCard",
          "category": "card",
          "card_type": "charge_card",
          "name": "View Card Clicked",
          "source_name": "debit_card_not_active"
        }
      },
      {
        "config": {
          "key": "/accounts/[id]/cardBalance",
          "category": "varo_believe",
          "subcategory": "believe_management",
          "name": "Manage Account Clicked",
          "source_name": "account_page"
        }
      },
      {
        "config": {
          "key": "/open-savings/applicationSubmitted",
          "name": "Savings Account Application Submitted",
          "source_name": "savings_account_application",
          "category": "application",
          "subcategory": "savings"
        }
      },
      {
        "config": {
          "key": "/open-savings/openVaroSavingTermAccepted",
          "name": "Backup Withholding Terms Checkbox Clicked",
          "source_name": "savings_account_application",
          "category": "application",
          "subcategory": "savings"
        }
      },
      {
        "config": {
          "key": "/open-savings/openSavingsApproved",
          "name": "Savings Account Application Approved",
          "source_name": "savings_account_application",
          "category": "application",
          "subcategory": "savings"
        }
      },
      {
        "config": {
          "key": "/open-savings/fund-savings-account/transferFund",
          "name": "Transfer Money Clicked",
          "source_name": "savings_account_funding",
          "category": "savings",
          "subcategory": ""
        }
      },
      {
        "config": {
          "key": "/open-savings/fund-savings-account/skipNow",
          "name": "Savings Account Funding Skipped",
          "source_name": "savings_account_funding",
          "category": "savings",
          "subcategory": ""
        }
      },
      {
        "config": {
          "key": "/accounts/current-apy/faqClicked",
          "name": "FAQs Clicked",
          "source_name": "current_apy_qualification_details",
          "category": "savings",
          "subcategory": ""
        }
      },
      {
        "config": {
          "key": "/move-money/mobileCheckDepositClicked",
          "name": "Mobile Check Deposit Clicked",
          "source_name": "move_money_page",
          "category": "mobile_check_deposit",
          "subcategory": ""
        }
      },
      {
        "config": {
          "key": "/move-money/check-deposit/rdcCaptureInitiated",
          "name": "RDC Capture Initiated",
          "source_name": "mobile_check_deposit",
          "category": "mobile_check_deposit",
          "subcategory": ""
        }
      },
      {
        "config": {
          "key": "/move-money/check-deposit/faqsClicked",
          "name": "FAQs Clicked",
          "source_name": "mobile_check_deposit",
          "faq_name": "mobile_check_deposit",
          "category": "mobile_check_deposit",
          "subcategory": ""
        }
      },
      {
        "config": {
          "key": "/move-money/check-deposit/fundsAvailabilityNoticeAccessed",
          "name": "Funds Availability Notice Accessed",
          "source_name": "mobile_check_deposit",
          "category": "mobile_check_deposit",
          "subcategory": ""
        }
      },
      {
        "config": {
          "key": "/move-money/check-deposit/amount/checkDepositAmountEntered",
          "name": "Check Deposit Amount Entered",
          "source_name": "check_deposit_amount",
          "category": "mobile_check_deposit",
          "subcategory": ""
        }
      },
      {
        "config": {
          "key": "/move-money/v2a/transfer/V2aTransferAmountEntered",
          "name": "V2A Amount Entered",
          "source_name": "v2a_enter_amount",
          "category": "v2a",
          "subcategory": "transfer_money_v2a_sender"
        }
      },
      {
        "config": {
          "key": "/move-money/v2a/transfer-success/V2aTransferSubmissionSuccessful",
          "name": "V2A Submission Successful",
          "source_name": "v2a_submission_successful",
          "category": "v2a",
          "subcategory": "transfer_money_v2a_sender"
        }
      },
      {
        "config": {
          "key": "/move-money/v2a/transfer-success/V2aTransferReceived",
          "name": "V2A Received",
          "source_name": "v2a_transfer_received",
          "category": "v2a",
          "subcategory": "transfer_money_v2a_sender"
        }
      },
      {
        "config": {
          "key": "/move-money/v2a/transfer-success/V2aHeadsUp",
          "name": "V2A Head Up Acknowledged",
          "source_name": "v2a_heads_up",
          "category": "v2a",
          "subcategory": "transfer_money_v2a_sender"
        }
      },
      {
        "config": {
          "key": "/move-money/v2a/transfer-success/V2aTransferReceived",
          "name": "V2A Received",
          "source_name": "v2a_submission_successful",
          "category": "v2a",
          "subcategory": "transfer_money_v2a_sender"
        }
      },
      {
        "config": {
          "key": "/payments/[token]/v2aReceiverSignupClicked",
          "name": "Signup Clicked",
          "category": "application",
          "subcategory": "checking",
          "source_name": "V2A Receiver Landing Page"
        }
      },
      {
        "config": {
          "key": "/payments/[token]/v2aReceiverErrorEncountered",
          "name": "V2A Receiver Flow Error Encountered",
          "category": "v2a",
          "subcategory": "transfer_money_v2a_receiver"
        }
      },
      {
        "config": {
          "key": "/payments-detail/v2aPaymentDetailsErrorEncountered",
          "name": "V2A Receiver Flow Error Encountered",
          "category": "v2a",
          "subcategory": "transfer_money_v2a_receiver"
        }
      },
      {
        "config": {
          "key": "/payments-confirmation/v2aReceiverTransferSuccessful",
          "name": "V2A Transfer Successful",
          "category": "v2a",
          "subcategory": "transfer_money_v2a_receiver"
        }
      },
      {
        "config": {
          "key": "/payments-confirmation/v2aReceiverTransferSignupClicked",
          "name": "Signup Clicked",
          "category": "application",
          "subcategory": "checking",
          "source_name": "v2a_transfer_successful"
        }
      },
      {
        "config": {
          "key": "/payments/[token]/transferToDifferentBankClicked",
          "name": "Cash Out With Debit Card Clicked",
          "category": "v2a",
          "subcategory": "transfer_money_v2a_receiver"
        }
      },
      {
        "config": {
          "key": "/payments/[token]/v2aReceiverFlowInitiated",
          "name": "V2A Receiver Flow Initiated",
          "category": "v2a",
          "subcategory": "transfer_money_v2a_receiver"
        }
      },
      {
        "config": {
          "key": "/payments-detail/v2aFirstNameClicked",
          "name": "First Name Field Clicked",
          "category": "v2a",
          "subcategory": "transfer_money_v2a_receiver"
        }
      },
      {
        "config": {
          "key": "/payments-detail/v2aLastNameClicked",
          "name": "Last Name Field Clicked",
          "category": "v2a",
          "subcategory": "transfer_money_v2a_receiver"
        }
      },
      {
        "config": {
          "key": "/payments-detail/v2aEmailFieldClicked",
          "name": "Email Field Clicked",
          "category": "v2a",
          "subcategory": "transfer_money_v2a_receiver"
        }
      },
      {
        "config": {
          "key": "/payments-detail/v2aDebitCardFieldClicked",
          "name": "Debit Card Number Field Clicked",
          "category": "v2a",
          "subcategory": "transfer_money_v2a_receiver"
        }
      },
      {
        "config": {
          "key": "/payments-detail/v2aCardExpirationDateFieldClicked",
          "name": "Card Expiration Date Field Clicked",
          "category": "v2a",
          "subcategory": "transfer_money_v2a_receiver"
        }
      },
      {
        "config": {
          "key": "/payments-detail/v2aCVVFieldClicked",
          "name": "CVV Field Clicked",
          "category": "v2a",
          "subcategory": "transfer_money_v2a_receiver"
        }
      },
      {
        "config": {
          "key": "/payments-detail/v2aZipFieldClicked",
          "name": "Zip Code Field Clicked",
          "category": "v2a",
          "subcategory": "transfer_money_v2a_receiver"
        }
      },
      {
        "config": {
          "key": "/payments-detail/v2aAgreementCheckboxClicked",
          "name": "V2A Agreement Checkbox Clicked",
          "category": "v2a",
          "subcategory": "transfer_money_v2a_receiver"
        }
      },
      {
        "config": {
          "key": "/payments-detail/v2aMarketingCheckboxClicked",
          "name": "V2A Marketing Opt-in Checkbox Clicked",
          "category": "v2a",
          "subcategory": "transfer_money_v2a_receiver"
        }
      },
      {
        "config": {
          "key": "/payments-detail/v2aTermsAndConditionAccess",
          "name": "Terms And Conditions Accessed",
          "category": "v2a",
          "subcategory": "transfer_money_v2a_receiver"
        }
      },
      {
        "config": {
          "key": "/payments-detail/v2aReceiverSubmitted",
          "name": "V2A Receiver Submitted",
          "category": "v2a",
          "subcategory": "transfer_money_v2a_receiver"
        }
      },
      {
        "config": {
          "key": "/move-money/check-deposit/amount/checkDepositAccountSelected",
          "name": "Check Deposit Account Selected",
          "source_name": "check_deposit_input_amount",
          "category": "mobile_check_deposit",
          "subcategory": ""
        }
      },
      {
        "config": {
          "key": "/move-money/check-deposit/capture/rdcCheckFrontImageCaptured",
          "name": "RDC Check Front Image Captured",
          "source_name": "rdc_front",
          "category": "mobile_check_deposit",
          "subcategory": ""
        }
      },
      {
        "config": {
          "key": "/move-money/check-deposit/capture-front/rdcCaptureExited",
          "name": "RDC Capture Exited",
          "category": "mobile_check_deposit",
          "source_name": "rdc_front",
          "subcategory": ""
        }
      },
      {
        "config": {
          "key": "/move-money/check-deposit/capture-back/rdcCaptureExited",
          "name": "RDC Capture Exited",
          "category": "mobile_check_deposit",
          "source_name": "rdc_back",
          "subcategory": ""
        }
      },
      {
        "config": {
          "key": "/move-money/check-deposit/review/rdcCaptureExited",
          "name": "RDC Capture Exited",
          "category": "mobile_check_deposit",
          "subcategory": ""
        }
      },
      {
        "config": {
          "key": "/move-money/check-deposit/capture/rdcCheckBackImageCaptured",
          "name": "RDC Check Back Image Captured",
          "source_name": "rdc_back",
          "category": "mobile_check_deposit",
          "subcategory": ""
        }
      },
      {
        "config": {
          "key": "/move-money/check-deposit/capture/rdcCheckRetakePhotoClicked",
          "name": "RDC Check Retake Photo Clicked",
          "category": "mobile_check_deposit",
          "subcategory": ""
        }
      },
      {
        "config": {
          "key": "/move-money/check-deposit/capture/rdcUsePhotoClicked",
          "name": "RDC Use Photo Clicked",
          "category": "mobile_check_deposit",
          "subcategory": ""
        }
      },
      {
        "config": {
          "key": "/move-money/check-deposit/review/checkDepositAmountEditClicked",
          "name": "Check Deposit Amount Edit Clicked",
          "source_name": "check_deposit_confirm",
          "category": "mobile_check_deposit",
          "subcategory": ""
        }
      },
      {
        "config": {
          "key": "/move-money/check-deposit/review/checkFrontImageRetakeClicked",
          "name": "Check Front Image Retake Clicked",
          "source_name": "check_deposit_confirm",
          "category": "mobile_check_deposit",
          "subcategory": ""
        }
      },
      {
        "config": {
          "key": "/move-money/check-deposit/review/checkBackImageRetakeClicked",
          "name": "Check Back Image Retake Clicked",
          "source_name": "check_deposit_confirm",
          "category": "mobile_check_deposit",
          "subcategory": ""
        }
      },
      {
        "config": {
          "key": "/move-money/check-deposit/review/rdcCheckSubmitted",
          "name": "RDC Check Submitted",
          "category": "mobile_check_deposit",
          "subcategory": ""
        }
      },
      {
        "config": {
          "key": "/move-money/check-deposit/review/goToHomeClicked",
          "name": "Go To Home Clicked",
          "category": "mobile_check_deposit",
          "subcategory": ""
        }
      },
      {
        "config": {
          "key": "/move-money/check-deposit/review/mobileCheckDepositClicked",
          "name": "Mobile Check Deposit Clicked",
          "category": "mobile_check_deposit",
          "subcategory": ""
        }
      },
      {
        "config": {
          "key": "/move-money/check-deposit/review/rdcCheckReviewClicked",
          "name": "RDC Check Review Clicked",
          "source_name": "check_deposit_error",
          "category": "mobile_check_deposit",
          "subcategory": ""
        }
      },
      {
        "config": {
          "key": "/help/loginIssueClicked",
          "name": "FAQs Clicked",
          "source_name": "login_help",
          "category": "login"
        }
      },
      {
        "config": {
          "key": "/help/faqIssueClicked",
          "name": "FAQs Clicked",
          "source_name": "login_help",
          "category": "login"
        }
      },
      {
        "config": {
          "key": "/help/contactUsClicked",
          "name": "FAQs Clicked",
          "source_name": "login_help",
          "category": "login"
        }
      },
      {
        "config": {
          "key": "/otp/error/tryAgainClicked",
          "name": "Find Account Clicked",
          "source_name": "account_finding_error_encountered",
          "subcategory": "forgot_password",
          "category": "login"
        }
      },
      {
        "config": {
          "key": "/reset-password/email-review/getErrorMessage",
          "name": "Account Finding Error Encountered",
          "subcategory": "forgot_password",
          "category": "login",
          "source_name": ""
        }
      },
      {
        "config": {
          "key": "/reset-password/email-review/emailFieldClicked",
          "name": "Email Field Clicked",
          "source_name": "forgot_password_page",
          "subcategory": "forgot_password",
          "category": "login"
        }
      },
      {
        "config": {
          "key": "/reset-password/email-review/nextClicked",
          "name": "Find Account Clicked",
          "source_name": "forgot_password_page",
          "subcategory": "forgot_password",
          "category": "login"
        }
      },
      {
        "config": {
          "key": "/reset-password/checkemail/resendClick",
          "name": "Verification Code Requested",
          "subcategory": "forget_password",
          "source_name": "email_otp_page",
          "category": "login"
        }
      },
      {
        "config": {
          "key": "/reset-password/checkemail/emailClick",
          "name": "Reset Password Go To Email",
          "subcategory": "forget_password",
          "source_name": "email_otp_page",
          "category": "login"
        }
      },
      {
        "config": {
          "key": "/reset-password/confirm-identity/setupPresented",
          "name": "Step Up Challenge Presented",
          "source_name": "",
          "category": "login",
          "subcategory": "forget_password"
        }
      },
      {
        "config": {
          "key": "/reset-password/confirm-identity/emailSelected",
          "name": "Step Up Challenge Selected",
          "source_name": "forgot_password_challenge",
          "category": "login",
          "subcategory": "forget_password"
        }
      },
      {
        "config": {
          "key": "/reset-password/confirm-identity/phoneSelected",
          "name": "Step Up Challenge Selected",
          "source_name": "forgot_password_challenge",
          "category": "login",
          "subcategory": "forget_password"
        }
      },
      {
        "config": {
          "key": "/reset-password/confirm-identity/noSelected",
          "name": "Step Up Challenge Method No Access",
          "source_name": "forgot_password_challenge",
          "category": "login",
          "subcategory": "forget_password"
        }
      },
      {
        "config": {
          "key": "/reset-password/enter-otp/resendClick",
          "name": "Verification Code Requested",
          "source_name": "sms_otp_page",
          "category": "login",
          "subcategory": "forgot_password"
        }
      },
      {
        "config": {
          "key": "/reset-password/enter-otp/nextButtonClicked",
          "name": "Verification Code Submitted",
          "source_name": "sms_otp_page",
          "category": "login",
          "subcategory": "forgot_password"
        }
      },
      {
        "config": {
          "key": "/reset-password/enter-otp/verificationFailed",
          "name": "Verification Failed",
          "source_name": "sms_otp_page",
          "category": "login",
          "subcategory": "forgot_password"
        }
      },
      {
        "config": {
          "key": "/otp/error/verificationFailed",
          "name": "Verification Failed",
          "source_name": "sms_otp_page",
          "category": "login",
          "subcategory": "forgot_password"
        }
      },
      {
        "config": {
          "key": "/reset-password/set-password/newPasswordFieldClicked",
          "name": "New Password Field Clicked",
          "source_name": "created_password_page",
          "category": "login",
          "subcategory": "forgot_password"
        }
      },
      {
        "config": {
          "key": "/reset-password/set-password/confirmPasswordFieldClicked",
          "name": "Confirm New Password Field Clicked",
          "source_name": "created_password_page",
          "category": "login",
          "subcategory": "forgot_password"
        }
      },
      {
        "config": {
          "key": "/reset-password/set-password/nextButtonClicked",
          "name": "Reset Password Requested Submitted",
          "source_name": "created_password_page",
          "category": "login",
          "subcategory": "forgot_password"
        }
      },
      {
        "config": {
          "key": "/reset-password/success/doneButtonClicked",
          "name": "Go To Home Clicked",
          "source_name": "password_updated_page",
          "category": "login",
          "subcategory": "forgot_password"
        }
      },
      {
        "config": {
          "key": "/reset-password/success/signedIn",
          "name": "Signed In",
          "source_name": "login_page",
          "category": "login",
          "subcategory": "forgot_password"
        }
      },
      {
        "config": {
          "key": "/reset-password/success/resetPasswordCompleted",
          "name": "Reset Password Completed",
          "source_name": "reset_password_completed_page",
          "category": "login",
          "subcategory": "forgot_password"
        }
      },
      {
        "config": {
          "key": "/reset-password/set-password/resetPasswordError",
          "name": "Reset Password Failed",
          "source_name": "reset_password_completed_page",
          "subcategory": "forgot_password",
          "category": "login"
        }
      },
      {
        "config": {
          "key": "/reset-password/find-account/emailFieldClicked",
          "name": "Email Field Clicked",
          "source_name": "forgot_password_page",
          "subcategory": "forgot_password",
          "category": "login"
        }
      },
      {
        "config": {
          "key": "/reset-password/find-account/nextClicked",
          "name": "Find Account Clicked",
          "source_name": "forgot_password_page",
          "subcategory": "forgot_password",
          "category": "login"
        }
      },
      {
        "config": {
          "key": "/myvaro/card/replace-lost-stolen/replace-card/[cardId]/cardLostClicked",
          "name": "Lost/Stolen Card Reason Selected",
          "source_name": "card_services",
          "subcategory": "replacement_card",
          "category": "card"
        }
      },
      {
        "config": {
          "key": "/accounts/[id]/pillNavigation",
          "name": "Transaction Insights Clicked",
          "category": "CHECKING",
          "source_name": "account_page",
          "account_type": "CHECKING"
        }
      },
      {
        "config": {
          "key": "/myvaro/card/replace-lost-stolen/replace-card/[cardId]/cardStolenClicked",
          "name": "Lost/Stolen Card Reason Selected",
          "source_name": "card_services",
          "subcategory": "replacement_card",
          "category": "card"
        }
      },
      {
        "config": {
          "key": "/myvaro/card/replace-lost-stolen/replace-card/[cardId]/cardStolenClicked",
          "name": "Lost/Stolen Card Reason Selected",
          "source_name": "card_services",
          "subcategory": "replacement_card",
          "category": "card"
        }
      },
      {
        "config": {
          "key": "/myvaro/card/replace-lost-stolen/replace-card/[cardId]/orderPhysicalCardClicked",
          "name": "Order Physical Card Confirmed",
          "source_name": "card_services",
          "subcategory": "replacement_card",
          "category": "card"
        }
      },
      {
        "config": {
          "key": "/myvaro/card/replace-lost-stolen/new-card/orderPhysicalCardExitClicked",
          "name": "Order Physical Card Flow Exited",
          "source_name": "card_services",
          "subcategory": "replacement_card",
          "category": "card"
        }
      },
      {
        "config": {
          "key": "/accounts/[id]/transfer",
          "name": "Transfer Money Clicked",
          "source_name": "account_page",
          "subcategory": "smart_ledger",
          "category": ""
        }
      },
      {
        "config": {
          "key": "/accounts/[id]/addMoney",
          "name": "Transfer Money Clicked",
          "source_name": "account_page",
          "category": "transfer_money"
        }
      },
      {
        "config": {
          "key": "/rewards/nearby-offers/[id]/offerGetDirectionClicked",
          "name": "Offer Get Direction Clicked",
          "category": "rewards"
        }
      },
      {
        "config": {
          "key": "/rewards/[id]/incentiveTermsClicked",
          "name": "Offer Terms Clicked",
          "category": "incentive",
          "source_name": "incentive_offer"
        }
      },
      {
        "config": {
          "key": "/rewards/rewardsPageError",
          "name": "Rewards Flow Error Encountered",
          "category": "rewards",
          "source_name": "rewards_page"
        }
      },
      {
        "config": {
          "key": "/rewards/categories/categoryPageError",
          "name": "Rewards Flow Error Encountered",
          "category": "rewards",
          "source_name": "offer_type_page"
        }
      },
      {
        "config": {
          "key": "/rewards/[id]/partnerOfferPageError",
          "name": "Rewards Flow Error Encountered",
          "category": "rewards",
          "source_name": "partner_offer_details_page"
        }
      },
      {
        "config": {
          "key": "/rewards/nearby-offers/map/offer-location-pin-selected",
          "name": "Offer Location Pin Selected",
          "source_name": "cashback_nearby",
          "category": "rewards"
        }
      },
      {
        "config": {
          "key": "/rewards/nearbyMapSelected",
          "name": "Nearby Map Selected",
          "source_name": "rewards_page_map",
          "category": "rewards",
          "offer_bracket": "nearby"
        }
      },
      {
        "config": {
          "key": "/rewards/nearby-offers/map/offer-pin-selected",
          "name": "Offer Location Pin Selected",
          "source_name": "rewards_map",
          "category": "rewards"
        }
      },
      {
        "config": {
          "key": "/rewards/nearby-offers/map/offer-activate-clicked",
          "name": "Offer Activate Clicked",
          "source_name": "rewards_map",
          "category": "rewards"
        }
      },
      {
        "config": {
          "key": "/rewards/nearby-offers/map/offer-type-selected",
          "name": "Offer Type Selected",
          "source_name": "rewards_map",
          "category": "rewards"
        }
      },
      {
        "config": {
          "key": "/rewards/nearby-offers/map/offer-list-view-selected",
          "name": "Offer List View Selected",
          "source_name": "rewards_map",
          "category": "rewards"
        }
      },
      {
        "config": {
          "key": "/rewards/nearby-offers/map/offer-map-view-selected",
          "name": "Offer Map View Selected",
          "source_name": "rewards_map",
          "category": "rewards"
        }
      },
      {
        "config": {
          "key": "/rewards/nearby-offers/map/partner-offer-selected",
          "name": "Partner Offer Selected",
          "source_name": "cashback_nearby",
          "category": "rewards"
        }
      },
      {
        "config": {
          "key": "/rewards/self-funded-offers/offer-selection/offerActivationError",
          "name": "Cashback Offer Activation Error Encountered",
          "subcategory": "self_funded",
          "category": "rewards",
          "error_count": "error_count"
        }
      },
      {
        "config": {
          "key": "/rewards/upside-offers/[merchantId]/deactivateOffer",
          "name": "Offer Deactivation Successful",
          "category": "rewards",
          "source_name": "offer_activated_page"
        }
      },
      {
        "config": {
          "key": "/myvaro/card/new-pin/[cardId]/pinSetSubmitted",
          "name": "PIN Set Request Submitted",
          "category": "card",
          "source_name": "create_pin_page",
          "card_type": ""
        }
      },
      {
        "config": {
          "key": "/myvaro/card/change-pin/[cardId]/pinSetSubmitted",
          "name": "PIN Set Request Submitted",
          "category": "card",
          "source_name": "create_pin_page",
          "card_type": ""
        }
      },
      {
        "config": {
          "key": "/myvaro/card/activate-card-success/setPinClicked",
          "name": "Set PIN Clicked",
          "category": "card",
          "source_name": "card_activated_page",
          "subcategory": "card_activation"
        }
      },
      {
        "config": {
          "key": "/myvaro/card/activate-card-success/setPinSkipped",
          "name": "Set PIN Skipped",
          "category": "card",
          "source_name": "card_activated_page",
          "subcategory": "card_activation"
        }
      },
      {
        "config": {
          "key": "/myvaro/card/new-pin/[cardId]/cardActivationSuccessful",
          "name": "Card Activation Successful",
          "category": "card",
          "subcategory": "card_activation",
          "card_type": ""
        }
      },
      {
        "config": {
          "key": "/myvaro/card/activate-card-success/goToManageCardClicked",
          "name": "Go To Manage Card Clicked",
          "category": "card",
          "source_name": "pin_set_completed",
          "subcategory": ""
        }
      },
      {
        "config": {
          "key": "/accounts/[id]/manageAccountIcon",
          "name": "Manage Account Clicked",
          "category": "account_management"
        }
      },
      {
        "config": {
          "key": "/accounts/[id]/manageAccountClicked",
          "name": "Manage Account Clicked",
          "category": "varo_advance",
          "source_name": "account_page"
        }
      },
      {
        "config": {
          "key": "/varo-line-of-credit/confirm-payment/vlocRepaymentSubmitted",
          "name": "VLOC Repayment Submitted",
          "category": "vloc",
          "subcategory": "vloc_repayment",
          "source_name": "vloc_repayment_submission",
          "amount": ""
        }
      },
      {
        "config": {
          "key": "/varo-line-of-credit/confirm-payment/vlocRepaymentSuccessfulTrack",
          "name": "VLOC Repayment Successful",
          "category": "vloc",
          "subcategory": "vloc_repayment"
        }
      },
      {
        "config": {
          "key": "/varo-line-of-credit/repayment-success/repaymentGoToHome",
          "name": "Go To Home Clicked",
          "category": "vloc",
          "subcategory": "vloc_repayment",
          "source_name": "vloc_repayment_successful"
        }
      },
      {
        "config": {
          "key": "/myvaro/personal-details/change-address/changeAddressSubmit",
          "name": "Home Address Saved",
          "category": "vloc",
          "source_name": "edit_home_address_page",
          "subcategory": "vloc_application"
        }
      },
      {
        "config": {
          "key": "/myvaro/personal-details/change-password/confirm-password/changePasswordCompletedOnPersonalDetails",
          "name": "Change Password Completed",
          "category": "profile_settings",
          "source_name": "change_password_page"
        }
      },
      {
        "config": {
          "key": "/myvaro/personal-details/change-password/confirm-password/resetPasswordFailedInPersonalDetails",
          "name": "Reset Password Failed",
          "category": "profile_settings",
          "source_name": "change_password_page"
        }
      },
      {
        "config": {
          "key": "/varo-line-of-credit/line-of-credit-entry-point-screen/errorButtonPress",
          "name": "VLOC Application Flow Error Encountered",
          "category": "vloc",
          "subcategory": "vloc_repayment",
          "source_name": "vloc_error_encountered",
          "cta": "done"
        }
      },
      {
        "config": {
          "key": "/rewards/offerTypeSelected",
          "name": "Offer Type Selected",
          "category": "rewards",
          "source_name": "rewards_page"
        }
      },
      {
        "config": {
          "key": "/rewards/viewAllCategoriesClicked",
          "name": "View All Categories Clicked",
          "category": "rewards",
          "source_name": "rewards_page"
        }
      },
      {
        "config": {
          "key": "/accounts/[id]/infoIcon",
          "name": "Information Icon Clicked",
          "account_type": "",
          "category": ""
        }
      },
      {
        "config": {
          "key": "/rewards/categories/categoryOfferTypeSelected",
          "name": "Offer Type Selected",
          "category": "rewards",
          "source_name": "offer_type_page"
        }
      },
      {
        "config": {
          "key": "/rewards/partnerOfferSelected",
          "name": "Partner Offer Selected",
          "category": "rewards",
          "source_name": "rewards_page"
        }
      },
      {
        "config": {
          "key": "/rewards/cashback/cashbackEarned/cashbackDetailClicked",
          "name": "Cashback Transaction Detail Clicked",
          "category": "rewards",
          "source_name": "cashback_management_page"
        }
      },
      {
        "config": {
          "key": "/rewards/cashback/cashbackEarned/cashbackFaqClicked",
          "name": "Cashback FAQs Clicked",
          "category": "rewards",
          "source_name": "cashback_management_page"
        }
      },
      {
        "config": {
          "key": "/rewards/cashbackFaqClicked",
          "name": "Cashback FAQs Clicked",
          "category": "rewards",
          "source_name": "rewards_page"
        }
      },
      {
        "config": {
          "key": "/accounts/[id]/smartViewCategory",
          "name": "Transaction Insights Category Clicked",
          "account_type": "",
          "category": ""
        }
      },
      {
        "config": {
          "key": "/accounts/[id]/moveMoney",
          "name": "Transfer Money Clicked",
          "category": ""
        }
      },
      {
        "config": {
          "key": "/accounts/[id]/viewCard",
          "name": "View Card Clicked",
          "category": ""
        }
      },
      {
        "config": {
          "key": "/perkTabClicked",
          "name": "Perks Tab Button Clicked",
          "category": "rewards",
          "source_name": "home_page"
        }
      },
      {
        "config": {
          "key": "/rewards/my-offers/cashbackFaqsClicked",
          "name": "Cashback FAQs Clicked",
          "category": "rewards",
          "source_name": "my_offers_page"
        }
      },
      {
        "config": {
          "key": "/myvaro/help/allTopics",
          "name": "FAQs Clicked",
          "category": "servicing",
          "source_name": "help_and_support",
          "subcategory": ""
        }
      },
      {
        "config": {
          "key": "/myvaro/help/chatWithUs",
          "name": "Support Chat Initiated",
          "category": "servicing",
          "source_name": "help_and_support",
          "subcategory": "chat"
        }
      },
      {
        "config": {
          "key": "/myvaro/help/chat/chatSessionStarted",
          "name": "Support Chat Session Started",
          "category": "servicing",
          "source_name": "varo_chat",
          "subcategory": "chat"
        }
      },
      {
        "config": {
          "key": "/myvaro/help/chatSessionEnded",
          "name": "Support Chat Session Ended",
          "category": "servicing",
          "source_name": "varo_chat",
          "subcategory": "chat"
        }
      },
      {
        "config": {
          "key": "/myvaro/help/chat/exitChat",
          "name": "Support Chat Exited",
          "category": "servicing",
          "source_name": "varo_chat",
          "subcategory": "chat"
        }
      },
      {
        "config": {
          "key": "/myvaro/help/supportCall",
          "name": "Support Call Initiated",
          "category": "servicing",
          "source_name": "help_and_support",
          "subcategory": ""
        }
      },
      {
        "config": {
          "key": "/myvaro/help/depositMoney",
          "name": "FAQs Clicked",
          "category": "servicing",
          "source_name": "help_and_support",
          "subcategory": ""
        }
      },
      {
        "config": {
          "key": "/myvaro/help/depositCheck",
          "name": "FAQs Clicked",
          "category": "servicing",
          "source_name": "help_and_support",
          "subcategory": ""
        }
      },
      {
        "config": {
          "key": "/myvaro/help/debitCardSpendingLimit",
          "name": "FAQs Clicked",
          "category": "servicing",
          "source_name": "help_and_support",
          "subcategory": ""
        }
      },
      {
        "config": {
          "key": "/myvaro/help/call-us/fileADispute",
          "name": "Support Call Clicked",
          "category": "servicing",
          "source_name": "call_us",
          "subcategory": "dispute"
        }
      },
      {
        "config": {
          "key": "/myvaro/help/call-us/setupMobileWallet",
          "name": "Support Call Clicked",
          "category": "servicing",
          "source_name": "call_us",
          "subcategory": "wallet_provisioning"
        }
      },
      {
        "config": {
          "key": "/myvaro/help/chat/startChatClicked",
          "name": "Support Chat Clicked",
          "category": "servicing",
          "source_name": "varo_chat",
          "subcategory": "chat"
        }
      },
      {
        "config": {
          "key": "/myvaro/help/chat/endChatClicked",
          "name": "Support End Chat Clicked",
          "category": "servicing",
          "source_name": "varo_chat",
          "subcategory": "chat"
        }
      },
      {
        "config": {
          "key": "/myvaro/help/chat/submitFeedbackClicked",
          "name": "Chat Survey Feedback Submitted",
          "category": "servicing",
          "source_name": "help_and_support",
          "subcategory": "chat"
        }
      },
      {
        "config": {
          "key": "/myvaro/help/chat/dismissSurvey",
          "name": "Chat Survey Dismissed",
          "category": "servicing",
          "source_name": "help_and_support",
          "subcategory": "chat"
        }
      },
      {
        "config": {
          "key": "/myvaro/help/chat/thumbsUpDownRating",
          "name": "Chat Survey Feedback Selected",
          "category": "servicing",
          "source_name": "help_and_support",
          "subcategory": "chat"
        }
      },
      {
        "config": {
          "key": "/myvaro/help/chat/starRating",
          "name": "Chat Survey Ratings Selected",
          "category": "servicing",
          "source_name": "help_and_support",
          "subcategory": "chat"
        }
      },
      {
        "config": {
          "key": "/myvaro/help/chat/lexBotOption",
          "name": "Support Chat Initiated",
          "category": "servicing",
          "source_name": "help_and_support",
          "subcategory": "chat"
        }
      },
      {
        "config": {
          "key": "/myvaro/card/[cardId]/viewCardNumber",
          "name": "Digital Card Number Viewed",
          "category": "card",
          "subcategory": "",
          "source_name": "card_services"
        }
      },
      {
        "config": {
          "key": "/myvaro/card/[cardId]/cardLockClicked",
          "name": "Card Lock Clicked",
          "subcategory": "",
          "category": "card",
          "source_name": "card_services"
        }
      },
      {
        "config": {
          "key": "/myvaro/card/[cardId]/cardUnlockClicked",
          "name": "Card Unlock Clicked",
          "subcategory": "",
          "category": "card",
          "source_name": "card_services"
        }
      },
      {
        "config": {
          "key": "/myvaro/card/[cardId]/setPinClicked",
          "name": "Set PIN Clicked",
          "subcategory": "",
          "category": "card",
          "source_name": "card_services"
        }
      },
      {
        "config": {
          "key": "/myvaro/card/[cardId]/orderPhysicalCardFlowInitiated",
          "name": "Order Physical Card Flow Initiated",
          "subcategory": "card_replacement",
          "category": "card",
          "source_name": "card_services",
          "cta": "Report lost or stolen card"
        }
      },
      {
        "config": {
          "key": "/accounts/manage-account/checkingNickNameUpdate",
          "name": "Checking Account Nickname Updated",
          "category": "checking",
          "source_name": "manage_account_page"
        }
      },
      {
        "config": {
          "key": "/accounts/manage-account/savingsNickNameUpdate",
          "name": "Savings Account Nickname Updated",
          "category": "savings",
          "source_name": "manage_account_page"
        }
      },
      {
        "config": {
          "key": "/accounts/manage-account/showAccountNumberSwitch",
          "source_name": "manage_account_page",
          "name": "Show Account Number Turned On",
          "category": ""
        }
      },
      {
        "config": {
          "key": "/login/InstantStartAuthError",
          "name": "Instant Authentication Initialization",
          "source_name": "",
          "category": "login",
          "subcategory": ""
        }
      },
      {
        "config": {
          "key": "/login/TokenGenerationError",
          "name": "Instant Auth Selected",
          "source_name": "",
          "category": "login",
          "subcategory": ""
        }
      },
      {
        "config": {
          "key": "/login/AuthenticationPossibleSuccess",
          "name": "Instant Authentication Possible",
          "source_name": "",
          "category": "login",
          "subcategory": ""
        }
      },
      {
        "config": {
          "key": "/login/AuthenticationInitializationSuccess",
          "name": "Instant Authentication Initialization",
          "source_name": "",
          "category": "login",
          "subcategory": ""
        }
      },
      {
        "config": {
          "key": "/login/AuthenticationStarted",
          "name": "Instant Authentication Started",
          "source_name": "",
          "category": "login",
          "subcategory": ""
        }
      },
      {
        "config": {
          "key": "/login/AuthenticationCompletedError",
          "name": "Instant Authentication Completed",
          "source_name": "",
          "category": "login",
          "subcategory": ""
        }
      },
      {
        "config": {
          "key": "/login/AuthenticationCompletedSuccess",
          "name": "Instant Authentication Completed",
          "source_name": "",
          "category": "login",
          "subcategory": ""
        }
      },
      {
        "config": {
          "key": "/login/AuthenticationPhoneURLCapturedError",
          "name": "Instant Authentication Phone URL Captured",
          "source_name": "",
          "category": "login",
          "subcategory": ""
        }
      },
      {
        "config": {
          "key": "/login/AuthenticationPhoneURLCapturedSuccess",
          "name": "Instant Authentication Phone URL Captured",
          "source_name": "",
          "category": "login",
          "subcategory": ""
        }
      },
      {
        "config": {
          "key": "/login/emailFieldClicked",
          "name": "Username Field Clicked",
          "source_name": "login_page",
          "category": "login"
        }
      },
      {
        "config": {
          "key": "/accounts/manage-account/routingNumberCopy",
          "name": "Routing Number Copied",
          "category": "",
          "source_name": "manage_account_page"
        }
      },
      {
        "config": {
          "key": "/login/passwordFieldClicked",
          "name": "Password Field Clicked",
          "source_name": "login_page",
          "category": "login"
        }
      },
      {
        "config": {
          "key": "/accounts/manage-account/accountNumberCopy",
          "name": "Account Number Copied",
          "category": "",
          "source_name": "manage_account_page"
        }
      },
      {
        "config": {
          "key": "/login/passwordMaskClicked",
          "name": "Password Mask Clicked",
          "source_name": "login_page",
          "category": "login"
        }
      },
      {
        "config": {
          "key": "/accounts/manage-account/currentAPYClicked",
          "name": "Current APY Clicked",
          "category": "savings",
          "source_name": "manage_account_page"
        }
      },
      {
        "config": {
          "key": "/login/signupClicked",
          "name": "Signup Clicked",
          "source_name": "login_page",
          "subcategory": "checking",
          "category": "application"
        }
      },
      {
        "config": {
          "key": "/login/helpClicked",
          "name": "Help Clicked",
          "source_name": "login_page",
          "category": "login"
        }
      },
      {
        "config": {
          "key": "/login/shownBiometric",
          "name": "Biometric Login Method Shown",
          "source_name": "login_page",
          "category": "login"
        }
      },
      {
        "config": {
          "key": "/accounts/manage-account/availableBalance",
          "name": "Available Balance Tooltip Clicked",
          "category": "",
          "source_name": "manage_account_page"
        }
      },
      {
        "config": {
          "key": "/accounts/manage-account/totalBalance",
          "name": "Total Balance Tooltip Clicked",
          "category": "",
          "source_name": "manage_account_page"
        }
      },
      {
        "config": {
          "key": "/accounts/manage-account/currentBalance",
          "name": "Current Balance Tooltip Clicked",
          "category": "",
          "source_name": "manage_account_page"
        }
      },
      {
        "config": {
          "key": "/login/forgotPasswordClicked",
          "name": "Forgot Password Clicked",
          "source_name": "login_page",
          "category": "login",
          "subcategory": "forgot_password"
        }
      },
      {
        "config": {
          "key": "/login/loginClicked",
          "name": "Login Submitted",
          "source_name": "login_page",
          "category": "login"
        }
      },
      {
        "config": {
          "key": "/accounts/manage-account/manageCardClick",
          "name": "Manage Card Clicked",
          "category": "card",
          "source_name": "manage_account_page"
        }
      },
      {
        "config": {
          "key": "/accounts/manage-account/believeManageCardClick",
          "name": "Make Payment Clicked",
          "category": "varo_believe",
          "source_name": "account_page",
          "subcategory": "believe_disbursement"
        }
      },
      {
        "config": {
          "key": "/accounts/manage-account/creditBuildingClick",
          "name": "FAQs Clicked",
          "source_name": "manage_account_page",
          "category": "varo_believe"
        }
      },
      {
        "config": {
          "key": "/login/signedIn",
          "name": "Signed In",
          "source_name": "login_page",
          "category": "login"
        }
      },
      {
        "config": {
          "key": "/accounts/manage-account/paymentHistoryClick",
          "name": "Payment History Clicked",
          "source_name": "manage_account_page",
          "category": "varo_believe",
          "subcategory": "believe_disbursement"
        }
      },
      {
        "config": {
          "key": "/accounts/manage-account/removeAccountClick",
          "name": "Remove Account Clicked",
          "source_name": "manage_account_page",
          "category": "external_account"
        }
      },
      {
        "config": {
          "key": "/accounts/manage-account/savingTrackerClick",
          "name": "High APY Tracker Clicked",
          "source_name": "account_page",
          "category": "savings",
          "subcategory": "savings_high_apy"
        }
      },
      {
        "config": {
          "key": "/accounts/manage-account/cardBasics",
          "name": "FAQs Clicked",
          "source_name": "manage_account_page",
          "category": "varo_believe",
          "subcategory": "believe_intro"
        }
      },
      {
        "config": {
          "key": "/login/loginFailed",
          "name": "Login Failed",
          "source_name": "login_page",
          "category": "login"
        }
      },
      {
        "config": {
          "key": "/login/loginPreconditionFailed",
          "name": "Login Precondition Failed",
          "source_name": "login_precondition_failed",
          "category": "login"
        }
      },
      {
        "config": {
          "key": "/accounts/savings-tracker/ctaClicked",
          "name": "Direct Deposit Flow Initiated",
          "source_name": "high_apy_checklist_page",
          "category": "savings",
          "subcategory": "savings_high_apy"
        }
      },
      {
        "config": {
          "key": "/accounts/savings-tracker/savingFaqClicked",
          "name": "FAQs Clicked",
          "source_name": "high_apy_checklist_page",
          "category": "savings",
          "subcategory": "savings_high_apy"
        }
      },
      {
        "config": {
          "key": "/accounts/[id]/transactionViewed",
          "name": "Transaction Viewed",
          "source_name": "account_page",
          "category": ""
        }
      },
      {
        "config": {
          "key": "/signup/signupStepStarted",
          "name": "Registration Step Started",
          "category": "application",
          "subcategory": "checking",
          "source_name": ""
        }
      },
      {
        "config": {
          "key": "/signup/emailFieldClicked",
          "name": "Email Field Clicked",
          "category": "application",
          "subcategory": "checking",
          "source_name": "signup_page"
        }
      },
      {
        "config": {
          "key": "/signup/phoneFieldClicked",
          "name": "Phone Field Clicked",
          "category": "application",
          "subcategory": "checking",
          "source_name": "signup_page"
        }
      },
      {
        "config": {
          "key": "/signup/passwordFieldClicked",
          "name": "Password Field Clicked",
          "category": "application",
          "subcategory": "checking",
          "source_name": "signup_page"
        }
      },
      {
        "config": {
          "key": "/signup/passwordMaskClicked",
          "name": "Password Mask Clicked",
          "category": "application",
          "subcategory": "checking",
          "source_name": "signup_page"
        }
      },
      {
        "config": {
          "key": "/signup/agreementClicked",
          "name": "Origination Legal Telephone Agreement Checked",
          "category": "application",
          "subcategory": "checking",
          "source_name": "signup_page"
        }
      },
      {
        "config": {
          "key": "/signup/signedIn",
          "name": "Signed In",
          "source_name": "signup_page",
          "category": "login"
        }
      },
      {
        "config": {
          "key": "/login/verify-device/signedIn",
          "name": "Signed In",
          "category": "login",
          "source_name": "device_otp_page",
          "verification_type": "device"
        }
      },
      {
        "config": {
          "key": "/login/verify-sms/signedIn",
          "name": "Signed In",
          "category": "login",
          "source_name": "sms_otp_page",
          "verification_type": "phone"
        }
      },
      {
        "config": {
          "key": "/login/verify-email/signedIn",
          "name": "Signed In",
          "category": "login",
          "source_name": "email_otp_page",
          "verification_type": "email"
        }
      },
      {
        "config": {
          "key": "/login/verify-email-code/signedIn",
          "name": "Signed In",
          "category": "login",
          "source_name": "email_otp_page",
          "verification_type": "email"
        }
      },
      {
        "config": {
          "key": "/login/verify-identity/resendMagicLink",
          "name": "Resend link clicked",
          "category": "login",
          "source_name": "magic_link"
        }
      },
      {
        "config": {
          "key": "/login/verify-identity-error/goToLogin",
          "name": "Go to login clicked",
          "category": "login",
          "source_name": "magic_link"
        }
      },
      {
        "config": {
          "key": "/login/verify-identity-error/contactUs",
          "name": "Contact us clicked",
          "category": "login",
          "source_name": "magic_link"
        }
      },
      {
        "config": {
          "key": "/signup/verify-device/signedIn",
          "name": "Signed In",
          "category": "login",
          "source_name": "device_otp_page",
          "verification_type": "device"
        }
      },
      {
        "config": {
          "key": "/signup/verify-sms/signedIn",
          "name": "Signed In",
          "category": "login",
          "source_name": "sms_otp_page",
          "verification_type": "phone"
        }
      },
      {
        "config": {
          "key": "/signup/verify-email/signedIn",
          "name": "Signed In",
          "category": "login",
          "source_name": "email_otp_page",
          "verification_type": "email"
        }
      },
      {
        "config": {
          "key": "/signup/verify-email-code/signedIn",
          "name": "Signed In",
          "category": "login",
          "source_name": "email_otp_page",
          "verification_type": "email"
        }
      },
      {
        "config": {
          "key": "/signup/acquisitionCaptured",
          "name": "Acquisition Captured",
          "category": "application",
          "subcategory": "checking",
          "source_name": "signup_page"
        }
      },
      {
        "config": {
          "key": "/signup/createAccountCompleted",
          "name": "Registration Step Completed",
          "category": "application",
          "subcategory": "checking",
          "source_name": ""
        }
      },
      {
        "config": {
          "key": "/signup/applicationFlowErrorEncountered",
          "name": "Application Flow Error Encountered",
          "category": "application",
          "subcategory": "checking",
          "source_name": ""
        }
      },
      {
        "config": {
          "key": "/signup/verify-device/resendClicked",
          "name": "Verification Code Requested",
          "category": "login",
          "source_name": "device_otp_page"
        }
      },
      {
        "config": {
          "key": "/signup/verify-device/verificationSuccessful",
          "name": "Verification Successful",
          "category": "login",
          "source_name": "device_otp_page"
        }
      },
      {
        "config": {
          "key": "/signup/verify-device/verificationFailed",
          "name": "Verification Failed",
          "category": "login",
          "source_name": "device_otp_page"
        }
      },
      {
        "config": {
          "key": "/signup/verify-device/verificationCodeSubmitted",
          "name": "Verification Code Submitted",
          "category": "login",
          "source_name": "device_otp_page"
        }
      },
      {
        "config": {
          "key": "/signup/verify-sms/verificationCodeSubmitted",
          "name": "Verification Code Submitted",
          "category": "login",
          "source_name": "sms_otp_page",
          "verification_type": "phone"
        }
      },
      {
        "config": {
          "key": "/signup/verify-sms/resendClickedNewCode",
          "name": "Verification Code Requested",
          "category": "login",
          "source_name": "sms_otp_page"
        }
      },
      {
        "config": {
          "key": "/signup/verify-sms/verificationSuccessful",
          "name": "Verification Successful",
          "category": "login",
          "source_name": "sms_otp_page"
        }
      },
      {
        "config": {
          "key": "/signup/verify-sms/phoneVerificationFailed",
          "name": "Verification Failed",
          "category": "login",
          "source_name": "sms_otp_page"
        }
      },
      {
        "config": {
          "key": "/signup/verify-sms/verifyStepStarted",
          "name": "Registration Step Started",
          "category": "application",
          "subcategory": "checking",
          "source_name": ""
        }
      },
      {
        "config": {
          "key": "/signup/verify-sms/smsManuallyEntered",
          "name": "Verification Code Submitted",
          "category": "application",
          "subcategory": "checking",
          "source_name": "phone_number_verification"
        }
      },
      {
        "config": {
          "key": "/signup/verify-sms/resendClicked",
          "name": "Verification Code Requested",
          "category": "application",
          "subcategory": "checking",
          "source_name": "phone_number_verification"
        }
      },
      {
        "config": {
          "key": "/signup/verify-sms/otpVerifyCompleted",
          "name": "Registration Step Completed",
          "category": "application",
          "subcategory": "checking",
          "source_name": ""
        }
      },
      {
        "config": {
          "key": "/signup/verify-sms/verificationFailed",
          "name": "Verification Failed",
          "source_name": "otp_page",
          "category": "application",
          "subcategory": "checking"
        }
      },
      {
        "config": {
          "key": "/signup/verify-email/enterCodeClicked",
          "name": "Enter Code Clicked",
          "category": "login",
          "source_name": "email_otp_page"
        }
      },
      {
        "config": {
          "key": "/signup/verify-email/verificationCodeSubmitted",
          "name": "Verification Code Submitted",
          "category": "login",
          "source_name": "email_otp_page"
        }
      },
      {
        "config": {
          "key": "/signup/verify-email-code/verifyStepStarted",
          "name": "Registration Step Started",
          "category": "application",
          "subcategory": "checking",
          "source_name": ""
        }
      },
      {
        "config": {
          "key": "/signup/verify-email-code/emailVerifyCompleted",
          "name": "Registration Step Completed",
          "category": "application",
          "subcategory": "checking",
          "source_name": ""
        }
      },
      {
        "config": {
          "key": "/signup/verify-email-code/verificationCodeSubmitted",
          "name": "Verification Code Submitted",
          "category": "login",
          "source_name": "email_otp_page"
        }
      },
      {
        "config": {
          "key": "/signup/verify-email-code/resendClickedLogin",
          "name": "Verification Code Requested",
          "category": "login",
          "source_name": "email_otp_page"
        }
      },
      {
        "config": {
          "key": "/signup/verify-email-code/resendClicked",
          "name": "Verification Code Requested",
          "category": "application",
          "source_name": "email_otp_page"
        }
      },
      {
        "config": {
          "key": "/signup/verify-email-code/verificationSuccessful",
          "name": "Verification Successful",
          "category": "login",
          "source_name": "email_otp_page"
        }
      },
      {
        "config": {
          "key": "/signup/verify-email-code/verificationFailed",
          "name": "Verification Failed",
          "source_name": "email_otp_page",
          "category": "login"
        }
      },
      {
        "config": {
          "key": "/signup/verify-email-code/resendClickedNewCode",
          "name": "Verification Code Requested",
          "category": "login",
          "source_name": "email_otp_page",
          "verification_type": "email"
        }
      },
      {
        "config": {
          "key": "/signup/personal-information/stepStarted",
          "name": "Registration Step Started",
          "category": "application",
          "subcategory": "checking",
          "source_name": ""
        }
      },
      {
        "config": {
          "key": "/signup/personal-information/firstNameFieldClicked",
          "name": "First Name Field Clicked",
          "category": "application",
          "subcategory": "checking",
          "source_name": "personal_info_name"
        }
      },
      {
        "config": {
          "key": "/signup/personal-information/lastNameFieldClicked",
          "name": "Last Name Field Clicked",
          "category": "application",
          "subcategory": "checking",
          "source_name": "personal_info_name"
        }
      },
      {
        "config": {
          "key": "/signup/personal-information/personalInformationCompleted",
          "name": "Registration Step Completed",
          "category": "application",
          "subcategory": "checking",
          "source_name": ""
        }
      },
      {
        "config": {
          "key": "/signup/address-collection/stepStarted",
          "name": "Registration Step Started",
          "category": "application",
          "subcategory": "checking",
          "source_name": ""
        }
      },
      {
        "config": {
          "key": "/signup/address-collection/addressFieldClicked",
          "name": "Address Field Clicked",
          "category": "application",
          "subcategory": "checking",
          "source_name": "personal_info_address"
        }
      },
      {
        "config": {
          "key": "/signup/address-collection/addressDropDownSelected",
          "name": "Address Dropdown Selected",
          "category": "application",
          "subcategory": "checking",
          "source_name": "personal_info_address"
        }
      },
      {
        "config": {
          "key": "/signup/address-collection/addressEnterManuallyClicked",
          "name": "Address Enter Manually Clicked",
          "category": "application",
          "subcategory": "checking",
          "source_name": "personal_info_address"
        }
      },
      {
        "config": {
          "key": "/signup/address-collection/manualAddressSelected",
          "name": "Manual Address Selected",
          "category": "application",
          "subcategory": "checking",
          "source_name": "personal_info_address"
        }
      },
      {
        "config": {
          "key": "/signup/address-collection/addressEnterManually",
          "name": "Manual Address Confirmed",
          "category": "application",
          "subcategory": "checking",
          "source_name": "personal_info_address"
        }
      },
      {
        "config": {
          "key": "/signup/address-collection/addressFormSubmitted",
          "name": "Address Form Submitted",
          "category": "application",
          "subcategory": "checking",
          "source_name": "personal_info_address"
        }
      },
      {
        "config": {
          "key": "/signup/address-collection/addressCollectionCompleted",
          "name": "Registration Step Completed",
          "category": "application",
          "subcategory": "checking",
          "source_name": ""
        }
      },
      {
        "config": {
          "key": "/signup/address-collection/editInvalidAddressClicked",
          "name": "Edit Address Clicked",
          "category": "application",
          "subcategory": "checking",
          "source_name": "invalid_address"
        }
      },
      {
        "config": {
          "key": "/signup/address-collection/editAddressClicked",
          "name": "Edit Address Clicked",
          "category": "application",
          "subcategory": "checking",
          "source_name": "personal_info_address"
        }
      },
      {
        "config": {
          "key": "/signup/dob/stepStarted",
          "name": "Registration Step Started",
          "category": "application",
          "subcategory": "checking",
          "source_name": ""
        }
      },
      {
        "config": {
          "key": "/signup/dob/dobClicked",
          "name": "DOB Field Clicked",
          "category": "application",
          "subcategory": "checking",
          "source_name": "personal_info_dob"
        }
      },
      {
        "config": {
          "key": "/signup/dob/dobCompleted",
          "name": "Registration Step Completed",
          "category": "application",
          "subcategory": "checking",
          "source_name": ""
        }
      },
      {
        "config": {
          "key": "/signup/employment/stepStarted",
          "name": "Registration Step Started",
          "category": "application",
          "subcategory": "checking",
          "source_name": ""
        }
      },
      {
        "config": {
          "key": "/signup/employment/employmentSelected",
          "name": "Employment Selected",
          "category": "application",
          "subcategory": "checking",
          "source_name": ""
        }
      },
      {
        "config": {
          "key": "/signup/employment/employmentStepCompleted",
          "name": "Registration Step Completed",
          "category": "application",
          "subcategory": "checking",
          "source_name": ""
        }
      },
      {
        "config": {
          "key": "/signup/citizenship/stepStarted",
          "name": "Registration Step Started",
          "category": "application",
          "subcategory": "checking",
          "source_name": ""
        }
      },
      {
        "config": {
          "key": "/signup/citizenship/citizenshipSelected",
          "name": "Citizenship Selected",
          "category": "application",
          "subcategory": "checking",
          "source_name": ""
        }
      },
      {
        "config": {
          "key": "/signup/citizenship/citizenshipStepCompleted",
          "name": "Registration Step Completed",
          "category": "application",
          "subcategory": "checking",
          "source_name": ""
        }
      },
      {
        "config": {
          "key": "/signup/verify-ssn/stepStarted",
          "name": "Registration Step Started",
          "category": "application",
          "subcategory": "checking",
          "source_name": ""
        }
      },
      {
        "config": {
          "key": "/signup/verify-ssn/ssnFieldClicked",
          "name": "SSN Field Clicked",
          "category": "application",
          "subcategory": "checking",
          "source_name": "ssn_verification"
        }
      },
      {
        "config": {
          "key": "/signup/verify-ssn/ssnMaskClicked",
          "name": "SSN Mask Clicked",
          "category": "application",
          "subcategory": "checking",
          "source_name": "ssn_verification"
        }
      },
      {
        "config": {
          "key": "/signup/verify-ssn/ssnVerificationCompleted",
          "name": "Registration Step Completed",
          "category": "application",
          "subcategory": "checking",
          "source_name": ""
        }
      },
      {
        "config": {
          "key": "/signup/legal/stepStarted",
          "name": "Registration Step Started",
          "category": "application",
          "subcategory": "checking",
          "source_name": ""
        }
      },
      {
        "config": {
          "key": "/signup/legal/reviewClicked",
          "name": "Origination Legal Agreements Review Clicked",
          "source_name": "legal_agreements",
          "subcategory": "checking",
          "category": "application"
        }
      },
      {
        "config": {
          "key": "/signup/legal/communicationCheckboxClicked",
          "name": "Original Bank Account Agreement Checkbox Clicked",
          "source_name": "legal_agreements",
          "subcategory": "checking",
          "category": "application"
        }
      },
      {
        "config": {
          "key": "/signup/legal/generalTermsAndConditionsCheckboxClicked",
          "name": "Origination General Terms Agreement Checkbox Checked",
          "source_name": "legal_agreements",
          "subcategory": "checking",
          "category": "application"
        }
      },
      {
        "config": {
          "key": "/signup/legal/savingAccountAgreementCheckboxClicked",
          "name": "Savings Account Agreement Checkbox Clicked",
          "source_name": "legal_agreements",
          "subcategory": "checking",
          "category": "application"
        }
      },
      {
        "config": {
          "key": "/signup/legal/agreeToAllClicked",
          "name": "Origination All Legal Agreements Checkbox Clicked",
          "source_name": "legal_agreements",
          "subcategory": "checking",
          "category": "application"
        }
      },
      {
        "config": {
          "key": "/signup/legal/applyClicked",
          "name": "Application Submitted",
          "source_name": "legal_agreements",
          "subcategory": "checking",
          "category": "application"
        }
      },
      {
        "config": {
          "key": "/signup/legal/completedLegalAgreement",
          "name": "Registration Step Completed",
          "subcategory": "checking",
          "category": "application",
          "source_name": ""
        }
      },
      {
        "config": {
          "key": "/signup/application-decision/verifyClicked",
          "name": "Identity Verification Flow Initiated",
          "subcategory": "checking",
          "category": "application",
          "source_name": "application_decision"
        }
      },
      {
        "config": {
          "key": "/signup/application-decision/statusChanged",
          "name": "Application Submission Status",
          "subcategory": "checking",
          "category": "application",
          "source_name": ""
        }
      },
      {
        "config": {
          "key": "/signup/application-decision/applicationAutoApproved",
          "name": "Application Auto Approved",
          "subcategory": "checking",
          "category": "application",
          "source_name": ""
        }
      },
      {
        "config": {
          "key": "/signup/application-decision/mobileAppDownLoad",
          "name": "Mobile App Download",
          "category": "onboarding",
          "subcategory": "onboarding_wizard",
          "source_name": ""
        }
      },
      {
        "config": {
          "key": "/signup/application-decision/downloadAppButtonClicked",
          "name": "Mobile App Download Link Requested",
          "category": "onboarding",
          "subcategory": "onboarding_wizard",
          "source_name": "application_approved_page"
        }
      },
      {
        "config": {
          "key": "/signup/application-decision/signedIn",
          "name": "Signed In",
          "source_name": "application_auto_approved",
          "category": "login"
        }
      },
      {
        "config": {
          "key": "/signup/application-decision/applicationDeclined",
          "name": "Application Declined",
          "subcategory": "checking",
          "category": "application",
          "source_name": ""
        }
      },
      {
        "config": {
          "key": "/signup/edd-questions/nextButtonClicked",
          "name": "Banking Survey Submitted",
          "source_name": "banking_survey",
          "category": "application"
        }
      },
      {
        "config": {
          "key": "/depositTrackerClicked",
          "name": "Direct Deposit Flow Initiated",
          "category": "direct_deposit",
          "source_name": "home_page",
          "subcategory": "deposit_tracker"
        }
      },
      {
        "config": {
          "key": "/creditTrackerClicked",
          "name": "Credit Tracker Clicked",
          "category": "direct_deposit",
          "source_name": "home_page",
          "subcategory": "deposit_tracker"
        }
      },
      {
        "config": {
          "key": "/linkedAccountClicked",
          "name": "Linked Account Tile Clicked",
          "source_name": "home_page",
          "category": "varo_home"
        }
      },
      {
        "config": {
          "key": "/manageExternalAccountClicked",
          "name": "External Accounts Clicked",
          "source_name": "home_page",
          "category": "varo_home"
        }
      },
      {
        "config": {
          "key": "/receiverContactClicked",
          "name": "V2A Receiver Contact Selected",
          "source_name": "home_page",
          "category": "v2a",
          "subcategory": "transfer_money_v2a_sender"
        }
      },
      {
        "config": {
          "key": "/newContactClicked",
          "name": "V2A Receiver New Contact Clicked",
          "source_name": "home_page",
          "category": "v2a",
          "subcategory": "transfer_money_v2a_sender"
        }
      },
      {
        "config": {
          "key": "/v2aClicked",
          "name": "V2A Clicked",
          "source_name": "home_page",
          "category": "v2a",
          "subcategory": "transfer_money_v2a_sender"
        }
      },
      {
        "config": {
          "key": "/move-money/v2a/transfer-success/V2aTransferUnsuccessful",
          "name": "V2A Submission Unsuccessful",
          "source_name": "v2a_submission_unsuccessful",
          "category": "v2a",
          "subcategory": "transfer_money_v2a_sender"
        }
      },
      {
        "config": {
          "key": "/depositTrackerClicked",
          "name": "Direct Deposit Flow Initiated",
          "source_name": "home_page",
          "category": "direct_deposit",
          "subcategory": "deposit_tracker"
        }
      },
      {
        "config": {
          "key": "/linkAccountClicked",
          "name": "Link Account Tile Clicked",
          "source_name": "home_page",
          "category": "varo_home"
        }
      },
      {
        "config": {
          "key": "/individualLinkedAccountClicked",
          "name": "Linked Account Tile Clicked",
          "source_name": "home_page",
          "category": "varo_home"
        }
      },
      {
        "config": {
          "key": "/referralClicked",
          "name": "Home Screen Invite Friends Clicked",
          "source_name": "home_page",
          "category": "referral"
        }
      },
      {
        "config": {
          "key": "/creditScoreSignupClicked",
          "name": "Credit Score Signup Clicked",
          "source_name": "home_page",
          "category": "credit_score"
        }
      },
      {
        "config": {
          "key": "/creditScoreTileClicked",
          "name": "Credit Score Tile Clicked",
          "source_name": "home_page",
          "category": "credit_score"
        }
      },
      {
        "config": {
          "key": "/savingsAccountCardClicked",
          "name": "Account Tile Clicked",
          "source_name": "home_page",
          "category": "varo_home"
        }
      },
      {
        "config": {
          "key": "/chargeCardAccountClicked",
          "name": "Account Tile Clicked",
          "source_name": "home_page",
          "category": "varo_home"
        }
      },
      {
        "config": {
          "key": "/checkingAccountCardClicked",
          "name": "Account Tile Clicked",
          "source_name": "home_page",
          "category": "varo_home"
        }
      },
      {
        "config": {
          "key": "/allRewardPressed",
          "name": "Partner Offer Selected",
          "source_name": "home_page",
          "category": "rewards"
        }
      },
      {
        "config": {
          "key": "/myvaro/personal-details/uploadPhotoClicked",
          "name": "Upload Photo Clicked",
          "source_name": "personal_details_page",
          "category": "profile_settings"
        }
      },
      {
        "config": {
          "key": "/myvaro/personal-details/mailingAddressDifferentChecked",
          "name": "Mailing address different - Checked",
          "category": "profile_settings",
          "source_name": "change_home_address"
        }
      },
      {
        "config": {
          "key": "/myvaro/personal-details/mailingAddressDifferentUnchecked",
          "name": "Mailing address different - Unchecked",
          "category": "profile_settings",
          "source_name": "change_home_address"
        }
      },
      {
        "config": {
          "key": "/myvaro/personal-details/changeHomeAndMailingAddressClicked",
          "name": "Edit Home And Mailing Address Clicked",
          "source_name": "personal_details_page",
          "category": "profile_settings"
        }
      },
      {
        "config": {
          "key": "/myvaro/personal-details/changeHomeAddressClicked",
          "name": "Edit Home Address Clicked",
          "source_name": "personal_details_page",
          "category": "profile_settings"
        }
      },
      {
        "config": {
          "key": "/myvaro/personal-details/changeMailingAddressClicked",
          "name": "Edit Mailing Address Clicked",
          "source_name": "personal_details_page",
          "category": "profile_settings"
        }
      },
      {
        "config": {
          "key": "/myvaro/personal-details/changeEmailAddressClicked",
          "name": "Edit Email Clicked",
          "source_name": "personal_details_page",
          "category": "profile_settings"
        }
      },
      {
        "config": {
          "key": "/myvaro/personal-details/change-email/confirm-email/emailOtpLimitExceeded",
          "name": "Email OTP Attempt Limit Exceeded",
          "category": "profile_settings"
        }
      },
      {
        "config": {
          "key": "/myvaro/personal-details/changePasswordClicked",
          "name": "Change Password Clicked",
          "source_name": "personal_details_page",
          "category": "profile_settings"
        }
      },
      {
        "config": {
          "key": "/myvaro/personal-details/faceIdEnabled",
          "name": "Biometrics Enabled",
          "source_name": "personal_details_page",
          "category": "profile_settings"
        }
      },
      {
        "config": {
          "key": "/myvaro/personal-details/faceIdDisabled",
          "name": "Biometrics Disabled",
          "source_name": "personal_details_page",
          "category": "profile_settings"
        }
      },
      {
        "config": {
          "key": "/myvaro/personal-details/change-address/saveHomeAddressClicked",
          "name": "Home address change submitted",
          "source_name": "change_home_address",
          "category": "profile_settings",
          "verification_type": "profile_settings"
        }
      },
      {
        "config": {
          "key": "/myvaro/personal-details/change-address/saveMailingAddressClicked",
          "name": "Mailing address change submitted",
          "source_name": "change_home_address",
          "category": "profile_settings",
          "verification_type": "profile_settings"
        }
      },
      {
        "config": {
          "key": "/myvaro/personal-details/homeAddressSuccessfullyChanged",
          "name": "Address Successfully Changed",
          "category": "profile_settings",
          "subcategory": "home_address_changed"
        }
      },
      {
        "config": {
          "key": "/myvaro/personal-details/mailingAddressSuccessfullyChanged",
          "name": "Address Successfully Changed",
          "source_name": "personal_details_page",
          "category": "profile_settings",
          "subcategory": "mailing_address_changed"
        }
      },
      {
        "config": {
          "key": "/myvaro/personal-details/homeAndMailingAddressSuccessfullyChanged",
          "name": "Address Successfully Changed",
          "source_name": "personal_details_page",
          "category": "profile_settings",
          "subcategory": "home_and_mailing_address_changed"
        }
      },
      {
        "config": {
          "key": "/myvaro/personal-details/change-email/changeEmailClicked",
          "name": "Email Change Submitted",
          "source_name": "change_email_page",
          "category": "profile_settings"
        }
      },
      {
        "config": {
          "key": "/myvaro/personal-details/change-email/confirm-email/resendEmailLinkClicked",
          "name": "Verification Code Requested",
          "source_name": "email_otp_page",
          "category": "profile_settings"
        }
      },
      {
        "config": {
          "key": "/myvaro/personal-details/change-password/currentPasswordSubmitted",
          "name": "Current Password Submitted",
          "source_name": "verify_current_password_page",
          "category": "profile_settings"
        }
      },
      {
        "config": {
          "key": "/myvaro/personal-details/change-password/confirm-password/newPasswordFieldFocused",
          "name": "New Password Field Clicked",
          "source_name": "change_password_page",
          "category": "profile_settings"
        }
      },
      {
        "config": {
          "key": "/myvaro/personal-details/change-password/confirm-password/confirmPasswordFieldFocused",
          "name": "Confirm New Password Field Clicked",
          "source_name": "change_password_page",
          "category": "profile_settings"
        }
      },
      {
        "config": {
          "key": "/myvaro/personal-details/change-password/confirm-password/resetPasswordClicked",
          "name": "Change Password Request Submitted",
          "source_name": "change_password_page",
          "category": "profile_settings"
        }
      },
      {
        "config": {
          "key": "/myvaro/personal-details/change-password/enter-code/resendClicked",
          "name": "Verification Code Requested",
          "source_name": "sms_otp_page",
          "category": "profile_settings"
        }
      },
      {
        "config": {
          "key": "/myvaro/personal-details/change-password/enter-code/verification-code-requested",
          "name": "Verification Code Requested",
          "source_name": "sms_otp_page",
          "category": "profile_settings"
        }
      },
      {
        "config": {
          "key": "/myvaro/personal-details/change-password/enter-code/verificationCodeSubmitted",
          "name": "Verification Code Submitted",
          "source_name": "sms_otp_page",
          "category": "profile_settings",
          "verification_type": "phone"
        }
      },
      {
        "config": {
          "key": "/myvaro/personal-details/change-password/enter-code/otp-failed-validation",
          "name": "Verification Failed",
          "category": "profile_settings",
          "source_name": "sms_otp_page"
        }
      },
      {
        "config": {
          "key": "/myvaro/personal-details/change-password/enter-code/verificationSuccessful",
          "name": "Verification Successful",
          "category": "profile_settings"
        }
      },
      {
        "config": {
          "key": "/myvaro/personal-details/change-email/enter-code/verification-code-requested",
          "name": "Verification Code Requested",
          "source_name": "sms_otp_page",
          "category": "profile_settings"
        }
      },
      {
        "config": {
          "key": "/myvaro/personal-details/change-email/enter-code/otp-failed-validation",
          "name": "Verification Failed",
          "category": "profile_settings",
          "source_name": "sms_otp_page"
        }
      },
      {
        "config": {
          "key": "/myvaro/personal-details/change-password/enter-code/smsManuallyEntered",
          "name": "Verification Code Submitted",
          "source_name": "sms_otp_page",
          "category": "profile_settings",
          "verification_type": "phone"
        }
      },
      {
        "config": {
          "key": "/move-money/v2a/transfer/v2aContactSelected",
          "name": "V2A Receiver Contact Selected",
          "source_name": "v2a_search_recipient",
          "category": "v2a",
          "subcategory": "transfer_money_v2a_sender"
        }
      },
      {
        "config": {
          "key": "/move-money/v2a/v2aContactSubmitted",
          "name": "V2A Receiver Contact Submitted",
          "source_name": "v2a_search_recipient",
          "category": "v2a",
          "subcategory": "transfer_money_v2a_sender"
        }
      },
      {
        "config": {
          "key": "/move-money/v2a/educationScreenButton",
          "name": "Contacts Access Clicked",
          "category": "v2a",
          "subcategory": "transfer_money_v2a_sender"
        }
      },
      {
        "config": {
          "key": "/move-money/v2a/transfer/educationScreenButton",
          "name": "Contacts Access Clicked",
          "category": "v2a",
          "subcategory": "transfer_money_v2a_sender"
        }
      },
      {
        "config": {
          "key": "/move-money/v2a/contactsAccessAllowed",
          "name": "Contacts Access Allowed",
          "category": "v2a",
          "source_name": "v2a_contacts_access_widget",
          "subcategory": "transfer_money_v2a_sender"
        }
      },
      {
        "config": {
          "key": "/move-money/v2a/contactsAccessDisallowed",
          "name": "Contacts Access Disallowed",
          "category": "v2a",
          "source_name": "v2a_contacts_access_widget",
          "subcategory": "transfer_money_v2a_sender"
        }
      },
      {
        "config": {
          "key": "/myvaro/personal-details/change-email/enter-code/verificationCodeSubmitted",
          "name": "Verification Code Submitted",
          "source_name": "sms_otp_page",
          "category": "profile_settings",
          "verification_type": "phone"
        }
      },
      {
        "config": {
          "key": "/move-money/transfer_history",
          "name": "Transfer History Clicked",
          "source_name": "move_money",
          "category": "transfer_money"
        }
      },
      {
        "config": {
          "key": "/move-money/mobile_deposit_history",
          "name": "Mobile Deposit History Clicked",
          "source_name": "move_money",
          "category": "mobile_deposit_check"
        }
      },
      {
        "config": {
          "key": "/move-money/v2a_transfer_history",
          "name": "V2A Transaction History Clicked",
          "source_name": "move_money",
          "category": "v2a"
        }
      },
      {
        "config": {
          "key": "/move-money/v2a/transfer-history/v2ATransactionViewed",
          "name": "V2A Transaction Viewed",
          "category": "v2a",
          "source_name": "v2a_history"
        }
      },
      {
        "config": {
          "key": "/move-money/v2a/transfer-details/v2ATransactionCancelled",
          "name": "V2A Transaction Cancellation Clicked",
          "category": "v2a",
          "source_name": "v2a_history_details"
        }
      },
      {
        "config": {
          "key": "/move-money/v2a/transfer-details/v2ATransactionCancellationSubmitted",
          "name": "V2A Transaction Cancellation Submitted",
          "category": "v2a",
          "source_name": "v2a_history_details"
        }
      },
      {
        "config": {
          "key": "/move-money/v2a/transfer/v2ATermsAndConditionsAccessed",
          "name": "Terms And Conditions Accessed",
          "category": "v2a",
          "subcategory": "transfer_money_v2a_sender",
          "source_name": "v2a_enter_amount"
        }
      },
      {
        "config": {
          "key": "/move-money/v2a/transfer/v2ATermsAndConditionsAccepted",
          "name": "V2A T&C Accepted",
          "category": "v2a",
          "subcategory": "transfer_money_v2a_sender",
          "source_name": "v2a_enter_amount"
        }
      },
      {
        "config": {
          "key": "/move-money/v2a/transfer/v2AFaqClicked",
          "name": "FAQs Clicked",
          "category": "v2a",
          "subcategory": "transfer_money_v2a_sender",
          "source_name": "v2a_enter_amount"
        }
      },
      {
        "config": {
          "key": "/move-money/v2a/transfer/v2ASubmitted",
          "name": "V2A Submitted",
          "category": "v2a",
          "subcategory": "transfer_money_v2a_sender",
          "source_name": "v2a_enter_amount"
        }
      },
      {
        "config": {
          "key": "/move-money/v2a/transfer/v2ACancelled",
          "name": "V2A Cancelled",
          "category": "v2a",
          "subcategory": "transfer_money_v2a_sender",
          "source_name": "v2a_enter_amount"
        }
      },
      {
        "config": {
          "key": "/move-money/v2a/transfer-details/v2ATransactionCancellationAborted",
          "name": "V2A Transaction Cancellation Aborted",
          "category": "v2a",
          "source_name": "v2a_history_details"
        }
      },
      {
        "config": {
          "key": "/move-money/v2a/transfer-details/v2ATransactionCancellationSuccessful",
          "name": "V2A Cancelled",
          "category": "v2a",
          "source_name": "v2a_history_details",
          "subcategory": "transfer_money_v2a_sender"
        }
      },
      {
        "config": {
          "key": "/move-money/v2a/transfer-details/v2ATransactionCancellationUnsuccessful",
          "name": "V2A Cancelled Unsuccessful",
          "category": "v2a",
          "source_name": "v2a_history_details",
          "subcategory": "transfer_money_v2a_sender"
        }
      },
      {
        "config": {
          "key": "/move-money/move_money_options",
          "name": "Move Money Options Clicked",
          "source_name": "move_money",
          "category": "transfer_money"
        }
      },
      {
        "config": {
          "key": "/myvaro/external-accounts/linkAccountClicked",
          "name": "Account Linking Initiated",
          "source_name": "external_account_management",
          "category": "",
          "cta": "Link an account"
        }
      },
      {
        "config": {
          "key": "/myvaro/external-accounts/LinkDebitCardClicked",
          "name": "Link Debit Card Clicked",
          "source_name": "linked_cards",
          "category": "link_external_debit_card"
        }
      },
      {
        "config": {
          "key": "/myvaro/external-accounts/ExternalCardClicked",
          "name": "External Card Clicked",
          "source_name": "linked_cards",
          "category": "link_external_debit_card"
        }
      },
      {
        "config": {
          "key": "/suspicious-transaction/customer_response_submitted",
          "name": "Customer Response Submitted",
          "source_name": "suspicious_transaction_review_page",
          "category": "suspicious_transaction"
        }
      },
      {
        "config": {
          "key": "/myvaro/external-accounts/externalAccountClicked",
          "name": "External Account Details Clicked",
          "source_name": "external_account_management",
          "category": ""
        }
      },
      {
        "config": {
          "key": "/myvaro/external-accounts/[id]/relinkNotificationBanner",
          "name": "Account Linking Initiated",
          "source_name": "external_account_management",
          "category": ""
        }
      },
      {
        "config": {
          "key": "/myvaro/external-accounts/[id]/moveMoneyExternalAccount",
          "name": "Transfer Money Clicked",
          "source_name": "external_account_management",
          "category": "transfer_money"
        }
      },
      {
        "config": {
          "key": "/myvaro/external-accounts/[cardId]/card-details/CardExpirationDateEditClicked",
          "name": "Card Expiration Date Edit Clicked",
          "source_name": "linked_card",
          "category": "link_external_debit_card"
        }
      },
      {
        "config": {
          "key": "/myvaro/external-accounts/[cardId]/card-details/EditAddressClicked",
          "name": "Edit Address Clicked",
          "source_name": "linked_card",
          "category": "profile_settings"
        }
      },
      {
        "config": {
          "key": "/myvaro/external-accounts/update-expiry-date/CardExpirationDateUpdateRequested",
          "name": "Card Expiration Date Update Requested",
          "source_name": "linked_card_expiration_date",
          "category": "link_external_debit_card"
        }
      },
      {
        "config": {
          "key": "/myvaro/external-accounts/[cardId]/card-details/LinkedCardRemoveClicked",
          "name": "Linked Card Remove Clicked",
          "source_name": "linked_card",
          "category": "link_external_debit_card"
        }
      },
      {
        "config": {
          "key": "/myvaro/external-accounts/[cardId]/card-details/LinkedCardRemoveConfirmed",
          "name": "Linked Card Remove Confirmed",
          "source_name": "linked_card",
          "category": "link_external_debit_card"
        }
      },
      {
        "config": {
          "key": "/myvaro/external-accounts/[cardId]/card-details/LinkedCardRemoveCancelled",
          "name": "Linked Card Remove Cancelled",
          "source_name": "linked_card",
          "category": "link_external_debit_card"
        }
      },
      {
        "config": {
          "key": "/myvaro/external-accounts/[cardId]/card-details/LinkedCardRemoveFailed",
          "name": "Linked Card Remove Failed",
          "source_name": "linked_card",
          "category": "link_external_debit_card"
        }
      },
      {
        "config": {
          "key": "/myvaro/external-accounts/update-expiry-date/CardExpirationDateUpdated",
          "name": "Card Expiration Date Updated",
          "source_name": "linked_card_expiration_date",
          "category": "link_external_debit_card"
        }
      },
      {
        "config": {
          "key": "/myvaro/external-accounts/update-expiry-date/UpdateCardExpirationDateError",
          "name": "Update Card Expiration Date Error Encountered",
          "source_name": "linked_card_expiration_date",
          "category": "link_external_debit_card"
        }
      },
      {
        "config": {
          "key": "/myvaro/external-accounts/update-expiry-date/debitCardInlineErrorEncountered",
          "name": "Debit Card Inline Error Encountered",
          "category": "link_external_debit_card",
          "subcategory": "va_day_0"
        }
      },
      {
        "config": {
          "key": "/myvaro/external-accounts/[cardId]/update-address/debitCardInlineErrorEncountered",
          "name": "Debit Card Inline Error Encountered",
          "category": "link_external_debit_card",
          "subcategory": "va_day_0"
        }
      },
      {
        "config": {
          "key": "/myvaro/external-accounts/[cardId]/update-address/addressDropdownSelected",
          "name": "Address Dropdown Selected",
          "source_name": "personal_info_address",
          "category": "profile_settings"
        }
      },
      {
        "config": {
          "key": "/myvaro/external-accounts/[cardId]/update-address/addressEnterManuallyClicked",
          "name": "Address Enter Manually Clicked",
          "source_name": "personal_info_address",
          "category": "profile_settings"
        }
      },
      {
        "config": {
          "key": "/myvaro/external-accounts/[cardId]/update-address/manualAddressSelected",
          "name": "Manual Address Selected",
          "source_name": "personal_info_address",
          "category": "profile_settings"
        }
      },
      {
        "config": {
          "key": "/myvaro/external-accounts/[cardId]/update-address/manualAddressConfirmed",
          "name": "Manual Address Confirmed",
          "source_name": "personal_info_address",
          "category": "profile_settings"
        }
      },
      {
        "config": {
          "key": "/myvaro/external-accounts/[cardId]/update-address/homeAddressSaved",
          "name": "Home Address Saved",
          "source_name": "personal_info_address",
          "category": "profile_settings"
        }
      },
      {
        "config": {
          "key": "/move-money/transfer/transfer-money/bottomSheetAccountSelect",
          "name": "Transfer Money Account Selected",
          "source_name": "transfer_money_amount",
          "category": "transfer_money"
        }
      },
      {
        "config": {
          "key": "/move-money/transfer/transfer-money/selectAccount",
          "name": "Transfer Money Select Account Clicked",
          "source_name": "transfer_money_amount",
          "category": "transfer_money"
        }
      },
      {
        "config": {
          "key": "/move-money/transfer/transfer-money/linkExternalAccount",
          "name": "Account Linking Initiated",
          "source_name": "transfer_money_amount",
          "cta": "Link an account",
          "category": "transfer_money"
        }
      },
      {
        "config": {
          "key": "/suspicious-transaction/transaction_declined_cancel",
          "name": "Order Physical Card Confirmed",
          "category": "card",
          "subcategory": "card_replacement",
          "source_name": "suspicious_transaction_review_page"
        }
      },
      {
        "config": {
          "key": "/suspicious-transaction/transaction_declined_dont_cancel",
          "name": "Order Physical Card Flow Exited",
          "category": "card",
          "subcategory": "card_replacement",
          "source_name": "suspicious_transaction_review_page"
        }
      },
      {
        "config": {
          "key": "/suspicious-transaction/transaction-result/suspicious_transaction_done",
          "name": "Go To Home Clicked",
          "category": ""
        }
      },
      {
        "config": {
          "key": "/credit-score/seeMyScoreClicked",
          "name": "Credit Score Monitoring Consent Submitted",
          "source_name": "credit_score_access_page",
          "category": ""
        }
      },
      {
        "config": {
          "key": "/credit-score/monitoringSuccessfulTriggered",
          "name": "Credit Score Monitoring Consent Successful",
          "source_name": "credit_score_access_page",
          "category": ""
        }
      },
      {
        "config": {
          "key": "/credit-score/tryAgainClicked",
          "name": "Credit Score Monitoring Consent Submitted",
          "source_name": "credit_score_monitoring_error_page",
          "category": ""
        }
      },
      {
        "config": {
          "key": "/credit-score/comeBackLaterClicked",
          "name": "Credit Score Monitoring Consent Flow Exited",
          "source_name": "credit_score_monitoring_error_page",
          "category": ""
        }
      },
      {
        "config": {
          "key": "/credit/about-credit-score/faqsClicked",
          "name": "FAQs Clicked",
          "source_name": "credit_score_details_page",
          "category": ""
        }
      },
      {
        "config": {
          "key": "/credit/about-credit-score/contactDisputeCenterClicked",
          "name": "Contact Transunion Dispute Center Clicked",
          "source_name": "credit_score_details_page",
          "category": ""
        }
      },
      {
        "config": {
          "key": "/accounts/[id]/safe-credit-builder/safePayOn",
          "name": "Charge Card SafePay Turned On",
          "account_type": "charge_card",
          "source_name": "manage_account_page",
          "category": ""
        }
      },
      {
        "config": {
          "key": "/move-money/direct-deposit/depositFlowInitiated",
          "name": "Direct Deposit Flow Initiated",
          "source_name": "direct_deposit_info",
          "category": "direct_deposit"
        }
      },
      {
        "config": {
          "key": "/move-money/direct-deposit/directDepositInstantSwitchInitiated",
          "name": "Direct Deposit Instant Switch Initiated",
          "source_name": "direct_deposit_info",
          "category": "direct_deposit"
        }
      },
      {
        "config": {
          "key": "/accounts/[id]/safe-credit-builder/safePayOff",
          "name": "Charge Card SafePay Turned Off",
          "account_type": "charge_card",
          "source_name": "manage_account_page",
          "category": ""
        }
      },
      {
        "config": {
          "key": "/move-money/direct-deposit/depositFormAccessed",
          "name": "Direct Deposit Form Accessed",
          "source_name": "direct_deposit_info",
          "category": "direct_deposit",
          "cta": "Send HR a direct deposit form"
        }
      },
      {
        "config": {
          "key": "/move-money/direct-deposit/formSubmissionClicked",
          "name": "Form Submission Clicked",
          "source_name": "direct_deposit_error_page",
          "category": "direct_deposit"
        }
      },
      {
        "config": {
          "key": "/move-money/direct-deposit/bankCopyPasteClicked",
          "name": "Bank Copy Paste Clicked",
          "source_name": "direct_deposit_error_page",
          "category": "direct_deposit"
        }
      },
      {
        "config": {
          "key": "/accounts/manage-account/statementAndDocumentClick",
          "name": "Statements and Documents Clicked",
          "category": "varo_believe",
          "source_name": "manage_account_page"
        }
      },
      {
        "config": {
          "key": "/move-money/direct-deposit/accountNumbersClicked",
          "name": "Account Numbers Clicked",
          "source_name": "direct_deposit_info",
          "category": "direct_deposit"
        }
      },
      {
        "config": {
          "key": "/move-money/direct-deposit/direct-deposit-form/sendForm",
          "name": "Direct Deposit Form Share Clicked",
          "source_name": "direct_deposit_form",
          "category": "direct_deposit"
        }
      },
      {
        "config": {
          "key": "/move-money/direct-deposit/accountNumberCopied",
          "name": "Account Number Copied",
          "source_name": "direct_deposit_info",
          "category": "checking"
        }
      },
      {
        "config": {
          "key": "/move-money/direct-deposit/routingNumberCopied",
          "name": "Routing Number Copied",
          "source_name": "direct_deposit_info",
          "category": "checking"
        }
      },
      {
        "config": {
          "key": "/move-money/transfer/transfer-money/transferMoneyClicked",
          "name": "Transfer Money Form Completed",
          "category": "transfer_money",
          "source_name": "transfer_money_amount"
        }
      },
      {
        "config": {
          "key": "/move-money/find-atm/atmSearch",
          "name": "Address Field Clicked",
          "source_name": "find_atm_page",
          "category": ""
        }
      },
      {
        "config": {
          "key": "/move-money/transfer/confirm-transfer/transferMoneySubmitted",
          "name": "Transfer Money Request Submitted",
          "category": "transfer_money",
          "source_name": "transfer_money_confirm"
        }
      },
      {
        "config": {
          "key": "/move-money/find-atm/addressSelected",
          "name": "Address Dropdown Selected",
          "source_name": "find_atm_page",
          "category": ""
        }
      },
      {
        "config": {
          "key": "/believe/move-your-pay/mypUpdate",
          "name": "Move Your Pay Updated",
          "category": "varo_believe",
          "subcategory": "move_your_pay",
          "source_name": "move_your_pay_setup"
        }
      },
      {
        "config": {
          "key": "/move-money/find-atm/locationRejected",
          "name": "Enable Location Services Skipped",
          "source_name": "find_atm_page",
          "category": ""
        }
      },
      {
        "config": {
          "key": "/believe/move-your-pay/updateMYPError",
          "name": "Move Your Pay Error Encountered",
          "category": "varo_believe",
          "subcategory": "move_your_pay",
          "error_name": "changes_did_not_save",
          "error_type": "system"
        }
      },
      {
        "config": {
          "key": "/move-money/find-atm/locationAccepted",
          "name": "Location Settings Clicked",
          "source_name": "find_atm_page",
          "category": ""
        }
      },
      {
        "config": {
          "key": "/believe/move-your-pay/learnMore",
          "name": "FAQs Clicked",
          "source_name": "move_your_pay_setup",
          "category": "varo_believe",
          "subcategory": "move_your_pay"
        }
      },
      {
        "config": {
          "key": "/believe/move-your-pay/moveYourPayExited",
          "name": "Move Your Pay Setup Exited",
          "source_name": "move_your_pay_setup",
          "category": "varo_believe",
          "subcategory": "move_your_pay",
          "account_type": "charge_card"
        }
      },
      {
        "config": {
          "key": "/believe/move-your-pay/moveYourPayDirectDepositSetUpClicked",
          "name": "Direct Deposit Flow Initiated",
          "category": "direct_deposit",
          "subcategory": "move_your_pay",
          "source_name": "move_your_pay_setup"
        }
      },
      {
        "config": {
          "key": "/believe/move-your-pay/moveYourPayDirectDepositSkipped",
          "name": "Direct Deposit Flow Skipped",
          "category": "direct_deposit",
          "subcategory": "move_your_pay",
          "source_name": "move_your_pay_setup"
        }
      },
      {
        "config": {
          "key": "/move-money/find-atm/locationRequested",
          "name": "Enable Location Services Clicked",
          "source_name": "find_atm_page",
          "category": ""
        }
      },
      {
        "config": {
          "key": "/move-money/find-atm/pinClicked",
          "name": "ATM Location Pin Clicked",
          "source_name": "find_atm_page",
          "category": ""
        }
      },
      {
        "config": {
          "key": "/move-money/find-atm/openMaps",
          "name": "ATM Open In Maps Clicked",
          "source_name": "find_atm_page",
          "category": ""
        }
      },
      {
        "config": {
          "key": "/move-money/deposit-cash/showDepositLocations",
          "name": "Show Deposit Locations Clicked",
          "source_name": "deposit_cash_info",
          "category": "",
          "subcategory": ""
        }
      },
      {
        "config": {
          "key": "/move-money/deposit-cash/depositCashFaq",
          "name": "FAQs Clicked",
          "source_name": "deposit_cash_info",
          "category": "",
          "subcategory": ""
        }
      },
      {
        "config": {
          "key": "/move-money/deposit-cash/map/showBarcodeClicked",
          "name": "Show Barcode Clicked",
          "source_name": "deposit_cash_barcode",
          "category": "deposit_cash",
          "subcategory": "barcode",
          "flow_name": "move_money"
        }
      },
      {
        "config": {
          "key": "/move-money/deposit-cash/map/openInMaps",
          "name": "Open in Maps",
          "source_name": "Deposit Locations",
          "category": "deposit_cash",
          "subcategory": "barcode",
          "flow_name": "move_money"
        }
      },
      {
        "config": {
          "key": "/move-money/deposit-cash/barcode/openInMapsClicked",
          "name": "Open in Maps Clicked",
          "source_name": "deposit_cash_barcode",
          "category": "deposit_cash",
          "subcategory": "barcode",
          "flow_name": "move_money"
        }
      },
      {
        "config": {
          "key": "/move-money/deposit-cash/barcode/returnToMap",
          "name": "Return to Cash Deposit Map Page",
          "source_name": "deposit_cash_barcode",
          "category": "deposit_cash",
          "subcategory": "barcode",
          "flow_name": "move_money"
        }
      },
      {
        "config": {
          "key": "/move-money/deposit-cash/barcode/refreshExpired",
          "name": "Cash Deposit Barcode Refresh Request For Expired",
          "source_name": "cash_deposit_location_map",
          "category": "deposit_cash",
          "subcategory": "cash_deposit_barcode",
          "barcode_status": "Expired",
          "flow_name": "move_money"
        }
      },
      {
        "config": {
          "key": "/move-money/deposit-cash/barcode/close",
          "name": "Closes Unable To Refresh Message",
          "category": "deposit_cash",
          "source_name": "cash_deposit_location_map",
          "subcategory": "cash_deposit_barcode",
          "flow_name": "move_money"
        }
      },
      {
        "config": {
          "key": "/move-money/deposit-cash/barcode/retry",
          "name": "Clicks Try Again",
          "category": "deposit_cash",
          "source_name": "cash_deposit_location_map",
          "subcategory": "cash_deposit_barcode",
          "flow_name": "move_money"
        }
      },
      {
        "config": {
          "key": "/move-money/deposit-cash/barcode/back",
          "name": "Clicks Back Button",
          "category": "deposit_cash",
          "source_name": "cash_deposit_location_map",
          "subcategory": "cash_deposit_barcode",
          "flow_name": "move_money"
        }
      },
      {
        "config": {
          "key": "/move-money/deposit-cash/clicksBack",
          "name": "Clicks Back On Location Services Error",
          "category": "",
          "error_code": "",
          "user_error_message": "locations_off_for_barcode",
          "error_category": "cash_deposit_errors",
          "subcategory": "cash_deposit_barcode",
          "flow_name": "move_money"
        }
      },
      {
        "config": {
          "key": "/move-money/deposit-cash/retry",
          "name": "Clicks Retry On Barcode Loading Error",
          "category": "deposit_cash",
          "source_name": "cash_deposit_location_map",
          "subcategory": "cash_deposit_barcode",
          "flow_name": "move_money"
        }
      },
      {
        "config": {
          "key": "/move-money/deposit-cash/back",
          "name": "Clicks Try again On Barcode Loading Error",
          "category": "deposit_cash",
          "source_name": "cash_deposit_location_map",
          "subcategory": "cash_deposit_barcode",
          "flow_name": "move_money"
        }
      },
      {
        "config": {
          "key": "/move-money/deposit-cash/userGrantsAccess",
          "name": "User Grants Native Location Services Access",
          "category": "deposit_cash",
          "source_name": "cash_deposit_location_map",
          "subcategory": "cash_deposit_barcode",
          "flow_name": "move_money"
        }
      },
      {
        "config": {
          "key": "/move-money/deposit-cash/barcode/clicksBackAppError",
          "name": "Clicks Back On App Required Error",
          "category": "deposit_cash",
          "source_name": "cash_deposit_location_map",
          "subcategory": "cash_deposit_barcode",
          "flow_name": "move_money"
        }
      },
      {
        "config": {
          "key": "/move-money/deposit-cash/returnToMapFromLocation",
          "name": "Return to Cash Deposit Map Page",
          "source_name": "cash_deposit_location_map",
          "category": "deposit_cash",
          "subcategory": "cash_deposit_barcode",
          "flow_name": "move_money"
        }
      },
      {
        "config": {
          "key": "/move-money/debit-card-funding/cardNumberClicked",
          "name": "Debit Card Number Field Clicked",
          "category": "dcf",
          "source_name": "debit_card_funding"
        }
      },
      {
        "config": {
          "key": "/move-money/debit-card-funding/expirationDateClicked",
          "name": "Card Expiration Date Field Clicked",
          "category": "dcf",
          "source_name": "debit_card_funding",
          "card_type": "debit_card"
        }
      },
      {
        "config": {
          "key": "/move-money/debit-card-funding/cardCvvClicked",
          "name": "CVV Field Clicked",
          "category": "dcf",
          "source_name": "debit_card_funding",
          "card_type": "debit_card"
        }
      },
      {
        "config": {
          "key": "/move-money/debit-card-funding/zipCodeClicked",
          "name": "Zip Code Field Clicked",
          "category": "dcf",
          "source_name": "debit_card_funding",
          "card_type": "debit_card"
        }
      },
      {
        "config": {
          "key": "/move-money/debit-card-funding/transferMoneyClicked",
          "name": "Transfer Money Clicked",
          "category": "dcf",
          "source_name": "debit_card_funding"
        }
      },
      {
        "config": {
          "key": "/move-money/debit-card-funding/dcfCompleted",
          "name": "Debit Card Funding Completed",
          "category": "dcf",
          "source_name": "debit_card_funding"
        }
      },
      {
        "config": {
          "key": "/move-money/debit-card-funding/addressOptionSelected",
          "name": "Address Option Selected",
          "category": "dcf",
          "source_name": "debit_card_funding"
        }
      },
      {
        "config": {
          "key": "/move-money/debit-card-funding/newAddressEntered",
          "name": "New address entered",
          "category": "dcf",
          "source_name": "debit_card_funding"
        }
      },
      {
        "config": {
          "key": "/move-money/debit-card-funding/paymentSubmissionAttempt",
          "name": "Payment Submission Attempt",
          "category": "dcf",
          "source_name": "debit_card_funding"
        }
      },
      {
        "config": {
          "key": "3dSecureSuccess",
          "name": "Debit Card funding 3d secure success",
          "category": "dcf",
          "source_name": "debit_card_funding"
        }
      },
      {
        "config": {
          "key": "3dSecureError",
          "name": "Debit Card funding 3d secure error",
          "category": "dcf",
          "source_name": "debit_card_funding"
        }
      },
      {
        "config": {
          "key": "/move-money/debit-card-funding/errorEncountered",
          "name": "Debit Card Funding Error Encountered",
          "category": "dcf"
        }
      },
      {
        "config": {
          "key": "/move-money/debit-card-funding/cardDetailsClicked",
          "name": "Debit Card Details Clicked",
          "source_name": "debit_card_funding",
          "category": ""
        }
      },
      {
        "config": {
          "key": "/believe/apply/cardApplication/varoBelieveProgramAgreement",
          "name": "Varo Believe Program Agreement Opened",
          "category": "varo_believe",
          "subcategory": "believe_application",
          "source_name": "legal_agreements"
        }
      },
      {
        "config": {
          "key": "/move-money/transfer/transfer-money/transferMoneyNextButton",
          "name": "Transfer Money Form Completed",
          "source_name": "transfer_money_amount",
          "category": "transfer_money"
        }
      },
      {
        "config": {
          "key": "/believe/apply/approved-application/addMoney",
          "name": "Transfer Money Clicked",
          "category": "varo_believe",
          "subcategory": "believe_day_0_application"
        }
      },
      {
        "config": {
          "key": "/believe/apply/approved-application/skip",
          "name": "Approved Screen Skipped",
          "category": "varo_believe",
          "subcategory": "believe_day_0_application"
        }
      },
      {
        "config": {
          "key": "/believe/apply/cardApplication/varoBelieveApplicationApprove",
          "name": "Varo Believe Application Approved",
          "category": "varo_believe",
          "subcategory": "believe_application"
        }
      },
      {
        "config": {
          "key": "/move-money/transfer/confirm-transfer/transferMoneyConfirm",
          "name": "Transfer Money Confirm",
          "source_name": "transfer_money_confirm",
          "category": "transfer_money"
        }
      },
      {
        "config": {
          "key": "/believe/apply/cardApplication/varoBelieveReviewAnalytics",
          "name": "Varo Believe Application In Review",
          "category": "varo_believe",
          "subcategory": "believe_application"
        }
      },
      {
        "config": {
          "key": "/move-money/transfer/transfer-success/transferMoneySuccessful",
          "name": "Transfer Money Successful",
          "source_name": "transfer_money_success",
          "category": "transfer_money"
        }
      },
      {
        "config": {
          "key": "/move-money/transfer/instant-transfer-success/transferMoneySuccessDone",
          "name": "Pressable Clicked",
          "source_name": "transfer_money_success",
          "category": "transfer_money"
        }
      },
      {
        "config": {
          "key": "/move-money/transfer/instant-transfer-success/transferMoneySuccessSeeTransfers",
          "name": "Pressable Clicked",
          "source_name": "transfer_money_success",
          "category": "transfer_money"
        }
      },
      {
        "config": {
          "key": "/move-money/transfer/transfer-processing/transferMoneyProcessingDone",
          "name": "Pressable Clicked",
          "source_name": "transfer_money_processing",
          "category": "transfer_money"
        }
      },
      {
        "config": {
          "key": "/move-money/transfer/instant-transfer-error/transferMoneyErrorChooseDifferentAccount",
          "name": "Pressable Clicked",
          "source_name": "transfer_money_error",
          "category": "transfer_money"
        }
      },
      {
        "config": {
          "key": "/move-money/transfer/instant-transfer-error/transferMoneyErrorDone",
          "name": "Pressable Clicked",
          "source_name": "transfer_money_error",
          "category": "transfer_money"
        }
      },
      {
        "config": {
          "key": "/move-money/transfer/instant-transfer-error/transferMoneyErrorRetry",
          "name": "Pressable Clicked",
          "source_name": "transfer_money_error",
          "category": "transfer_money"
        }
      },
      {
        "config": {
          "key": "/move-money/transfer/instant-transfer-error/transferMoneyErrorRestart",
          "name": "Pressable Clicked",
          "source_name": "transfer_money_error",
          "category": "transfer_money"
        }
      },
      {
        "config": {
          "key": "/move-money/transfer/review-transfer-details/transferMoneyConfirmErrorRetry",
          "name": "Pressable Clicked",
          "source_name": "transfer_money_confirm",
          "category": "transfer_money"
        }
      },
      {
        "config": {
          "key": "/move-money/transfer/review-transfer-details/transferMoneyConfirmErrorDone",
          "name": "Pressable Clicked",
          "source_name": "transfer_money_confirm",
          "category": "transfer_money"
        }
      },
      {
        "config": {
          "key": "/move-money/transfer/review-transfer-details/transferMoneyConfirmLeaveDialogStay",
          "name": "Pressable Clicked",
          "source_name": "transfer_money_confirm",
          "category": "transfer_money"
        }
      },
      {
        "config": {
          "key": "/move-money/transfer/review-transfer-details/transferMoneyConfirmLeaveDialogLeave",
          "name": "Pressable Clicked",
          "source_name": "transfer_money_confirm",
          "category": "transfer_money"
        }
      },
      {
        "config": {
          "key": "/move-money/transfer/instant-transfer/transferMoneyAmountErrorRetry",
          "name": "Pressable Clicked",
          "source_name": "transfer_money_amount",
          "category": "transfer_money"
        }
      },
      {
        "config": {
          "key": "/move-money/transfer/instant-transfer/transferMoneyAmountErrorGoBack",
          "name": "Pressable Clicked",
          "source_name": "transfer_money_amount",
          "category": "transfer_money"
        }
      },
      {
        "config": {
          "key": "/believe/apply/cardApplication/varoBelieveDeclinedAnalytics",
          "name": "Varo Believe Application Declined",
          "category": "varo_believe",
          "subcategory": "believe_application"
        }
      },
      {
        "config": {
          "key": "/move-money/transfer/transfer-error/transferMoneyFlowError",
          "name": "Transfer Money Flow Error Encountered",
          "category": "transfer_money"
        }
      },
      {
        "config": {
          "key": "/accounts/manage-account/manageAccountStatementsAndDocumentsClicked",
          "name": "Statements and Documents Clicked",
          "source_name": "manage_account_page",
          "category": ""
        }
      },
      {
        "config": {
          "key": "/accounts/manage-account/showAccountNumberSwitchOff",
          "source_name": "manage_account_page",
          "name": "Show Account Number Turned Off",
          "category": ""
        }
      },
      {
        "config": {
          "key": "/accounts/manage-account/showAccountNumberSwitchOn",
          "source_name": "manage_account_page",
          "name": "Show Account Number Turned On",
          "category": ""
        }
      },
      {
        "config": {
          "key": "/move-money/deposit-cash/map/noThankYouClicked",
          "name": "Enable Location Services Skipped",
          "source_name": "deposit_location_page",
          "category": ""
        }
      },
      {
        "config": {
          "key": "/accounts/[id]/autoSaving",
          "name": "Auto Saving Clicked",
          "category": "savings",
          "source_name": "account_page"
        }
      },
      {
        "config": {
          "key": "/move-money/deposit-cash/map/goToSettingsClicked",
          "name": "Location Settings Clicked",
          "source_name": "deposit_location_page",
          "category": ""
        }
      },
      {
        "config": {
          "key": "/accounts/automatic-savings/saveYourChangesTurnedOff",
          "name": "Save Your Change Turned Off",
          "source_name": "automatic_savings_page",
          "category": "savings"
        }
      },
      {
        "config": {
          "key": "/move-money/deposit-cash/map/locationPinClicked",
          "name": "Deposit Location Pin Clicked",
          "source_name": "deposit_location_page",
          "category": ""
        }
      },
      {
        "config": {
          "key": "/accounts/automatic-savings/saveYourChangesTurnedOn",
          "name": "Save Your Change Turned On",
          "source_name": "automatic_savings_page",
          "category": "savings"
        }
      },
      {
        "config": {
          "key": "/move-money/deposit-cash/map/openInMapsClicked",
          "name": "Deposit Location Open In Maps Clicked",
          "source_name": "deposit_location_page",
          "category": ""
        }
      },
      {
        "config": {
          "key": "/move-money/deposit-cash/map/typesOnSearchBar",
          "name": "Search Location Entered",
          "source_name": "deposit_location_page",
          "category": ""
        }
      },
      {
        "config": {
          "key": "/move-money/deposit-cash/map/freeCashDepositLocationsTurnedOn",
          "name": "Free Cash Deposit Locations Turned On",
          "source_name": "deposit_location_page",
          "category": ""
        }
      },
      {
        "config": {
          "key": "/move-money/deposit-cash/map/freeCashDepositLocationsTurnedOff",
          "name": "Free Cash Deposit Locations Turned Off",
          "source_name": "deposit_location_page",
          "category": ""
        }
      },
      {
        "config": {
          "key": "/accounts/automatic-savings/saveYourPayClicked",
          "name": "Save Your Pay Clicked",
          "source_name": "automatic_savings_page",
          "category": "savings"
        }
      },
      {
        "config": {
          "key": "/move-money/deposit-cash/map/atmSearch",
          "name": "Address Field Clicked",
          "source_name": "deposit_location_page",
          "category": ""
        }
      },
      {
        "config": {
          "key": "/move-money/deposit-cash/map/addressSelected",
          "name": "Address Dropdown Selected",
          "source_name": "deposit_location_page",
          "category": ""
        }
      },
      {
        "config": {
          "key": "/accounts/save-your-pay/sypUpdatePercentage",
          "name": "Save Your Pay Percentage Updated",
          "source_name": "save_your_pay_page",
          "category": "savings"
        }
      },
      {
        "config": {
          "key": "/myvaro/card/new-pin/[cardId]/pinSetCompleted",
          "name": "PIN Set Completed",
          "category": "card",
          "source_name": "pin_set_completed",
          "card_type": ""
        }
      },
      {
        "config": {
          "key": "pinSetFailed",
          "name": "PIN Set Failed",
          "category": "card",
          "source_name": "pin_set_failed",
          "card_type": ""
        }
      },
      {
        "config": {
          "key": "/accounts/[id]/suspiciousTransaction",
          "name": "Alert Banner Clicked",
          "source_name": "account_page",
          "category": "account_page"
        }
      },
      {
        "config": {
          "key": "walletSuccessScreenContinueButton",
          "name": "Wallet Provisioning Successful Continue Clicked",
          "source_name": "wallet_provisioning_successful",
          "category": "card",
          "subcategory": "wallet_provisioning"
        }
      },
      {
        "config": {
          "key": "initializeAddToWalletFlow",
          "name": "Wallet Provisioning Initiated",
          "category": "card",
          "subcategory": "wallet_provisioning",
          "source_name": "card_services"
        }
      },
      {
        "config": {
          "key": "finishedAddToWalletFlowSuccess",
          "name": "Wallet Provisioning Completed",
          "category": "card",
          "subcategory": "wallet_provisioning",
          "source_name": "card_services"
        }
      },
      {
        "config": {
          "key": "addToWalletFlowError",
          "name": "Wallet Provisioning Failed",
          "category": "card",
          "subcategory": "wallet_provisioning",
          "error_type": "system"
        }
      },
      {
        "config": {
          "key": "addToWalletFlowAbandoned",
          "name": "Wallet Provisioning Canceled",
          "category": "card",
          "subcategory": "wallet_provisioning",
          "source_name": "card_services"
        }
      },
      {
        "config": {
          "key": "/move-money/find-atm/findAtmSearchClicked",
          "name": "Search Area Clicked",
          "source_name": "find_atm_page",
          "category": ""
        }
      },
      {
        "config": {
          "key": "/move-money/deposit-cash/map/depositSearchClicked",
          "name": "Search Area Clicked",
          "source_name": "deposit_location_page",
          "category": ""
        }
      },
      {
        "config": {
          "key": "/accounts/[id]/upcomingTransactionAnalytics",
          "name": "Upcoming Payments Clicked",
          "source_name": "account_page",
          "category": ""
        }
      },
      {
        "config": {
          "key": "/accounts/[id]/upcomingTransactionLearnMoreAnalytics",
          "name": "Upcoming Payments Projection Disclaimer Clicked",
          "source_name": "account_page",
          "category": ""
        }
      },
      {
        "config": {
          "key": "/payments-detail/email-new-otp-requested",
          "name": "Email New OTP Requested",
          "category": "v2a",
          "subcategory": "transfer_money_v2a_receiver"
        }
      },
      {
        "config": {
          "key": "/payments-detail/resendClicked",
          "name": "Verification Code Requested",
          "category": "v2a",
          "subcategory": "transfer_money_v2a_receiver"
        }
      },
      {
        "config": {
          "key": "/payments-detail/sms-new-otp-requested",
          "name": "SMS New OTP Requested",
          "category": "v2a",
          "subcategory": "transfer_money_v2a_receiver"
        }
      },
      {
        "config": {
          "key": "/payments-detail/email-otp-entered",
          "name": "Email OTP Entered",
          "category": "v2a",
          "subcategory": "transfer_money_v2a_receiver"
        }
      },
      {
        "config": {
          "key": "/payments-detail/sms-otp-entered",
          "name": "SMS OTP Entered",
          "category": "v2a",
          "subcategory": "transfer_money_v2a_receiver"
        }
      },
      {
        "config": {
          "key": "/payments-detail/email-otp-completed",
          "name": "Email OTP Completed",
          "category": "v2a",
          "subcategory": "transfer_money_v2a_receiver"
        }
      },
      {
        "config": {
          "key": "/payments-detail/sms-otp-completed",
          "name": "SMS OTP Completed",
          "category": "v2a",
          "subcategory": "transfer_money_v2a_receiver"
        }
      },
      {
        "config": {
          "key": "/payments-detail/verificationFailed",
          "name": "Verification Failed",
          "category": "v2a",
          "subcategory": "transfer_money_v2a_receiver"
        }
      },
      {
        "config": {
          "key": "/payments-detail/verificationCodeSubmitted",
          "name": "Verification Code Submitted",
          "category": "v2a",
          "subcategory": "transfer_money_v2a_receiver"
        }
      },
      {
        "config": {
          "key": "/payments-detail/verificationSuccessful",
          "name": "Verification Code Submitted",
          "category": "v2a",
          "subcategory": "transfer_money_v2a_receiver"
        }
      },
      {
        "config": {
          "key": "/move-money/p2p/debit/copyCardNumberP2P",
          "name": "Digital Card Number Copied",
          "category": "card",
          "source_name": "p2p_funding",
          "card_type": "debit_card"
        }
      },
      {
        "config": {
          "key": "/move-money/p2p/debit/copyAccountNumberP2P",
          "name": "Account Number Copied",
          "category": "checking",
          "source_name": "p2p_funding"
        }
      },
      {
        "config": {
          "key": "/move-money/p2p/debit/copyRoutingNumberP2P",
          "name": "Routing Number Copied",
          "category": "checking",
          "source_name": "p2p_funding"
        }
      },
      {
        "config": {
          "key": "/move-money/p2p/debit/viewCardClicked",
          "name": "Digital Card Number Viewed",
          "category": "card",
          "source_name": "p2p_funding",
          "card_type": "debit_card"
        }
      },
      {
        "config": {
          "key": "/move-money/p2p/debit/hideCardClicked",
          "name": "Hide Card Clicked",
          "category": "card",
          "source_name": "p2p_funding"
        }
      },
      {
        "config": {
          "key": "/confirm-your-address/confirmAddressPressed",
          "name": "Address Confirmed",
          "source_name": "home_address_confirmation",
          "category": "profile_settings",
          "subcategory": "mastercard"
        }
      },
      {
        "config": {
          "key": "/confirm-your-address/editAddressPressed",
          "name": "Edit Address Clicked",
          "source_name": "home_address_confirmation",
          "category": "profile_settings",
          "subcategory": "mastercard"
        }
      },
      {
        "config": {
          "key": "/confirm-your-address/closeScreenAnalytics",
          "name": "Confirm Address Closed",
          "source_name": "confirm_address_error_page",
          "category": "profile_settings",
          "subcategory": "mastercard"
        }
      },
      {
        "config": {
          "key": "/confirm-your-address/tryAgainClicked",
          "name": "Confirm Address Try Again Clicked",
          "source_name": "confirm_address_error_page",
          "category": "profile_settings",
          "subcategory": "mastercard"
        }
      },
      {
        "config": {
          "key": "/myvaro/personal-details/change-address/changeAddressSaved",
          "name": "Home Address Saved",
          "category": "profile_settings",
          "source_name": "edit_home_address_page",
          "subcategory": "mastercard"
        }
      },
      {
        "config": {
          "key": "/directDepositSwitchInitiatedHome",
          "name": "Direct Deposit Instant Switch Initiated",
          "source_name": "home_page",
          "category": "direct_deposit"
        }
      },
      {
        "config": {
          "key": "/onboarding/directDepositSwitchInitiatedOnboarding",
          "source_name": "onboarding",
          "name": "Direct Deposit Instant Switch Initiated",
          "category": "direct_deposit"
        }
      },
      {
        "config": {
          "key": "/direct-deposit-benefits/directDepositSwitchInitiatedDepositTracker",
          "name": "Direct Deposit Instant Switch Initiated",
          "source_name": "direct_deposit_info",
          "category": "direct_deposit"
        }
      },
      {
        "config": {
          "key": "/onboarding/tabapay/dcf-tabapay-form/cardNumberFieldClicked",
          "name": "Debit Card Number Field Clicked",
          "category": "dcf",
          "subcategory": "dcf_v2_1screen",
          "source_name": "debit_card_funding",
          "vendor": "tabapay"
        }
      },
      {
        "config": {
          "key": "/onboarding/tabapay/dcf-tabapay-form/expDateFieldClicked",
          "name": "Card Expiration Date Field Clicked",
          "card_type": "debit_card",
          "category": "onboarding_wizard",
          "subcategory": "dcf_v2_1screen",
          "card_id": "debit_card",
          "vendor": "tabapay"
        }
      },
      {
        "config": {
          "key": "/onboarding/tabapay/address-screen/debitCardInlineErrorEncountered",
          "name": "Debit Card Inline Error Encountered",
          "category": "onboarding_wizard",
          "subcategory": "dcf_v2_1screen",
          "validation_type": "Transaction_validation"
        }
      },
      {
        "config": {
          "key": "/onboarding/tabapay/dcf-tabapay-form/addDebitCardErrorEncountered",
          "name": "Add Debit Card Error Encountered",
          "category": "onboarding_wizard",
          "subcategory": "dcf_v2_1screen",
          "validation_type": "Transaction_validation"
        }
      },
      {
        "config": {
          "key": "/onboarding/tabapay/dcf-tabapay-form/cvvFieldClicked",
          "name": "CVV Field Clicked",
          "card_type": "debit_card",
          "category": "onboarding_wizard",
          "subcategory": "dcf_v2_1screen",
          "source_name": "debit_card_funding",
          "vendor": "tabapay"
        }
      },
      {
        "config": {
          "key": "/onboarding/tabapay/dcf-tabapay-form/addressFieldClicked",
          "name": "Address Field Clicked",
          "card_type": "debit_card",
          "category": "dcf",
          "subcategory": "dcf_v2_1screen",
          "source_name": "debit_card_funding"
        }
      },
      {
        "config": {
          "key": "/onboarding/tabapay/dcf-tabapay-form/addDebitCardSubmmited",
          "name": "Add Debit Card Submitted",
          "source_name": "debit_card_funding",
          "category": "onboarding_wizard",
          "subcategory": "dcf_v2_1screen",
          "vendor": "tabapay"
        }
      },
      {
        "config": {
          "key": "/onboarding/tabapay/dcf-tabapay-form/pillsTabapayClicked",
          "name": "Debit Card Funding Amount Pill Selected",
          "source": "option_set_amount",
          "amount_selection_type": "preselected",
          "vendor": "tabapay",
          "category": "onboarding_wizard",
          "subcategory": "dcf_v2_1screen"
        }
      },
      {
        "config": {
          "key": "/onboarding/tabapay/tabapay-transfer-screen/addMoneyClicked",
          "name": "Transfer Money Clicked",
          "category": "onboarding_wizard",
          "source_name": "debit_card_funding",
          "subcategory": "dcf_v2_1screen",
          "vendor": "tabapay"
        }
      },
      {
        "config": {
          "key": "/onboarding/tabapay/address-screen/addressDropdownSelected",
          "name": "Address Dropdown Selected",
          "category": "onboarding_wizard",
          "subcategory": "dcf_v2_1screen",
          "source_name": "debit_card_funding"
        }
      },
      {
        "config": {
          "key": "/onboarding/tabapay/address-screen/addressEnterManuallyClicked",
          "name": "Address Enter Manually Clicked",
          "category": "onboarding_wizard",
          "subcategory": "dcf_v2_1screen",
          "source_name": "debit_card_funding"
        }
      },
      {
        "config": {
          "key": "/onboarding/tabapay/address-screen/manualAddressSelected",
          "name": "Manual Address Selected",
          "category": "onboarding_wizard",
          "subcategory": "dcf_v2_1screen",
          "source_name": "debit_card_funding"
        }
      },
      {
        "config": {
          "key": "/onboarding/tabapay/address-screen/manualAddressConfirmed",
          "name": "Manual Address Confirmed",
          "category": "onboarding_wizard",
          "subcategory": "dcf_v2_1screen",
          "source_name": "debit_card_funding"
        }
      },
      {
        "config": {
          "key": "/onboarding/tabapay/dcf-tabapay-form/addNewAddressClicked",
          "name": "Add New Address Clicked",
          "category": "onboarding_wizard",
          "subcategory": "dcf_v2_1screen",
          "source_name": "debit_card_funding"
        }
      },
      {
        "config": {
          "key": "/onboarding/tabapay/tabapay-transfer-success/dcfCompleted",
          "name": "Debit Card Funding Completed",
          "category": "onboarding_wizard",
          "subcategory": "dcf_v2_1screen"
        }
      },
      {
        "config": {
          "key": "/move-money/tabapay/dcf-tabapay-form/cardNumberFieldClicked",
          "name": "Debit Card Number Field Clicked",
          "flow_name": "debit_card",
          "category": "dcf",
          "subcategory": "dcf_v2_1screen",
          "source_name": "debit_card_funding",
          "vendor": "tabapay"
        }
      },
      {
        "config": {
          "key": "/move-money/tabapay/dcf-tabapay-form/expDateFieldClicked",
          "name": "Card Expiration Date Field Clicked",
          "card_type": "debit_card",
          "category": "dcf",
          "subcategory": "dcf_v2_1screen",
          "flow_name": "dcf",
          "card_id": "debit_card",
          "vendor": "tabapay"
        }
      },
      {
        "config": {
          "key": "/move-money/tabapay/dcf-tabapay-form/cvvFieldClicked",
          "name": "CVV Field Clicked",
          "card_type": "debit_card",
          "category": "dcf",
          "subcategory": "dcf_v2_1screen",
          "flow_name": "dcf",
          "source_name": "debit_card_funding",
          "vendor": "tabapay"
        }
      },
      {
        "config": {
          "key": "/move-money/tabapay/dcf-tabapay-form/addressFieldClicked",
          "name": "Address Field Clicked",
          "card_type": "debit_card",
          "category": "dcf",
          "subcategory": "dcf_v2_1screen",
          "flow_name": "dcf",
          "source_name": "debit_card_funding"
        }
      },
      {
        "config": {
          "key": "/move-money/tabapay/dcf-tabapay-form/addDebitCardSubmmited",
          "name": "Add Debit Card Submitted",
          "source_name": "add_debit_card",
          "category": "link_external_debit_card",
          "subcategory": "va_day_0"
        }
      },
      {
        "config": {
          "key": "/move-money/tabapay/add-card-success/debitCardAddedSuccess",
          "name": "Debit Card Successfully Added",
          "category": "link_external_debit_card",
          "subcategory": "va_day_0"
        }
      },
      {
        "config": {
          "key": "/move-money/tabapay/dcf-tabapay-form/addNewAddressClicked",
          "name": "Add New Address Clicked",
          "category": "dcf",
          "subcategory": "dcf_v2_1screen",
          "source_name": "debit_card_funding"
        }
      },
      {
        "config": {
          "key": "/move-money/tabapay/address-screen/addressEnterManuallyClicked",
          "name": "Address Enter Manually Clicked",
          "category": "dcf",
          "subcategory": "dcf_v2_1screen",
          "source_name": "debit_card_funding"
        }
      },
      {
        "config": {
          "key": "/move-money/tabapay/address-screen/addressDropdownSelected",
          "name": "Address Dropdown Selected",
          "category": "dcf",
          "subcategory": "dcf_v2_1screen",
          "source_name": "debit_card_funding"
        }
      },
      {
        "config": {
          "key": "/move-money/tabapay/address-screen/manualAddressSelected",
          "name": "Manual Address Selected",
          "category": "dcf",
          "subcategory": "dcf_v2_1screen",
          "source_name": "debit_card_funding"
        }
      },
      {
        "config": {
          "key": "/move-money/tabapay/address-screen/manualAddressConfirmed",
          "name": "Manual Address Confirmed",
          "category": "dcf",
          "subcategory": "dcf_v2_1screen",
          "source_name": "debit_card_funding"
        }
      },
      {
        "config": {
          "key": "/move-money/tabapay/address-screen/debitCardInlineErrorEncountered",
          "name": "Debit Card Inline Error Encountered",
          "category": "dcf",
          "subcategory": "dcf_v2_1screen",
          "validation_type": "Transaction_validation"
        }
      },
      {
        "config": {
          "key": "/move-money/tabapay/dcf-tabapay-form/addDebitCardErrorEncountered",
          "name": "Add Debit Card Error Encountered",
          "category": "dcf",
          "subcategory": "dcf_v2_1screen",
          "validation_type": "Transaction_validation"
        }
      },
      {
        "config": {
          "key": "/move-money/tabapay/dcf-tabapay-form/debitCardInlineErrorEncountered",
          "name": "Debit Card Inline Error Encountered",
          "category": "dcf",
          "subcategory": "dcf_v2_1screen",
          "validation_type": "Transaction_validation"
        }
      },
      {
        "config": {
          "key": "/move-money/tabapay/dcf-tabapay-form/pillsTabapayClicked",
          "name": "Debit Card Funding Amount Pill Selected",
          "source": "option_set_amount",
          "amount_selection_type": "preselected",
          "vendor": "tabapay",
          "category": "dcf",
          "subcategory": "dcf_v2_1screen"
        }
      },
      {
        "config": {
          "key": "/believe-funding/tabapay/dcf-tabapay-form/cardNumberFieldClicked",
          "name": "Debit Card Number Field Clicked",
          "category": "dcf",
          "subcategory": "dcf_believe_day_0_application",
          "source_name": "debit_card_funding",
          "vendor": "tabapay"
        }
      },
      {
        "config": {
          "key": "/believe-funding/tabapay/dcf-tabapay-form/expDateFieldClicked",
          "name": "Card Expiration Date Field Clicked",
          "card_type": "debit_card",
          "category": "dcf",
          "subcategory": "dcf_believe_day_0_application",
          "source_name": "debit_card_funding",
          "vendor": "tabapay"
        }
      },
      {
        "config": {
          "key": "/believe-funding/tabapay/dcf-tabapay-form/cvvFieldClicked",
          "name": "CVV Field Clicked",
          "card_type": "debit_card",
          "category": "dcf",
          "subcategory": "dcf_believe_day_0_application",
          "source_name": "debit_card_funding",
          "vendor": "tabapay"
        }
      },
      {
        "config": {
          "key": "/believe-funding/tabapay/dcf-tabapay-form/addressFieldClicked",
          "name": "Address Field Clicked",
          "card_type": "debit_card",
          "category": "dcf",
          "subcategory": "dcf_believe_day_0_application",
          "source_name": "debit_card_funding"
        }
      },
      {
        "config": {
          "key": "/believe-funding/tabapay/dcf-tabapay-form/addDebitCardSubmmited",
          "name": "Add Debit Card Submitted",
          "source_name": "debit_card_funding",
          "category": "dcf",
          "subcategory": "dcf_believe_day_0_application",
          "vendor": "tabapay"
        }
      },
      {
        "config": {
          "key": "/believe-funding/tabapay/dcf-tabapay-form/addNewAddressClicked",
          "name": "Add New Address Clicked",
          "category": "dcf",
          "subcategory": "dcf_believe_day_0_application",
          "source_name": "debit_card_funding"
        }
      },
      {
        "config": {
          "key": "/believe-funding/tabapay/dcf-tabapay-form/pillsTabapayClicked",
          "name": "Debit Card Funding Amount Pill Selected",
          "source": "option_set_amount",
          "amount_selection_type": "preselected",
          "vendor": "tabapay",
          "category": "dcf",
          "subcategory": "dcf_believe_day_0_application"
        }
      },
      {
        "config": {
          "key": "/believe-funding/tabapay/dcf-tabapay-form/debitCardInlineErrorEncountered",
          "name": "Debit Card Inline Error Encountered",
          "category": "dcf",
          "subcategory": "dcf_believe_day_0_application",
          "validation_type": "Transaction_validation"
        }
      },
      {
        "config": {
          "key": "/believe-funding/tabapay/address-screen/addressEnterManuallyClicked",
          "name": "Address Enter Manually Clicked",
          "category": "dcf",
          "subcategory": "dcf_believe_day_0_application",
          "source_name": "debit_card_funding"
        }
      },
      {
        "config": {
          "key": "/believe-funding/tabapay/address-screen/addressDropdownSelected",
          "name": "Address Dropdown Selected",
          "category": "dcf",
          "subcategory": "dcf_believe_day_0_application",
          "source_name": "debit_card_funding"
        }
      },
      {
        "config": {
          "key": "/believe-funding/tabapay/address-screen/manualAddressSelected",
          "name": "Manual Address Selected",
          "category": "dcf",
          "subcategory": "dcf_believe_day_0_application",
          "source_name": "debit_card_funding"
        }
      },
      {
        "config": {
          "key": "/believe-funding/tabapay/address-screen/manualAddressConfirmed",
          "name": "Manual Address Confirmed",
          "category": "dcf",
          "subcategory": "dcf_believe_day_0_application",
          "source_name": "debit_card_funding"
        }
      },
      {
        "config": {
          "key": "/believe-funding/tabapay/address-screen/debitCardInlineErrorEncountered",
          "name": "Debit Card Inline Error Encountered",
          "category": "dcf",
          "subcategory": "dcf_believe_day_0_application",
          "validation_type": "Transaction_validation"
        }
      },
      {
        "config": {
          "key": "/believe-funding/tabapay/tabapay-transfer-success/dcfCompleted",
          "name": "Debit Card Funding Completed",
          "category": "dcf",
          "subcategory": "dcf_believe_day_0_application"
        }
      },
      {
        "config": {
          "key": "/believe-funding/tabapay/tabapay-transfer-screen/addMoneyClicked",
          "name": "Transfer Money Clicked",
          "category": "dcf",
          "source_name": "debit_card_funding",
          "subcategory": "dcf_believe_day_0_application",
          "vendor": "tabapay"
        }
      },
      {
        "config": {
          "key": "/believe-funding/tabapay/tabapay-transfer-screen/selectAccount",
          "name": "Transfer Money Select Account Clicked",
          "source_name": "transfer_money_amount",
          "category": "dcf",
          "subcategory": "dcf_believe_day_0_application"
        }
      },
      {
        "config": {
          "key": "/believe-funding/tabapay/tabapay-transfer-screen/accountSelected",
          "name": "Transfer Money Account Selected",
          "source_name": "transfer_money_amount",
          "category": "dcf",
          "subcategory": "dcf_believe_day_0_application"
        }
      },
      {
        "config": {
          "key": "/myvaro/external-accounts/update-expiry-date/verifyCardClicked",
          "name": "Verify Card Acknowledged",
          "category": "link_external_debit_card",
          "source_name": "verify_card"
        }
      },
      {
        "config": {
          "key": "/myvaro/external-accounts/[cardId]/card-details/verifyCardClicked",
          "name": "Verify Card Acknowledged",
          "category": "link_external_debit_card",
          "source_name": "verify_card"
        }
      },
      {
        "config": {
          "key": "/move-money/tabapay/dcf-tabapay-form/verifyCardClicked",
          "name": "Verify Card Acknowledged",
          "category": "link_external_debit_card",
          "source_name": "verify_card"
        }
      },
      {
        "config": {
          "key": "/move-money/v2a/mobileAppDownloadRequested",
          "name": "Mobile App Download Link Requested",
          "category": "v2a",
          "subcategory": "transfer_money_v2a_sender",
          "source_name": "v2a_mobile_app_download"
        }
      },
      {
        "config": {
          "key": "/move-money/v2a/mobileAppDownloadSkipped",
          "name": "Mobile App Download Skipped",
          "category": "v2a",
          "subcategory": "transfer_money_v2a_sender",
          "source_name": "v2a_mobile_app_download"
        }
      },
      {
        "config": {
          "key": "/reactivation/logoutClosedAccount",
          "name": "Log Out Clicked",
          "category": "application",
          "source_name": "closed_account_reactivation"
        }
      },
      {
        "config": {
          "key": "/reactivation/applyNow",
          "name": "Registration Step Completed",
          "category": "application",
          "subcategory": "checking"
        }
      },
      {
        "config": {
          "key": "/reactivation/accountStatements",
          "name": "Account Statement Clicked",
          "category": "appplication",
          "source_name": "closed_account_reactivation"
        }
      },
      {
        "config": {
          "key": "/reactivation/taxStatements",
          "name": "Tax Statement Clicked",
          "category": "appplication",
          "source_name": "closed_account_reactivation"
        }
      },
      {
        "config": {
          "key": "/reactivation/editMailAddress",
          "name": "Edit Address Clicked",
          "category": "application",
          "subcategory": "checking",
          "source_name": "closed_account_reactivation"
        }
      },
      {
        "config": {
          "key": "/reactivation/verify-sms/noPhoneNumberAccess",
          "name": "Phone Number No Access Clicked",
          "category": "application",
          "subcategory": "checking",
          "source_name": "phone_number_verification"
        }
      },
      {
        "config": {
          "key": "/reactivation/verify-sms/smsVerificationStepStarted",
          "name": "Registration Step Started",
          "category": "application",
          "subcategory": "checking"
        }
      },
      {
        "config": {
          "key": "/reactivation/verify-sms/smsVerificationStepCompleted",
          "name": "Registration Step Completed",
          "category": "application",
          "subcategory": "checking"
        }
      },
      {
        "config": {
          "key": "/reactivation/verify-sms/submitOtp",
          "name": "Verification Code Submitted",
          "category": "application",
          "subcategory": "checking",
          "source_name": "phone_number_verification"
        }
      },
      {
        "config": {
          "key": "/reactivation/verify-sms/resendOtp",
          "name": "Verification Code Requested",
          "category": "application",
          "subcategory": "checking",
          "source_name": "phone_number_verification"
        }
      },
      {
        "config": {
          "key": "/reactivation/contact-support/contactSupport",
          "name": "Support Call Clicked",
          "category": "servicing",
          "source_name": "help_and_support"
        }
      },
      {
        "config": {
          "key": "/reactivation/verify-ssn/ssnFieldClicked",
          "name": "SSN Field Clicked",
          "category": "application",
          "subcategory": "checking",
          "source_name": "ssn_verification_reactivation"
        }
      },
      {
        "config": {
          "key": "/reactivation/verify-ssn/ssnMaskClicked",
          "name": "SSN Mask Clicked",
          "category": "application",
          "subcategory": "checking",
          "source_name": "ssn_verification_reactivation"
        }
      },
      {
        "config": {
          "key": "/reactivation/verify-ssn/ssnVerificationStepStarted",
          "name": "Registration Step Started",
          "category": "application",
          "subcategory": "checking"
        }
      },
      {
        "config": {
          "key": "/reactivation/verify-ssn/ssnVerificationStepCompleted",
          "name": "Registration Step Completed",
          "category": "application",
          "subcategory": "checking"
        }
      },
      {
        "config": {
          "key": "/reactivation/review-info/reviewInfoStepStarted",
          "name": "Registration Step Started",
          "category": "application",
          "subcategory": "checking"
        }
      },
      {
        "config": {
          "key": "/reactivation/review-info/nextButtonPressed",
          "name": "Registration Step Completed",
          "category": "application",
          "subcategory": "checking"
        }
      },
      {
        "config": {
          "key": "/reactivation/review-info/editName",
          "name": "Edit Name Clicked",
          "category": "application",
          "subcategory": "checking",
          "source_name": "review_information"
        }
      },
      {
        "config": {
          "key": "/reactivation/review-info/editAddress",
          "name": "Edit Address Clicked",
          "category": "application",
          "subcategory": "checking",
          "source_name": "review_information"
        }
      },
      {
        "config": {
          "key": "/reactivation/review-info/editOccupation",
          "name": "Edit Occupation Clicked",
          "category": "application",
          "subcategory": "checking",
          "source_name": "review_information"
        }
      },
      {
        "config": {
          "key": "/reactivation/review-info/editDob",
          "name": "Edit DOB Clicked",
          "category": "application",
          "subcategory": "checking",
          "source_name": "review_information"
        }
      },
      {
        "config": {
          "key": "/reactivation/verify-ssn-error/logoutButtonPressed",
          "name": "Log Out Clicked",
          "category": "application",
          "source_name": "info_not_verified"
        }
      },
      {
        "config": {
          "key": "/reactivation/verify-ssn-error/signupButtonPressed",
          "name": "Signup Clicked",
          "category": "application",
          "source_name": "info_not_verified"
        }
      },
      {
        "config": {
          "key": "/reactivation/verify-ssn-error/goToHomeButtonPressed",
          "name": "Go To Home Clicked",
          "category": "application",
          "source_name": "info_not_verified"
        }
      },
      {
        "config": {
          "key": "/reactivation/error/backToHomeButtonPressed",
          "name": "Go To Home Clicked",
          "source_name": "reactivation_error",
          "category": "application",
          "subcategory": "checking"
        }
      },
      {
        "config": {
          "key": "/reactivation/legal/legalAgreementsStepStarted",
          "name": "Registration Step Started",
          "category": "application",
          "subcategory": "checking"
        }
      },
      {
        "config": {
          "key": "/reactivation/legal/agreeToAllClicked",
          "name": "Origination All Legal Agreements Checkbox Clicked",
          "source_name": "legal_agreements",
          "subcategory": "checking",
          "category": "application"
        }
      },
      {
        "config": {
          "key": "/reactivation/legal/reviewClicked",
          "name": "Origination Legal Agreements Review Clicked",
          "source_name": "legal_agreements",
          "subcategory": "checking",
          "category": "application"
        }
      },
      {
        "config": {
          "key": "/reactivation/legal/applyClicked",
          "name": "Application Submitted",
          "source_name": "legal_agreements",
          "subcategory": "checking",
          "category": "application"
        }
      },
      {
        "config": {
          "key": "/reactivation/legal/completedLegalAgreement",
          "name": "Registration Step Completed",
          "subcategory": "checking",
          "category": "application",
          "source_name": ""
        }
      },
      {
        "config": {
          "key": "/confirm-your-address/confirmClicked",
          "name": "Address Confirmed",
          "source_name": "home_address_confirmation",
          "category": "profile_settings",
          "subcategory": "card_expiration"
        }
      },
      {
        "config": {
          "key": "/confirm-your-address/editAddressClicked",
          "name": "Edit Address Clicked",
          "source_name": "home_address_confirmation",
          "category": "profile_settings",
          "subcategory": "card_expiration"
        }
      },
      {
        "config": {
          "key": "/myvaro/personal-details/change-address/saveHomeAddressClicked",
          "name": "Home Address Saved",
          "source_name": "edit_home_address_page",
          "category": "profile_settings",
          "subcategory": "card_expiration"
        }
      },
      {
        "config": {
          "key": "/onboarding/wallet-provisioning/skipWalletProvisioning",
          "name": "Wallet Provisioning Skipped",
          "source_name": "get_digital_card",
          "category": "onboarding",
          "subcategory": "intent_based_onboarding"
        }
      },
      {
        "config": {
          "key": "/onboarding/funding/fundingMethodSkipped",
          "name": "Funding Method Skipped",
          "category": "onboarding",
          "subcategory": "intent_based_onboarding",
          "source_name": "funding_method"
        }
      },
      {
        "config": {
          "key": "/onboarding/funding/fundingMethodOptionSubmitted",
          "name": "Funding Method Option Submitted",
          "category": "onboarding",
          "subcategory": "intent_based_onboarding",
          "source_name": "funding_method"
        }
      },
      {
        "config": {
          "key": "/onboarding/intentMethodSkipped",
          "name": "Primary Goal Onboarding Survey Skipped",
          "category": "onboarding",
          "subcategory": "intent_based_onboarding",
          "source_name": "primary_goal_onboarding_survey"
        }
      },
      {
        "config": {
          "key": "/onboarding/intentMethodOptionSubmitted",
          "name": "Primary Goal Onboarding Survey Completed",
          "category": "onboarding",
          "subcategory": "intent_based_onboarding",
          "source_name": "primary_goal_onboarding_survey"
        }
      },
      {
        "config": {
          "key": "/onboarding/get-paid-early/skipEarlyPayDay",
          "name": "Direct Deposit Flow Skipped",
          "survey_option": "early_direct_deposit",
          "category": "onboarding",
          "subcategory": "intent_based_onboarding",
          "source_name": "set_up_direct_deposit"
        }
      },
      {
        "config": {
          "key": "/onboarding/get-paid-early/disclosureClicked",
          "name": "Direct Deposit Disclosure Clicked",
          "category": "onboarding",
          "subcategory": "intent_based_onboarding",
          "source_name": "set_up_direct_deposit"
        }
      },
      {
        "config": {
          "key": "/onboarding/get-paid-early/directDepositClicked",
          "name": "Direct Deposit Flow Initiated",
          "category": "onboarding",
          "subcategory": "intent_based_onboarding",
          "source_name": "set_up_direct_deposit"
        }
      },
      {
        "config": {
          "key": "/welcome/welcomeSignupClicked",
          "name": "Welcome Signup Clicked",
          "category": "application",
          "subcategory": "checking",
          "source_name": "welcome_page"
        }
      },
      {
        "config": {
          "key": "/welcome/welcomeLoginClicked",
          "name": "Welcome Login Clicked",
          "source_name": "welcome_page",
          "category": "login"
        }
      },
      {
        "config": {
          "key": "/welcome/disclosureClicked",
          "name": "Disclosures Clicked",
          "source_name": "welcome_page",
          "category": ""
        }
      },
      {
        "config": {
          "key": "/login/biometricCancelled",
          "name": "Biometric Login Method Removed",
          "category": "login",
          "subcategory": "",
          "source_name": "login_page"
        }
      },
      {
        "config": {
          "key": "/login/usernameFieldError",
          "name": "Username Field Error Encountered",
          "category": "login",
          "subcategory": "",
          "source_name": "login_page"
        }
      },
      {
        "config": {
          "key": "/login/passwordFieldError",
          "name": "Password Field Error Encountered",
          "category": "login",
          "subcategory": "",
          "source_name": "login_page"
        }
      },
      {
        "config": {
          "key": "/login/verify-email-code/resendClickedNewCode",
          "name": "Verification Code Requested",
          "category": "login",
          "source_name": "email_otp_page",
          "verification_type": "email"
        }
      },
      {
        "config": {
          "key": "/login/verify-email-code/verificationSuccessful",
          "name": "Verification Successful",
          "category": "login",
          "source_name": "email_otp_page"
        }
      },
      {
        "config": {
          "key": "/login/verify-email-code/verificationFailed",
          "name": "Verification Failed",
          "source_name": "email_otp_page",
          "category": "login"
        }
      },
      {
        "config": {
          "key": "/login/verify-email-code/verificationCodeSubmitted",
          "name": "Verification Code Submitted",
          "category": "login",
          "source_name": "email_otp_page"
        }
      },
      {
        "config": {
          "key": "/login/verify-email-code/resendClicked",
          "name": "Verification Code Requested",
          "category": "application",
          "source_name": "email_otp_page"
        }
      },
      {
        "config": {
          "key": "/move-money/tabapay/tabapay-transfer-screen/selectAccount",
          "name": "Transfer Money Select Account Clicked",
          "source_name": "transfer_money_amount",
          "category": "dcf"
        }
      },
      {
        "config": {
          "key": "/move-money/tabapay/tabapay-transfer-screen/accountSelected",
          "name": "Transfer Money Account Selected",
          "source_name": "transfer_money_amount",
          "category": "dcf"
        }
      },
      {
        "config": {
          "key": "/move-money/tabapay/tabapay-transfer-screen/addMoneyClicked",
          "name": "Transfer Money Clicked",
          "category": "dcf",
          "source_name": "debit_card_funding",
          "flow_name": "dcf",
          "subcategory": "dcf_v2_1screen",
          "vendor": "tabapay"
        }
      },
      {
        "config": {
          "key": "/move-money/tabapay/tabapay-transfer-screen/partialAuthErrorClosed",
          "name": "Partial Auth Transaction Error Closed",
          "category": "dcf",
          "subcategory": "partial_auth"
        }
      },
      {
        "config": {
          "key": "/move-money/tabapay/tabapay-transfer-success/dcfCompleted",
          "name": "Debit Card Funding Completed",
          "category": "dcf"
        }
      },
      {
        "config": {
          "key": "/bill-manager/landing/open_bill_manager",
          "name": "Button Clicked",
          "category": "bill_manager"
        }
      },
      {
        "config": {
          "key": "/bill-switch/intro/launchPinwheel",
          "name": "Bill Switch Redirected",
          "category": "bill_switch"
        }
      },
      {
        "config": {
          "key": "/bill-switch/believe/launchPinwheel",
          "name": "Bill Switch Redirected",
          "category": "bill_switch"
        }
      },
      {
        "config": {
          "key": "/bill-switch/phone-bill/launchPinwheel",
          "name": "Bill Switch Redirected",
          "category": "bill_switch"
        }
      },
      {
        "config": {
          "key": "/bill-switch/intro/bottomSheetPrimary",
          "name": "Bill Switch Bottom Sheet Redirected",
          "category": "bill_switch",
          "source_name": "home_control"
        }
      },
      {
        "config": {
          "key": "/bill-switch/believe/bottomSheetPrimary",
          "name": "Bill Switch Bottom Sheet Redirected",
          "category": "bill_switch",
          "source_name": "home_believe"
        }
      },
      {
        "config": {
          "key": "/bill-switch/phone-bill/bottomSheetPrimary",
          "name": "Bill Switch Bottom Sheet Redirected",
          "category": "bill_switch",
          "source_name": "home_sweepstakes"
        }
      },
      {
        "config": {
          "key": "/bill-switch/intro/bottomSheetSecondary",
          "name": "Bill Switch Bottom Sheet Cancelled",
          "category": "bill_switch",
          "source_name": "home_control"
        }
      },
      {
        "config": {
          "key": "/bill-switch/believe/bottomSheetSecondary",
          "name": "Bill Switch Bottom Sheet Cancelled",
          "category": "bill_switch",
          "source_name": "home_believe"
        }
      },
      {
        "config": {
          "key": "/bill-switch/phone-bill/bottomSheetSecondary",
          "name": "Bill Switch Bottom Sheet Cancelled",
          "category": "bill_switch",
          "source_name": "home_sweepstakes"
        }
      },
      {
        "config": {
          "key": "/bill-switch/intro/bottomSheetSwitch",
          "name": "Bill Switch Bottom Sheet Switch Toggled",
          "category": "bill_switch",
          "source_name": "home_control"
        }
      },
      {
        "config": {
          "key": "/bill-switch/believe/bottomSheetSwitch",
          "name": "Bill Switch Bottom Sheet Switch Toggled",
          "category": "bill_switch",
          "source_name": "home_believe"
        }
      },
      {
        "config": {
          "key": "/bill-switch/phone-bill/bottomSheetSwitch",
          "name": "Bill Switch Bottom Sheet Switch Toggled",
          "category": "bill_switch",
          "source_name": "home_sweepstakes"
        }
      },
      {
        "config": {
          "key": "/varo-advance/link-account/agreementCheckbox",
          "name": "Link Account Data Authorization Checkbox Clicked",
          "source_name": "va_agreement",
          "category": "varo_advance",
          "subcategory": "va_day_0"
        }
      },
      {
        "config": {
          "key": "/varo-advance/review/achAgreementCheckboxClicked",
          "name": "Linked Account ACH Authorization Agreement Checkbox Clicked",
          "source_name": "va_review",
          "category": "varo_advance"
        }
      },
      {
        "config": {
          "key": "/varo-advance/review/gotItClicked",
          "name": "Linked Account ACH Authorization Acknowledged",
          "source_name": "va_review",
          "category": "varo_advance"
        }
      },
      {
        "config": {
          "key": "/open-savings/open-savings-success/savingsGoToHomeClicked",
          "name": "Go To Home Clicked",
          "source_name": "savings_account_application",
          "category": "application",
          "subcategory": "savings"
        }
      },
      {
        "config": {
          "key": "/varo-advance/review/legalAgreementConfirmed",
          "name": "Account Linking Legal Agreement Confirmed",
          "source_name": "va_review",
          "category": "varo_advance",
          "subcategory": "va_day_0"
        }
      },
      {
        "config": {
          "key": "/varo-advance/review/ach-faq-clicked",
          "name": "FAQs Clicked",
          "source_name": "va_review",
          "category": "varo_advance"
        }
      },
      {
        "config": {
          "key": "/varo-advance/lcm-direct-deposit/directDepositFlowInitiated",
          "name": "Direct Deposit Flow Initiated",
          "source_name": "set_up_direct_deposit",
          "category": "direct_deposit",
          "subcategory": "varo_advance"
        }
      },
      {
        "config": {
          "key": "/varo-advance/link-account/LinkingInitiated",
          "name": "Account Linking Initiated",
          "source_name": "va_agreement",
          "category": "varo_advance",
          "subcategory": "va_day_0"
        }
      },
      {
        "config": {
          "key": "/varo-advance/link-account/eligibility/linkingAccount",
          "name": "Account Linking Initiated",
          "cta": "Link a new account",
          "category": "va_advance",
          "subcategory": "va_day_0"
        }
      },
      {
        "config": {
          "key": "/varo-advance/link-account/eligibility/directDeposit",
          "name": "Direct Deposit Flow Initiated",
          "category": "va_advance",
          "subcategory": "va_day_0"
        }
      },
      {
        "config": {
          "key": "/varo-advance/link-account/useExistingLinkedAccount",
          "name": "Use Existing Linked Account Clicked",
          "source_name": "va_agreement",
          "category": "varo_advance",
          "subcategory": "va_day_0"
        }
      },
      {
        "config": {
          "key": "/varo-advance/link-debit-card/continue",
          "name": "Link Debit Card Clicked",
          "source_name": "link_debit_card",
          "category": "link_external_debit_card"
        }
      },
      {
        "config": {
          "key": "/varo-advance/review/backup-payment-options",
          "name": "Backup Payment Methods Acknowledged",
          "category": "varo_advance",
          "subcategory": "va_day_0"
        }
      },
      {
        "config": {
          "key": "/varo-advance/link-debit-card/learn-more",
          "name": "FAQs Clicked",
          "source_name": "link_debit_card",
          "category": "link_external_debit_card"
        }
      },
      {
        "config": {
          "key": "/bill-switch/funding/secondaryAction",
          "name": "Funding Not Now Pressed",
          "category": "bill_switch"
        }
      },
      {
        "config": {
          "key": "/bill-switch/funding/fundingOptionSelected",
          "name": "Funding Option Selected",
          "category": "bill_switch"
        }
      },
      {
        "config": {
          "key": "/bill-switch/believe/funding/primaryButton",
          "name": "Believe Funding Next Selected",
          "category": "bill_switch"
        }
      },
      {
        "config": {
          "key": "/varo-advance/link-debit-card/backup-payment-options",
          "name": "Backup Payment Methods Acknowledged",
          "category": "varo_advance",
          "subcategory": "va_day_0"
        }
      },
      {
        "config": {
          "key": "/varo-advance/employment-info/varoAdvanceCardClicked",
          "name": "Varo Advance Clicked",
          "source_name": "my_varo",
          "category": "varo_advance",
          "subcategory": "va_intro"
        }
      },
      {
        "config": {
          "key": "/varo-advance/employment-info/faqsClicked",
          "name": "FAQs Clicked",
          "source_name": "employment_info",
          "category": "varo_advance",
          "subcategory": "va_application"
        }
      },
      {
        "config": {
          "key": "/varo-advance/not-qualified/directDepositSwitchInitiatedAdvance",
          "name": "Direct Deposit Instant Switch Initiated",
          "source_name": "va_home_advance",
          "category": "direct_deposit"
        }
      },
      {
        "config": {
          "key": "/varo-advance/review/getAdvanceClicked",
          "name": "VA Submitted",
          "source_name": "va_review",
          "category": "varo_advance"
        }
      },
      {
        "config": {
          "key": "/varo-advance/review/reviewClicked",
          "name": "Account Linking Agreement Review Clicked",
          "source_name": "va_review",
          "category": "varo_advance"
        }
      },
      {
        "config": {
          "key": "/varo-advance/review/getAdvanceFlowExited",
          "name": "Advance Flow Exited",
          "source_name": "va_review",
          "category": "varo_advance"
        }
      },
      {
        "config": {
          "key": "/varo-advance/link-account/intro/lightningIntro",
          "name": "VA Educational Continue Clicked",
          "source_name": "va_educational",
          "cts": "Continue",
          "category": "varo_advance",
          "subcategory": "va_day_0"
        }
      },
      {
        "config": {
          "key": "/varo-advance/link-account/cra-upgrade/cra-upgrade-account-pressed",
          "name": "CRA Account Selected",
          "source_name": "cra_account_selection",
          "category": "varo_advance"
        }
      },
      {
        "config": {
          "key": "/varo-advance/link-account/cra-upgrade/cra-upgrade-link-new-account",
          "name": "Account Linking Initiated",
          "source_name": "cra_account_selection",
          "category": "account_linking",
          "subcategory": "va_day_0"
        }
      },
      {
        "config": {
          "key": "/varo-advance/new/advanceFlowInitiated",
          "name": "va_home_advance",
          "source_name": "va_home_advance",
          "category": "varo_advance",
          "subcategory": "va_application"
        }
      },
      {
        "config": {
          "key": "/varo-advance/employment-info/monthlyIncomeTextFieldClicked",
          "name": "Monthly Income Entered",
          "source_name": "employment_info",
          "category": "varo_advance",
          "subcategory": "va_application"
        }
      },
      {
        "config": {
          "key": "/varo-advance/employment-info/vaEmploymentInfoSubmitted",
          "name": "VA Employment Info Submitted",
          "source_name": "employment_info",
          "category": "varo_advance",
          "subcategory": "va_application"
        }
      },
      {
        "config": {
          "key": "/varo-advance/employment-info/vaRegistrationStepCompleted",
          "name": "VA Registration Step Completed",
          "source_name": "employment_info",
          "category": "varo_advance",
          "subcategory": "va_application"
        }
      },
      {
        "config": {
          "key": "/accounts/varo-advance/confirm-payment/success/gotoHomeClicked",
          "name": "Go To Home Clicked",
          "source_name": "va_paid_off",
          "category": "varo_advance",
          "subcategory": "va_repayment"
        }
      },
      {
        "config": {
          "key": "/accounts/varo-advance/confirm-payment/VAConfirmPaymentErrorScreenButton",
          "name": "VA Repayment Flow Error Encountered",
          "category": "varo_advance",
          "subcategory": "va_repayment"
        }
      },
      {
        "config": {
          "key": "/varo-advance/new/manageAccountClicked",
          "name": "Manage Account Clicked",
          "source_name": "va_amount_selection",
          "category": "varo_advance"
        }
      },
      {
        "config": {
          "key": "/varo-advance/new/vaAmountSelected",
          "name": "VA Amount Selected",
          "source_name": "va_amount_selection",
          "category": "varo_advance",
          "subcategory": "va_disbursement"
        }
      },
      {
        "config": {
          "key": "/varo-advance/new/showMoreClicked",
          "name": "Show More Clicked",
          "source_name": "va_amount_selection",
          "category": "varo_advance",
          "subcategory": "va_disbursement"
        }
      },
      {
        "config": {
          "key": "/varo-advance/qualification/setupDirectDepositClicked",
          "name": "Direct Deposit Flow Initiated",
          "source_name": "va_qualification_details",
          "category": "varo_advance",
          "subcategory": "va_application"
        }
      },
      {
        "config": {
          "key": "/varo-advance/not-qualified/setupDirectDepositClicked",
          "name": "Direct Deposit Flow Initiated",
          "source_name": "va_qualification_details",
          "category": "varo_advance",
          "subcategory": "va_application"
        }
      },
      {
        "config": {
          "key": "/varo-advance/employment-info/vaEmploymentInfoExited",
          "name": "VA Employment Info Exited",
          "source_name": "employment_info",
          "category": "varo_advance",
          "subcategory": "va_application"
        }
      },
      {
        "config": {
          "key": "/varo-advance/employment-info/termsAndConditionsClicked",
          "name": "VA Terms And Conditions Agreement Checkbox Clicked",
          "source_name": "employment_info",
          "category": "varo_advance",
          "subcategory": "va_application"
        }
      },
      {
        "config": {
          "key": "/varo-advance/employment-info/employmentStatusDropDownClicked",
          "name": "Employment Status Dropdown Clicked",
          "source_name": "employment_info",
          "category": "varo_advance",
          "subcategory": "va_application"
        }
      },
      {
        "config": {
          "key": "/accounts/varo-advance/partially-qualified/faqsClicked",
          "name": "FAQs Clicked",
          "faq_name": "va_eligibility_requirements",
          "source_name": "va_reeligibility_temp_no_access",
          "category": "varo_advance",
          "subcategory": "va_application"
        }
      },
      {
        "config": {
          "key": "/varo-advance/processing/gotoHomeClicked",
          "name": "Go To Home Clicked",
          "source_name": "va_processing",
          "category": "varo_advance",
          "subcategory": "va_application"
        }
      },
      {
        "config": {
          "key": "/varo-advance/new/manageAccountClicked",
          "name": "Manage Account Clicked",
          "source_name": "va_amount_selection",
          "category": "varo_advance",
          "subcategory": ""
        }
      },
      {
        "config": {
          "key": "/varo-advance/approved/borrowNowClicked",
          "name": "Advance Flow Initiated",
          "source_name": "va_qualified",
          "category": "varo_advance",
          "subcategory": "va_application"
        }
      },
      {
        "config": {
          "key": "/varo-advance/approved/borrowLaterClicked",
          "name": "Advance Flow Skipped",
          "source_name": "va_qualified",
          "category": "varo_advance",
          "subcategory": "va_application"
        }
      },
      {
        "config": {
          "key": "/varo-advance/approved/directDeposit",
          "name": "Direct Deposit Flow Initiated",
          "source_name": "va_qualified",
          "category": "direct_deposit",
          "subcategory": "va_day_0"
        }
      },
      {
        "config": {
          "key": "/varo-advance/approved/continueWithoutDD",
          "name": "Direct Deposit Flow Skipped",
          "source_name": "va_qualified",
          "category": "direct_deposit",
          "subcategory": "va_day_0"
        }
      },
      {
        "config": {
          "key": "/varo-advance/success/transferInstantly",
          "name": "Transfer Instantly Clicked",
          "category": "transfer_money"
        }
      },
      {
        "config": {
          "key": "/varo-advance/success/gotoHomeClicked",
          "name": "Go To Home Clicked",
          "source_name": "va_executed",
          "category": "varo_advance",
          "subcategory": "va_application"
        }
      },
      {
        "config": {
          "key": "/accounts/varo-advance/manual-repayment/vaRepaymentAccountSelected!!",
          "name": "VA Repayment Account Selected",
          "source_name": "va_repayment_amount",
          "category": "varo_advance",
          "subcategory": "va_repayment"
        }
      },
      {
        "config": {
          "key": "/accounts/varo-advance/manual-repayment/vaSelectAmountStepCompleted",
          "name": "VA Select Amount Step Completed",
          "source_name": "va_repayment_amount",
          "category": "varo_advance",
          "subcategory": "va_repayment"
        }
      },
      {
        "config": {
          "key": "/varo-advance/review/submitApplication",
          "name": "Account Linking Legal Agreement Confirmed",
          "source_name": "va_review",
          "category": "varo_advance",
          "subcategory": "va_day_0"
        }
      },
      {
        "config": {
          "key": "/varo-advance/autopayment/faqsClicked",
          "name": "FAQs Clicked",
          "source_name": "va_autopayment",
          "category": "varo_advance",
          "subcategory": "va_disbursement"
        }
      },
      {
        "config": {
          "key": "/varo-advance/autopayment/calendarClicked",
          "name": "Auto Payment Date Picker Clicked",
          "source_name": "va_autopayment",
          "category": "varo_advance",
          "subcategory": "va_disbursement"
        }
      },
      {
        "config": {
          "key": "/varo-advance/autopayment/accountClicked",
          "name": "Payment Account Clicked",
          "source_name": "va_autopayment",
          "category": "varo_advance",
          "subcategory": "va_disbursement"
        }
      },
      {
        "config": {
          "key": "/varo-advance/expired-card/updateCardClicked",
          "category": "varo_advance",
          "name": "View Card Clicked",
          "source_name": "varo_advance"
        }
      },
      {
        "config": {
          "key": "/varo-advance/autopayment/vaAutoPaymentSubmitted",
          "name": "VA Auto Payment Schedule Submitted",
          "source_name": "va_autopayment",
          "category": "varo_advance",
          "subcategory": "va_disbursement"
        }
      },
      {
        "config": {
          "key": "/varo-advance/autopayment/paymentAccountSelected",
          "name": "Payment Account Selected",
          "source_name": "va_autopayment",
          "category": "varo_advance",
          "subcategory": "va_disbursement"
        }
      },
      {
        "config": {
          "key": "/varo-advance/autopayment/linkDebitCardClicked",
          "name": "Link Debit Card Clicked",
          "source_name": "va_autopayment",
          "category": "link_external_debit_card",
          "subcategory": "varo_advance"
        }
      },
      {
        "config": {
          "key": "/varo-advance/autopayment/linkExternalAccountClicked",
          "name": "Account Linking Initiated",
          "source_name": "va_autopayment",
          "category": "varo_advance",
          "subcategory": "va_disbursement"
        }
      },
      {
        "config": {
          "key": "/accounts/varo-advance/confirm-payment/confirmPaymentClicked",
          "name": "VA Repayment Confirmed",
          "source_name": "va_repayment_confirmation",
          "category": "varo_advance",
          "subcategory": "va_repayment"
        }
      },
      {
        "config": {
          "key": "/varo-advance/review/debitAgreementCheckboxClicked",
          "name": "Debit Card Payment Authorization Checkbox Clicked",
          "source_name": "va_review",
          "category": "varo_advance"
        }
      },
      {
        "config": {
          "key": "/accounts/[id]/makePaymentClicked",
          "name": "Make Payment Clicked",
          "category": "varo_advance",
          "subcategory": "va_repayment",
          "source_name": "va_account_details"
        }
      },
      {
        "config": {
          "key": "/accounts/[id]/vaTransactionViewed",
          "name": "VA Transaction Viewed",
          "category": "varo_advance",
          "subcategory": "va_repayment",
          "source_name": "va_account_details"
        }
      },
      {
        "config": {
          "key": "/accounts/advance-details/statements/yearlyAccountStatementClicked",
          "name": "Account Statement Clicked",
          "source_name": "statements_page",
          "category": "varo_advance",
          "subcategory": ""
        }
      },
      {
        "config": {
          "key": "/accounts/advance-details/statements/year/monthlyAccountStatementClicked",
          "name": "Account Statement Clicked",
          "source_name": "statements_page",
          "category": "varo_advance",
          "subcategory": ""
        }
      },
      {
        "config": {
          "key": "/accounts/advance-details/va-faq",
          "name": "FAQs Clicked",
          "source_name": "manage_account_page",
          "category": "varo_advance"
        }
      },
      {
        "config": {
          "key": "/accounts/advance-details/termsAndConditions",
          "name": "FAQs Clicked",
          "source_name": "manage_account_page",
          "category": "varo_advance"
        }
      },
      {
        "config": {
          "key": "/accounts/advance-details/statementsAndDocumentsClicked",
          "name": "Statements and Documents Clicked",
          "source_name": "manage_account_page",
          "category": "varo_advance"
        }
      },
      {
        "config": {
          "key": "/accounts/advance-details/what-is-va",
          "name": "FAQs Clicked",
          "source_name": "manage_account_page",
          "category": "varo_advance",
          "subcategory": ""
        }
      },
      {
        "config": {
          "key": "/accounts/advance-details/advanceHistoryClicked",
          "name": "Account History Accessed",
          "source_name": "manage_account_page",
          "category": "varo_advance"
        }
      },
      {
        "config": {
          "key": "/accounts/advance-details/history/vaTransactionClicked",
          "name": "VA Transaction Viewed",
          "source_name": "va_transaction_history",
          "category": "varo_advance"
        }
      },
      {
        "config": {
          "key": "/accounts/advance-details/statements/docs",
          "name": "Statements and Documents",
          "source_name": "manage_account_page",
          "category": "varo_advance"
        }
      },
      {
        "config": {
          "key": "/accounts/AccountDetails",
          "name": "Statements and Documents",
          "category": "varo_advance"
        }
      },
      {
        "config": {
          "key": "/challenge/magic-link/[tokenRef]/signedInWithMagicLink",
          "name": "Signed In",
          "category": "login",
          "subcategory": "magic_link",
          "source_name": "magic_link_authentication"
        }
      },
      {
        "config": {
          "key": "/varo-advance/autopayment-authorization/autopayAuthorizationCheckboxClicked",
          "name": "VA Autopay Authorization Acknowledged",
          "subcategory": "va_disbursement",
          "source_name": "va_autopayment",
          "category": "varo_advance"
        }
      },
      {
        "config": {
          "key": "/onboardingChecklistClicked",
          "name": "Onboarding Checklist Clicked",
          "source_name": "home_page",
          "category": "onboarding_checklist"
        }
      },
      {
        "config": {
          "key": "/get-varo-app/storeClicked",
          "name": "Store Clicked",
          "source_name": "home_page",
          "category": "onboarding_checklist"
        }
      },
      {
        "config": {
          "key": "/spend-benefits/nearbyOffersClicked",
          "name": "Nearby Offers Clicked",
          "category": "onboarding",
          "subcategory": "onboarding_checklist",
          "source_name": "onboarding_cashback_information"
        }
      },
      {
        "config": {
          "key": "/spend-benefits/viewCardClicked",
          "name": "View Card Clicked",
          "category": "onboarding",
          "subcategory": "onboarding_checklist",
          "source_name": "onboarding_cashback_information"
        }
      },
      {
        "config": {
          "key": "/spend-benefits/saveYourChangeClicked",
          "name": "Save Your Change Clicked",
          "category": "onboarding",
          "subcategory": "onboarding_checklist",
          "source_name": "onboarding_cashback_information"
        }
      },
      {
        "config": {
          "key": "/spend-benefits/onboardingDisclosuresAccessed",
          "name": "Onboarding Disclosures Accessed",
          "category": "onboarding",
          "subcategory": "onboarding_checklist",
          "source_name": "onboarding_cashback_information"
        }
      },
      {
        "config": {
          "key": "/onboardingDisclosuresAccessed",
          "name": "Onboarding Disclosures Accessed",
          "category": "onboarding",
          "subcategory": "onboarding_checklist",
          "source_name": "onboarding_checklist_complete_notification"
        }
      },
      {
        "config": {
          "key": "/onboardingChecklistComplete",
          "name": "Onboarding Checklist Complete",
          "category": "onboarding",
          "subcategory": "onboarding_checklist",
          "source_name": "onboarding_checklist_complete_notification"
        }
      },
      {
        "config": {
          "key": "/directDepositFlowInitiated",
          "name": "Direct Deposit Flow Initiated",
          "category": "direct_deposit",
          "source_name": "onboarding_checklist"
        }
      },
      {
        "config": {
          "key": "/onboardingDisclosuresRead",
          "name": "Onboarding Disclosures Read",
          "category": "onboarding",
          "subcategory": "onboarding_checklist"
        }
      },
      {
        "config": {
          "key": "/onboarding/deposit-cash/disclosuresClicked",
          "name": "Disclosures Clicked",
          "category": "onboarding",
          "source_name": "deposit_cash_flow"
        }
      },
      {
        "config": {
          "key": "/onboarding/deposit-cash/viewLocationsClicked",
          "name": "View Locations Clicked",
          "category": "onboarding",
          "source_name": "deposit_cash_flow"
        }
      },
      {
        "config": {
          "key": "/myvaro/personal-details/change-address/editAddressClicked",
          "name": "Edit Address Clicked",
          "category": "profile_settings",
          "source_name": "home_address_confirmation"
        }
      },
      {
        "config": {
          "key": "/myvaro/personal-details/change-address/acceptAddressClicked",
          "name": "Accept Address Clicked",
          "category": "profile_settings",
          "source_name": "home_address_confirmation"
        }
      },
      {
        "config": {
          "key": "/myvaro/personal-details/change-mailing-address/editAddressClicked",
          "name": "Edit Address Clicked",
          "category": "profile_settings",
          "source_name": "mailing_address_confirmation"
        }
      },
      {
        "config": {
          "key": "/myvaro/personal-details/change-mailing-address/acceptAddressClicked",
          "name": "Accept Address Clicked",
          "category": "profile_settings",
          "source_name": "mailing_address_confirmation"
        }
      },
      {
        "config": {
          "key": "/move-money/apple-pay/noDebitCardsError",
          "name": "No Debit Cards In Apple Wallet For Apple Pay Error",
          "category": "apple_pay"
        }
      },
      {
        "config": {
          "key": "/move-money/apple-pay/fundingCompleted",
          "name": "Apple Pay Funding Completed",
          "category": "apple_pay"
        }
      },
      {
        "config": {
          "key": "/move-money/apple-pay/limitsInfoChecked",
          "name": "Apple Pay Limits Info Checked",
          "category": "apple_pay"
        }
      },
      {
        "config": {
          "key": "/move-money/apple-pay/unavailableToUser",
          "name": "Apple Pay Is Unavailable To User",
          "category": "apple_pay"
        }
      },
      {
        "config": {
          "key": "/move-money/apple-pay/debitCardErrorEncountered",
          "name": "Debit Card Error Encountered",
          "category": "link_external_debit_card",
          "subcategory": "add_card",
          "flow_name": "apple_pay"
        }
      },
      {
        "config": {
          "key": "/move-money/zelle/continue_to_zelle_clicked",
          "name": "Zelle Step Completed",
          "source_name": "move_money",
          "category": "zelle"
        }
      },
      {
        "config": {
          "key": "/move-money/zelle/zelle_ineligible_manage_direct_deposit",
          "name": "Direct Deposit Flow Initiated",
          "source_name": "zelle_not_eligible",
          "category": "direct_deposit"
        }
      },
      {
        "config": {
          "key": "/move-money/zelle/zelle_personalized_ineligible_manage_direct_deposit",
          "name": "Pressable Clicked",
          "source_name": "zelle_personalized_ineligible_manage_direct_deposit",
          "category": "zelle"
        }
      },
      {
        "config": {
          "key": "/move-money/zelle/zelle_ineligible_got_it",
          "name": "Pressable Clicked",
          "source_name": "zelle_ineligible_got_it",
          "category": "zelle"
        }
      },
      {
        "config": {
          "key": "/move-money/zelle/zelle_clicked",
          "name": "Zelle Initiated",
          "category": "zelle",
          "source_name": "move_money"
        }
      },
      {
        "config": {
          "key": "/rewards/myCashbackClicked",
          "name": "My Cashback Clicked",
          "category": "rewards",
          "source_name": "rewards_page"
        }
      },
      {
        "config": {
          "key": "/move-money/zelle/mobile_app_download_clicked",
          "name": "Mobile App Download Clicked",
          "source_name": "zelle",
          "category": "zelle"
        }
      },
      {
        "config": {
          "key": "/rewards/categories/[category]/offerActivationClicked",
          "name": "Offer Activate Clicked",
          "category": "rewards",
          "source_name": "offer_type_details_page"
        }
      },
      {
        "config": {
          "key": "/rewards/myOffersClicked",
          "name": "My Offers Clicked",
          "category": "rewards",
          "source_name": "rewards_page"
        }
      },
      {
        "config": {
          "key": "/rewards/my-offers/activatedOfferClicked",
          "name": "Activated Offer Clicked",
          "category": "rewards",
          "source_name": "my_offers_page"
        }
      },
      {
        "config": {
          "key": "/rewards/[id]/offerGetDirectionClicked",
          "name": "Get Directions Clicked",
          "category": "rewards"
        }
      },
      {
        "config": {
          "key": "/rewards/upside-offers/[merchantId]/activatedOfferClicked",
          "name": "Activate Offer Clicked",
          "category": "rewards",
          "source_name": "cashback_details_page"
        }
      },
      {
        "config": {
          "key": "/rewards/activateOfferClicked",
          "name": "Activate Offer Clicked",
          "category": "rewards",
          "source_name": "rewards_page"
        }
      },
      {
        "config": {
          "key": "/varo-advance/link-account/borrow-more-pay-less/borrowMorePayLessContinueWithDD",
          "name": "Direct Deposit Flow Initiated",
          "category": "direct_deposit",
          "subcategory": "va_day_0",
          "source_name": "dd_borrow_more"
        }
      },
      {
        "config": {
          "key": "/varo-advance/link-account/borrow-more-pay-less/borrowMorePayLessContinueWithoutDD",
          "name": "Direct Deposit Flow Skipped",
          "category": "direct_deposit",
          "subcategory": "va_day_0",
          "source_name": "dd_borrow_more"
        }
      },
      {
        "config": {
          "key": "/varo-advance/link-account/intro/ddBorrowMoreWithDD",
          "name": "Direct Deposit Flow Initiated",
          "category": "direct_deposit",
          "subcategory": "va_day_0",
          "source_name": "dd_borrow_more"
        }
      },
      {
        "config": {
          "key": "/varo-advance/link-account/intro/ddBorrowMoreWithoutDD",
          "name": "Direct Deposit Flow Skipped",
          "category": "direct_deposit",
          "subcategory": "va_day_0",
          "source_name": "dd_borrow_more"
        }
      },
      {
        "config": {
          "key": "/varo-advance/dd-prompt/ddBorrowMoreWithDD",
          "name": "Direct Deposit Flow Initiated",
          "category": "direct_deposit",
          "subcategory": "va_day_0",
          "source_name": "dd_borrow_more_phase2"
        }
      },
      {
        "config": {
          "key": "/varo-advance/dd-prompt/ddBorrowMoreWithoutDD",
          "name": "Direct Deposit Flow Skipped",
          "category": "direct_deposit",
          "subcategory": "va_day_0",
          "source_name": "dd_borrow_more_phase2"
        }
      },
      {
        "config": {
          "key": "/myvaro/card/[cardId]/cardCredentialViewCardInitiated",
          "name": "View Card Initiated",
          "category": "View Sensitive Card Info",
          "source_name": "View Sensitive Card Info"
        }
      },
      {
        "config": {
          "key": "/myvaro/card/[cardId]/cardCredentialViewCardNumberStarted",
          "name": "View Card Number Started",
          "category": "View Card Started",
          "source_name": "View Card (Not Funding) Started"
        }
      },
      {
        "config": {
          "key": "/myvaro/card/[cardId]/cardCredentialCardNumberShown",
          "name": "Card Number Shown",
          "category": "View Card Completed",
          "source_name": "View Card (Not Funding) completed"
        }
      },
      {
        "config": {
          "key": "cardCredentialOtpStarted",
          "name": "OTP Started",
          "category": "OTP Started",
          "source_name": "OTP Started"
        }
      },
      {
        "config": {
          "key": "cardCredentialOtpEntered",
          "name": "OTP Entered",
          "category": "OTP Entered",
          "source_name": "OTP Entered"
        }
      },
      {
        "config": {
          "key": "cardCredentialOtpExpired",
          "name": "OTP Expired",
          "category": "OTP Expired",
          "source_name": "OTP Expired"
        }
      },
      {
        "config": {
          "key": "cardCredentialOtpFailed",
          "name": "OTP Failed",
          "category": "OTP Failed",
          "source_name": "OTP Failed"
        }
      },
      {
        "config": {
          "key": "cardCredentialOtpPassed",
          "name": "OTP Passed",
          "category": "OTP Passed",
          "source_name": "OTP Passed"
        }
      },
      {
        "config": {
          "key": "/pay-over-time/account-settings/statements-documents",
          "name": "Statements and Documents Clicked",
          "category": "pay_over_time",
          "source_name": "pay_over_time_account_settings"
        }
      },
      {
        "config": {
          "key": "/pay-over-time/account-settings/payOverTimeFaqsClicked",
          "name": "FAQs Clicked",
          "category": "pay_over_time",
          "source_name": "pay_over_time_account_settings"
        }
      },
      {
        "config": {
          "key": "/pay-over-time/account-settings/payOverTimeTermsAndConditionsClicked",
          "name": "Pay Over Time Terms And Conditions Clicked",
          "category": "pay_over_time",
          "source_name": "pay_over_time_account_settings"
        }
      },
      {
        "config": {
          "key": "/pay-over-time/apply-now/applyNowClicked",
          "name": "Pay Over Time Application Initiated",
          "category": "pay_over_time",
          "source_name": "pay_over_time_intro"
        }
      },
      {
        "config": {
          "key": "/pay-over-time/landing-page/applyNowClicked",
          "name": "Pay Over Time Application Initiated",
          "category": "pay_over_time",
          "source_name": "pay_over_time_landing_page"
        }
      },
      {
        "config": {
          "key": "/pay-over-time/payment-plan/paymentPlanTermsCheckbox",
          "name": "Pay Over Time Terms And Conditions Agreement Checkbox Clicked",
          "category": "pay_over_time",
          "source_name": "pay_over_time_payment_plan_review"
        }
      },
      {
        "config": {
          "key": "/pay-over-time/payment-plan/paymentPlanDisclosureClicked",
          "name": "Pay Over Time Disclosure Clicked",
          "category": "pay_over_time",
          "source_name": "pay_over_time_payment_plan_review"
        }
      },
      {
        "config": {
          "key": "/pay-over-time/payment-plan/paymentPlanWhatIsAutopayClicked",
          "name": "Pay Over Time What Is Autopay Clicked",
          "category": "pay_over_time",
          "source_name": "pay_over_time_payment_plan_review"
        }
      },
      {
        "config": {
          "key": "/pay-over-time/payment-plan/paymentPlanWhatIsAutopayBottomSheetCloseClicked",
          "name": "Pay Over Time What Is Autopay Bottom Sheet Close Clicked",
          "category": "pay_over_time",
          "source_name": "pay_over_time_payment_plan_review"
        }
      },
      {
        "config": {
          "key": "/pay-over-time/payment-plan/paymentPlanAcceptClicked",
          "name": "Pay Over Time Application Submitted",
          "category": "pay_over_time",
          "source_name": "pay_over_time_payment_plan_review"
        }
      },
      {
        "config": {
          "key": "/pay-over-time/payment-plan/paymentPlanCancelClicked",
          "name": "Pay Over Time Application Cancel Clicked",
          "category": "pay_over_time",
          "source_name": "pay_over_time_payment_plan_review"
        }
      },
      {
        "config": {
          "key": "/pay-over-time/loan-details/makePaymentClicked",
          "name": "Make Payment Clicked",
          "category": "pay_over_time",
          "source_name": "pay_over_time_loan_details"
        }
      },
      {
        "config": {
          "key": "/accounts/transaction-details/payOverTimeListItemTapped",
          "name": "Pay Over Time Clicked",
          "category": "pay_over_time",
          "source_name": "transaction_detail"
        }
      },
      {
        "config": {
          "key": "/accounts/transaction-details/payOverTimeViewPaymentPlanTapped",
          "name": "Pay Over Time View Payment Plan Clicked",
          "category": "pay_over_time",
          "source_name": "pay_over_time_bottom_sheet"
        }
      },
      {
        "config": {
          "key": "/accounts/transaction-details/payOverTimeApplyNowBottomSheetCloseTapped",
          "name": "Pay Over Time Apply Now Bottom Sheet Close Clicked",
          "category": "pay_over_time",
          "source_name": "pay_over_time_bottom_sheet"
        }
      },
      {
        "config": {
          "key": "/payOverTimeAccountCardClicked",
          "name": "Pay Over Time Clicked",
          "category": "pay_over_time",
          "source_name": "home_page"
        }
      },
      {
        "config": {
          "key": "/google-pay/submit",
          "name": "Add Money",
          "category": "card",
          "subcategory": "wallet_provisioning"
        }
      },
      {
        "config": {
          "key": "/google-pay/limits",
          "name": "View Limits",
          "category": "card",
          "subcategory": "wallet_provisioning"
        }
      },
      {
        "config": {
          "key": "/bill-manager/billManagerErrorRetryClicked",
          "name": "Button Clicked",
          "category": "bill_manager"
        }
      },
      {
        "config": {
          "key": "/plaid/marketing-consent/plaidConsentAgreeAndContinue",
          "name": "Plaid Consent Agree and Continue Clicked",
          "source_name": "plaid_marketing_consent",
          "category": "external_account",
          "subcategory": "plaid_consent"
        }
      },
      {
        "config": {
          "key": "/plaid/marketing-consent/plaidConsentBackArrow",
          "name": "Plaid Consent Back Arrow Clicked",
          "source_name": "plaid_marketing_consent",
          "category": "external_account",
          "subcategory": "plaid_consent"
        }
      },
      {
        "config": {
          "key": "/myvaro/referrals/termsClicked",
          "name": "Button Pressed",
          "category": "referral",
          "source_name": "referral_limit_met",
          "button_name": "see_full_terms"
        }
      },
      {
        "config": {
          "key": "/referrals/termsClicked",
          "name": "Button Pressed",
          "category": "referral",
          "source_name": "referral_limit_met",
          "button_name": "see_full_terms"
        }
      }
    ],
    "networkConfigs": [
      {
        "config": {
          "key": "//deposit-check",
          "name": "Deposit Check",
          "source_name": "deposit_check",
          "category": "deposit",
          "subcategory": "check"
        }
      }
    ]
  }
}
